// couple polyfill for IE for short term

// This version tries to optimize by only checking for "in" when looking for undefined and
// skipping the definitely fruitless NaN search. Other parts are merely cosmetic conciseness.
// Whether it is actually faster remains to be seen.
if (!Array.prototype.indexOf)
  Array.prototype.indexOf = (function (Object, max, min) {
    'use strict'
    return function indexOf(member, fromIndex) {
      if (this === null || this === undefined) throw TypeError('Array.prototype.indexOf called on null or undefined')

      var that = Object(this),
        Len = that.length >>> 0,
        i = min(fromIndex | 0, Len)
      if (i < 0) i = max(0, Len + i)
      else if (i >= Len) return -1

      if (member === void 0) {
        // undefined
        for (; i !== Len; ++i) if (that[i] === void 0 && i in that) return i
      } else if (member !== member) {
        // NaN
        return -1 // Since NaN !== NaN, it will never be found. Fast-path it.
      } // all else
      else for (; i !== Len; ++i) if (that[i] === member) return i

      return -1 // if the value was not found, then return -1
    }
  })(Object, Math.max, Math.min)

if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    'use strict'
    if (typeof start !== 'number') {
      start = 0
    }

    if (start + search.length > this.length) {
      return false
    } else {
      return this.indexOf(search, start) !== -1
    }
  }
}

if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    enumerable: false,
    value: function (obj) {
      var newArr = this.filter(function (el) {
        return el == obj
      })
      return newArr.length > 0
    },
  })
}

// IE 9 and up CustomEvent Polyfill

;(function () {
  if (typeof window.CustomEvent === 'function') return false

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined,
    }
    var evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }

  CustomEvent.prototype = window.Event.prototype

  window.CustomEvent = CustomEvent
})()

// Array.from Polyfill for Trusted Form
// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString
    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]'
    }
    var toInteger = function (value) {
      var number = Number(value)
      if (isNaN(number)) {
        return 0
      }
      if (number === 0 || !isFinite(number)) {
        return number
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number))
    }
    var maxSafeInteger = Math.pow(2, 53) - 1
    var toLength = function (value) {
      var len = toInteger(value)
      return Math.min(Math.max(len, 0), maxSafeInteger)
    }

    // The length property of the from method is 1.
    return function from(arrayLike /*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike)

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined')
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined
      var T
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function')
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2]
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length)

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len)

      // 16. Let k be 0.
      var k = 0
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue
      while (k < len) {
        kValue = items[k]
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k)
        } else {
          A[k] = kValue
        }
        k += 1
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len
      // 20. Return A.
      return A
    }
  })()
}

/*! (c) Andrea Giammarchi - ISC URLSearchParams Polyfill*/
//prettier-ignore
;(function () {
//eslint-disable-next-line
var self=this||{};try{!function(t,n){if(new t("q=%2B").get("q")!==n||new t({q:n}).get("q")!==n||new t([["q",n]]).get("q")!==n||"q=%0A"!==new t("q=\n").toString()||"q=+%26"!==new t({q:" &"}).toString())throw t;self.URLSearchParams=t}(URLSearchParams,"+")}catch(t){!function(t,a,o){"use strict";var u=t.create,h=t.defineProperty,n=/[!'\(\)~]|%20|%00/g,e=/\+/g,r={"!":"%21","'":"%27","(":"%28",")":"%29","~":"%7E","%20":"+","%00":"\0"},i={append:function(t,n){l(this._ungap,t,n)},delete:function(t){delete this._ungap[t]},get:function(t){return this.has(t)?this._ungap[t][0]:null},getAll:function(t){return this.has(t)?this._ungap[t].slice(0):[]},has:function(t){return t in this._ungap},set:function(t,n){this._ungap[t]=[a(n)]},forEach:function(n,e){var r=this;for(var i in r._ungap)r._ungap[i].forEach(t,i);function t(t){n.call(e,t,a(i),r)}},toJSON:function(){return{}},toString:function(){var t=[];for(var n in this._ungap)for(var e=g(n),r=0,i=this._ungap[n];r<i.length;r++)t.push(e+"="+g(i[r]));return t.join("&")}};for(var s in i)h(c.prototype,s,{configurable:!0,writable:!0,value:i[s]});function c(t){var n=u(null);switch(h(this,"_ungap",{value:n}),!0){case!t:break;case"string"==typeof t:"?"===t.charAt(0)&&(t=t.slice(1));for(var e=t.split("&"),r=0,i=e.length;r<i;r++){var a=(s=e[r]).indexOf("=");-1<a?l(n,p(s.slice(0,a)),p(s.slice(a+1))):s.length&&l(n,p(s),"")}break;case o(t):for(r=0,i=t.length;r<i;r++){var s;l(n,(s=t[r])[0],s[1])}break;case"forEach"in t:t.forEach(f,n);break;default:for(var c in t)l(n,c,t[c])}}function f(t,n){l(this,n,t)}function l(t,n,e){var r=o(e)?e.join(","):e;n in t?t[n].push(r):t[n]=[r]}function p(t){return decodeURIComponent(t.replace(e," "))}function g(t){return encodeURIComponent(t).replace(n,v)}function v(t){return r[t]}self.URLSearchParams=c}(Object,String,Array.isArray)}!function(l){var r=!1;try{r=!!Symbol.iterator}catch(t){}function t(t,n){var e=[];return t.forEach(n,e),r?e[Symbol.iterator]():{next:function(){var t=e.shift();return{done:void 0===t,value:t}}}}"forEach"in l||(l.forEach=function(e,r){var i=this,t=Object.create(null);this.toString().replace(/=[\s\S]*?(?:&|$)/g,"=").split("=").forEach(function(n){!n.length||n in t||(t[n]=i.getAll(n)).forEach(function(t){e.call(r,t,n,i)})})}),"keys"in l||(l.keys=function(){return t(this,function(t,n){this.push(n)})}),"values"in l||(l.values=function(){return t(this,function(t,n){this.push(t)})}),"entries"in l||(l.entries=function(){return t(this,function(t,n){this.push([n,t])})}),!r||Symbol.iterator in l||(l[Symbol.iterator]=l.entries),"sort"in l||(l.sort=function(){for(var t,n,e,r=this.entries(),i=r.next(),a=i.done,s=[],c=Object.create(null);!a;)n=(e=i.value)[0],s.push(n),n in c||(c[n]=[]),c[n].push(e[1]),a=(i=r.next()).done;for(s.sort(),t=0;t<s.length;t++)this.delete(s[t]);for(t=0;t<s.length;t++)n=s[t],this.append(n,c[n].shift())}),function(c){var o=c.defineProperty,u=c.getOwnPropertyDescriptor,h=function(t){var n=t.append;t.append=l.append,URLSearchParams.call(t,t._usp.search.slice(1)),t.append=n},f=function(t,n){if(!(t instanceof n))throw new TypeError("'searchParams' accessed on an object that does not implement interface "+n.name)},t=function(n){var e,r,t=n.prototype,i=u(t,"searchParams"),a=u(t,"href"),s=u(t,"search");!i&&s&&s.set&&(r=function(e){function r(t,n){l.append.call(this,t,n),t=this.toString(),e.set.call(this._usp,t?"?"+t:"")}function i(t){l.delete.call(this,t),t=this.toString(),e.set.call(this._usp,t?"?"+t:"")}function a(t,n){l.set.call(this,t,n),t=this.toString(),e.set.call(this._usp,t?"?"+t:"")}return function(t,n){return t.append=r,t.delete=i,t.set=a,o(t,"_usp",{configurable:!0,writable:!0,value:n})}}(s),e=function(t,n){return o(t,"_searchParams",{configurable:!0,writable:!0,value:r(n,t)}),n},c.defineProperties(t,{href:{get:function(){return a.get.call(this)},set:function(t){var n=this._searchParams;a.set.call(this,t),n&&h(n)}},search:{get:function(){return s.get.call(this)},set:function(t){var n=this._searchParams;s.set.call(this,t),n&&h(n)}},searchParams:{get:function(){return f(this,n),this._searchParams||e(this,new URLSearchParams(this.search.slice(1)))},set:function(t){f(this,n),e(this,t)}}}))};try{t(HTMLAnchorElement),/^function|object$/.test(typeof URL)&&URL.prototype&&t(URL)}catch(t){}}(Object)}(self.URLSearchParams.prototype,Object);
})()

// polyfill for IE11 and google address feature
Number.isInteger =
  Number.isInteger ||
  function (value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value
  }

window.localData = {}
/**
 * @param  {string} type
 */
function storageAvailable(type) {
  try {
    const storage = window[type],
      x = '__storage_test__'
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return false
  }
}

/**
 * @param  {string} type
 * @param  {string} itemType
 * @param  {string} key
 * @param  {object, string, array} value
 */
const storage = (type, itemType, key, value) => {
  // variable to be returned
  let getValue = ''

  // sets each storage function call to "global" memory
  try {
    if (itemType === 'get') {
      getValue = localData[key]
    } else if (itemType === 'set') {
      localData[key] = value
    } else if (itemType === 'remove') {
      delete localData[key]
    }
  } catch (error) {
    console.log(error)
  }

  // checks if client storage is available and stores data there as well
  if (storageAvailable(`${type}Storage`)) {
    if (type === 'session') {
      if (itemType === 'get') {
        getValue = sessionStorage.getItem(key, value)
      } else if (itemType === 'set') {
        sessionStorage.setItem(key, value)
      } else if (itemType === 'remove') {
        sessionStorage.removeItem(key, value)
      } else if (itemType === 'clear') {
        sessionStorage.clear()
      }
    } else if (type === 'local') {
      if (itemType === 'get') {
        getValue = localStorage.getItem(key, value)
        if (getValue === null) {
          getValue = localData[key]
        }
      } else if (itemType === 'set') {
        localStorage.setItem(key, value)
      } else if (itemType === 'remove') {
        localStorage.removeItem(key, value)
      } else if (itemType === 'clear') {
        localStorage.clear()
      }
    }
  }

  // checks to see if getValue is null or undefined, if so then return the "global" value from memory
  if (getValue === null || getValue === undefined) {
    return localData[key]
  }
  return getValue
}

/* this module includes various utility functions that I use to make life easier on myself
 * this module has to be loaded first in the compiling because many other functions rely on these
 */

// get a query string parameter by name
function getParameterByName(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url),
    res
  if (!results) return null
  if (!results[2]) return ''
  try {
    res = decodeURIComponent(results[2].replace(/\+/g, ' '))
  } catch (error) {
    res = ''
  }
  return res
}

// gets all the url params and creates an object of the properties and values
var getParams = function (url) {
  var params = {}
  var parser = document.createElement('a')
  parser.href = url
  var query = parser.search.substring(1)
  var vars = query.split('&')
  var pair
  var i
  try {
    for (i = 0; i < vars.length; i++) {
      pair = vars[i].split('=')
      params[pair[0]] = decodeURIComponent(pair[1])
    }
  } catch (error) {
    for (i = 0; i < vars.length; i++) {
      pair = vars[i].split('=')
      params[pair[0]] = pair[1]
    }
  }

  return params
}

// convert query string onto an array then a json object to put onto session storage
function queryStringToJSON(queryString) {
  if (queryString.indexOf('?') > -1) {
    queryString = queryString.split('?')[1]
  }
  var pairs = queryString.split('&')
  var result = {}
  pairs.forEach(function (pair) {
    pair = pair.split('=')
    result[pair[0]] = decodeURIComponent(pair[1] || '')
  })
  return result
}

function requestId() {
  let requestId = getParameterByName('req_id')

  // if not in url set update variable from window
  if (!requestId) {
    requestId = window.ckm_request_id
  }

  // if not in url or window var gets erased grab it from storage
  if (!requestId) {
    requestId = storage('session', 'get', 'request_id')
  }

  return requestId
}

function removeCommaFromArray(arr) {
  var newArr = []
  for (var i = 0; i < arr.length; i++) {
    newArr.push(arr[i].replace(/,/g, ''))
  }
  return newArr
}

// sets a cookie
function setCookie(cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

//helper function for grabbing cookies by name
function getCookie(name) {
  var nameEQ = name + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

//delete item from serialized data
function serializeDeleteItem(strSerialize, strParamName) {
  var arrSerialize = strSerialize.split('&')
  var i = arrSerialize.length

  while (i--) {
    if (arrSerialize[i].indexOf(strParamName + '=') == 0) {
      arrSerialize.splice(i, 1)
      break // Found the one and only, we're outta here.
    }
  }
  return arrSerialize.join('&')
}

//this is a utility function for changing the anchor hash
// Should be executed BEFORE any hash change has occurred.
;(function (namespace) {
  // Closure to protect local variable "var hash"
  if ('replaceState' in history) {
    // Yay, supported!

    namespace.replaceHash = function (newhash) {
      if (('' + newhash).charAt(0) !== '#') {
        newhash = '#' + newhash
      }
      history.replaceState('', '', newhash)
    }
  } else {
    var hash = location.hash
    namespace.replaceHash = function (newhash) {
      if (location.hash !== hash) {
        history.back()
      }
      location.hash = newhash
    }
  }
})(window)

//get the current value of a question
const questionCurrentValue = function (questionName) {
  var dataQCV = queryStringToJSON($('form:visible').serialize())
  return dataQCV[questionName]
}

//redirect the user based on values
// questionName = string, valuesToRedirect = array of strings, redirect url = string
function redirectBasedOnValues(questionName, valuesToRedirect, redirectUrl, userOverride) {
  function redirect() {
    $('#loading-gif').show()
    setTimeout(function () {
      window.location.href = redirectUrl
    }, 2000)
  }

  if (userOverride == true) {
    redirect()
  } else {
    var valueNow = questionCurrentValue(questionName)
    if (valuesToRedirect.includes(valueNow)) {
      redirect()
    }
  }
  return
}

//first character off string to uppercase
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * this function is best to be invoked at the top of the page through and in line script tag to make it redirect as fast as possible
 * it detects if user agent is a mobile or tablet device, and returns a boolean
 */

const mobileDetection = function () {
  function mobileCheck() {
    var check = false
    ;(function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        // eslint-disable-next-line no-useless-escape
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true
    })(navigator.userAgent || navigator.vendor || window.opera)
    return check
  }
  isMobile = mobileCheck()
  if (isMobile == false && $(window).width() < 1001) {
    isMobile = true
  }
  return isMobile
}

//parser to replace an occurence of string better than .replace(), such if you need to use an escape character in it

String.prototype.replaceAll = function (search, replacement) {
  var target = this
  return target.split(search).join(replacement)
}

//translate empty values to the defaults for sites with checkbox
const translateFormValues = function (current_form) {
  var formValues = queryStringToJSON(current_form.form.serialize())
  if (current_form.fullLoanType() == 'refinance') {
    return formValues
  } else {
    if (!formValues.own_rent) {
      formValues.own_rent = 'Rent'
    }
    if (!formValues.usaa_member) {
      formValues.usaa_member = 'No'
    }
    return formValues
  }
}
// change a questions ordinal position in the form, can only re order questions that live inside the form
const reOrderQuestion = function (questionName, newOrder) {
  var refiSchema = [],
    purchaseSchema = [],
    purchaseCount = 1,
    refiCount = 1,
    refiQuestion = $('.msform-refinance')
      .find('input[name="' + questionName + '"]')
      .parents('fieldset'),
    purchaseQuestion = $('.msform-purchase')
      .find('input[name="' + questionName + '"]')
      .parents('fieldset')

  if (refiQuestion.length > 0) {
    if (refiQuestion.prop('id').indexOf('final') != -1) {
      return
    }
  }
  if (purchaseQuestion.length > 0) {
    if (purchaseQuestion.prop('id').indexOf('final') != -1) {
      return
    }
  }

  if (newOrder == 1) {
    $('.msform-refinance').find('.first-frame').removeClass('first-frame first-frame-refinance')
    $('.msform-purchase').find('.first-frame').removeClass('first-frame first-frame-purchase')

    refiQuestion.addClass('first-frame first-frame-refinance')
    purchaseQuestion.addClass('first-frame first-frame-purchase')
  }

  refiQuestion.siblings('fieldset').each(function () {
    refiSchema.push({
      id: $(this).prop('id'),
      position: refiCount,
    })
    refiCount++
  })

  purchaseQuestion.siblings('fieldset').each(function () {
    purchaseSchema.push({
      id: $(this).prop('id'),
      position: purchaseCount,
    })
    purchaseCount++
  })

  if (newOrder == 'last') {
    refiQuestion.insertBefore('#final-frame-refinance')
    purchaseQuestion.insertBefore('#final-frame-purchase')
  } else {
    for (var question in refiSchema) {
      if (refiSchema[question].position == newOrder - 1) {
        refiQuestion.insertAfter($('#' + refiSchema[question].id))
        return
      } else if (refiSchema[question].position == newOrder) {
        refiQuestion.insertBefore($('#' + refiSchema[question].id))
        return
      }
    }

    for (var pQuestion in purchaseSchema) {
      if (purchaseSchema[pQuestion].position == newOrder - 1) {
        purchaseQuestion.insertAfter($('#' + purchaseSchema[pQuestion].id))
        return
      } else if (purchaseSchema[pQuestion].position == newOrder) {
        purchaseQuestion.insertBefore($('#' + purchaseSchema[pQuestion].id))
        return
      }
    }
  }
}
//attach the dropdowns
const dropDownLTV = function (arg) {
  if ($('select[name="est_property_value"]').length != 0 || $('select[name="PropertyValue"]').length != 0) {
    // prettier-ignore
    var values = [ '80,000', '85,000', '90,000', '95,000', '100,000', '105,000', '110,000', '115,000', '120,000', '125,000', '130,000', '135,000', '140,000', '145,000', '150,000', '155,000', '160,000', '165,000', '170,000', '175,000', '180,000', '185,000', '190,000', '195,000', '200,000', '210,000', '220,000', '230,000', '240,000', '250,000', '260,000', '270,000', '280,000', '290,000', '300,000', '310,000', '320,000', '330,000', '340,000', '350,000', '360,000', '370,000', '380,000', '390,000', '400,000', '420,000', '440,000', '460,000', '480,000', '500,000', '520,000', '540,000', '560,000', '580,000', '600,000', '620,000', '640,000', '660,000', '680,000', '700,000', '720,000', '740,000', '760,000', '780,000', '800,000', '820,000', '840,000', '860,000', '880,000', '900,000', '920,000', '940,000', '960,000', '980,000', '1,000,000', '1,500,000'], anchor = $('select[name="est_property_value"], select[name="PropertyValue"]').val()

    $('select[name="mortgage_amount"], select[name="MortgageAmount"]').html('')

    for (var i = 0; i < values.length; i++) {
      valueToInt = values[i].replace(',', '')
      if (valueToInt < parseInt(anchor)) {
        curValue = `<option value=${values[i + 1].replace(/,/g, '')}>$${values[i]}-$${values[i + 1]}</option>`
        $('select[name="mortgage_amount"], select[name="MortgageAmount"]').append(curValue)
      }
    }

    if (anchor == '2000000') {
      // do nothing
    } else if (
      $('select[name="mortgage_amount"] option:last, select[name="MortgageAmount"] option:last').val() != '60000' &&
      anchor != '85000' &&
      anchor != '90000'
    ) {
      $('select[name="mortgage_amount"] option:last, select[name="MortgageAmount"] option:last').remove()
      $('select[name="mortgage_amount"] option:last, select[name="MortgageAmount"] option:last').remove()
    } else {
      // do nothing
    }

    if (arg === 'default') {
      try {
        if (scData[0].siteVertical && scData[0].siteVertical !== '100k') {
          $('select[name="mortgage_amount"], select[name="MortgageAmount"]')[0].selectedIndex = 30
          $('select[name="mortgage_amount"] option:last, select[name="MortgageAmount"] option:last').remove()
        } else {
          $('select[name="mortgage_amount"], select[name="MortgageAmount"]')[0].selectedIndex = 18
          $('select[name="mortgage_amount"] option:last, select[name="MortgageAmount"] option:last').remove()
        }
      } catch (error) {
        $('select[name="mortgage_amount"], select[name="MortgageAmount"]')[0].selectedIndex = 18
        $('select[name="mortgage_amount"] option:last, select[name="MortgageAmount"] option:last').remove()
      }
    } else {
      $('select[name="mortgage_amount"] option:last, select[name="MortgageAmount"] option:last').attr(
        'selected',
        'selected'
      )
    }
  }
}
const reverseDropDownLTV = function (arg) {
  if ($('select[name="mortgage_amount"], select[name="MortgageAmount"]').length != 0) {
    // prettier-ignore
    var values = ['80000', '85000', '90000', '95000', '100000', '105000', '110000', '115000', '120000', '125000', '130000', '135000', '140000', '145000', '150000', '155000', '160000', '165000', '170000', '175000', '180000', '185000', '190000', '195000', '200000', '210000', '220000', '230000', '240000', '250000', '260000', '270000', '280000', '290000', '300000', '310000', '320000', '330000', '340000', '350000', '360000', '370000', '380000', '390000', '400000', '420000', '440000', '460000', '480000', '500000', '520000', '540000', '560000', '580000', '600000', '620000', '640000', '660000', '680000', '700000', '720000', '740000', '760000', '780000', '800000', '820000', '840000', '860000', '880000', '900000', '920000', '940000', '960000', '980000', '1000000', '1500000'], anchor = $('select[name="mortgage_amount"], select[name="MortgageAmount"]').val(), curValue
    $('select[name="est_property_value"], select[name="PropertyValue"]').html('')

    for (var i = 0; i < values.length; i++) {
      if (parseInt(values[i]) > parseInt(anchor)) {
        try {
          curValue = `<option value=${values[i + 1]}>$${values[i].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}-$${values[
            i + 1
          ].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</option>`
          $('select[name="est_property_value"], select[name="PropertyValue"]').append(curValue)
        } catch (error) {
          // do nothing
        }
      }
    }

    if (arg === 'default') {
      $('select[name="est_property_value"], select[name="PropertyValue"]')[0].selectedIndex = 6
    } else {
      if (anchor == '2000000') {
        curValue = '<option value="2000001">$2,000,000+</option>}'
        $('select[name="est_property_value"], select[name="PropertyValue"]').append(curValue)
      } else {
        // onchange
        let currentSelectedIndex = $('select[name="est_property_value"], select[name="PropertyValue"]')[0].selectedIndex
        $('select[name="est_property_value"], select[name="PropertyValue"]')[0].selectedIndex = currentSelectedIndex + 8
      }
    }
  }
}

const convertChars = function (charStr) {
  var convertSchema = {}
  convertSchema.ae = 'ä|æ|ǽ'
  convertSchema.oe = 'ö|œ'
  convertSchema.ue = 'ü'
  convertSchema.Ae = 'Ä'
  convertSchema.Ue = 'Ü'
  convertSchema.Oe = 'Ö'
  convertSchema.A = 'À|Á|Â|Ã|Ä|Å|Ǻ|Ā|Ă|Ą|Ǎ'
  convertSchema.a = 'à|á|â|ã|å|ǻ|ā|ă|ą|ǎ|ª'
  convertSchema.C = 'Ç|Ć|Ĉ|Ċ|Č'
  convertSchema.c = 'ç|ć|ĉ|ċ|č'
  convertSchema.D = 'Ð|Ď|Đ'
  convertSchema.d = 'ð|ď|đ'
  convertSchema.E = 'È|É|Ê|Ë|Ē|Ĕ|Ė|Ę|Ě'
  convertSchema.e = 'è|é|ê|ë|ē|ĕ|ė|ę|ě'
  convertSchema.G = 'Ĝ|Ğ|Ġ|Ģ'
  convertSchema.g = 'ĝ|ğ|ġ|ģ'
  convertSchema.H = 'Ĥ|Ħ'
  convertSchema.h = 'ĥ|ħ'
  convertSchema.I = 'Ì|Í|Î|Ï|Ĩ|Ī|Ĭ|Ǐ|Į|İ'
  convertSchema.i = 'ì|í|î|ï|ĩ|ī|ĭ|ǐ|į|ı'
  convertSchema.J = 'Ĵ'
  convertSchema.j = 'ĵ'
  convertSchema.K = 'Ķ'
  convertSchema.k = 'ķ'
  convertSchema.L = 'Ĺ|Ļ|Ľ|Ŀ|Ł'
  convertSchema.l = 'ĺ|ļ|ľ|ŀ|ł'
  convertSchema.N = 'Ñ|Ń|Ņ|Ň'
  convertSchema.n = 'ñ|ń|ņ|ň|ŉ'
  convertSchema.O = 'Ò|Ó|Ô|Õ|Ō|Ŏ|Ǒ|Ő|Ơ|Ø|Ǿ'
  convertSchema.o = 'ò|ó|ô|õ|ō|ŏ|ǒ|ő|ơ|ø|ǿ|º'
  convertSchema.R = 'Ŕ|Ŗ|Ř'
  convertSchema.r = 'ŕ|ŗ|ř'
  convertSchema.S = 'Ś|Ŝ|Ş|Š'
  convertSchema.s = 'ś|ŝ|ş|š|ſ'
  convertSchema.T = 'Ţ|Ť|Ŧ'
  convertSchema.t = 'ţ|ť|ŧ'
  convertSchema.U = 'Ù|Ú|Û|Ũ|Ū|Ŭ|Ů|Ű|Ų|Ư|Ǔ|Ǖ|Ǘ|Ǚ|Ǜ'
  convertSchema.u = 'ù|ú|û|ũ|ū|ŭ|ů|ű|ų|ư|ǔ|ǖ|ǘ|ǚ|ǜ'
  convertSchema.Y = 'Ý|Ÿ|Ŷ'
  convertSchema.y = 'ý|ÿ|ŷ'
  convertSchema.W = 'Ŵ'
  convertSchema.w = 'ŵ'
  convertSchema.Z = 'Ź|Ż|Ž'
  convertSchema.z = 'ź|ż|ž'
  convertSchema.AE = 'Æ|Ǽ'
  convertSchema.ss = 'ß'
  convertSchema.IJ = 'Ĳ'
  convertSchema.ij = 'ĳ'
  convertSchema.OE = 'Œ'
  convertSchema.f = 'ƒ'
  for (var i in convertSchema) {
    var re = new RegExp(convertSchema[i], 'g')
    charStr = charStr.replace(re, i)
    charStr = charStr.replace(/[^a-z',\s\-\u00C0-\u017F]/i, '')
  }
  return charStr
}

// this function is caled in controls.js on form submit
const inputValOnSubmit = function () {
  try {
    // checks address for only letters or only numbers.  If either exist then we prepend or append to create an alphanumberic value
    var addressCheck = current_form.form.find('input[name="address"]').val(),
      inputHTML = current_form.form.find('input[name="address"]')
    if (addressCheck.indexOf('1234') == 0) {
      addressCheck = addressCheck.replace('1234', '1')
      inputHTML.val(addressCheck).css('color', 'transparent')
    }

    var addressString = addressCheck.split('')
    var myLength = addressString[0].match(/[0-9]/g)
    if (myLength === null) {
      inputHTML.val(' 1 ' + addressCheck).css('color', 'transparent')
    }

    if (addressCheck.match(/^[\s\d]+$/) != null) {
      inputHTML.val(addressCheck + ' st').css('color', 'tranparent')
    }

    // runs the convertChars function to ensure no accented chars are passed to cake.  This function also does a replace to strip out all special characters on form submit
    var firstNameCheck = current_form.form.find('input[name="first_name"]').val(),
      lastNameCheck = current_form.form.find('input[name="last_name"]').val(),
      newFNCheck = convertChars(firstNameCheck),
      newLNCheck = convertChars(lastNameCheck)

    current_form.form.find('input[name="first_name"]').val(newFNCheck)
    current_form.form.find('input[name="last_name"]').val(newLNCheck)
  } catch (error) {
    console.log(error)
  }
}

//get the subaffiliate
function s1() {
  if (
    storage('session', 'get', 'subAffiliate') != null &&
    storage('session', 'get', 'subAffiliate') != undefined &&
    storage('session', 'get', 'subAffiliate') != ''
  ) {
    value = '&s1=' + storage('session', 'get', 'subAffiliate')
    return value
  } else {
    return ''
  }
}

function organicS1() {
  var organicS1id = getParameterByName('s1')
  if (organicS1id) {
    return '&s1=' + organicS1id
  } else {
    return '&s1='
  }
}

function crt() {
  var criteoConversion = getParameterByName('crt')
  if (!criteoConversion || criteoConversion == '') {
    return ''
  } else {
    return '&crt=1'
  }
}

//get the job title for heros
function jobTitle() {
  dc1 = getParameterByName('dc1')
  if (dc1 != null && dc1 != undefined && dc1 != '') {
    return '&job_title=' + dc1
  } else {
    return ''
  }
}

//determine if the lead should be considered high price
function highPrice() {
  var hpValues = queryStringToJSON($('form:visible').serialize())
  if (parseInt(hpValues.est_property_value) > 125000 || parseInt(hpValues.est_purchase_price) > 125000) {
    return '&high_price=yes'
  } else {
    return '&high_price=no'
  }
}

//get the job title for heros
function ageParam() {
  const age = $('#' + current_form.form_id + ' [name=age]').val()
  if (age != null && age != undefined && age != '') {
    return '&age=' + age
  } else {
    return ''
  }
}

/**
 * @param  {} percent
 * Calculates users equity
 * If an argument is passed it will override the default 85% calculation
 */
function equity(percent) {
  var homeVal = $('[name=est_property_value], [name=PropertyValue]').val(),
    amountOwned = $('[name=mortgage_amount], [name=MortgageAmount]').val(),
    equity = 0,
    p
  if (!percent || isNaN(percent)) {
    p = 0.85
  } else {
    p = percent
  }

  if (homeVal && amountOwned) {
    equity = parseInt(homeVal * p - amountOwned)
    return equity
  } else {
    return equity
  }
}

/**
 * @param  {} percent
 * updates refi_purpose and additional_cash_needed values based on users equity
 * If an argument is passed, it overrides default percent of 85
 */

// set this var as false globally
var equityAsAddlCash = false

function equityAndAddlCash(percent) {
  var p, eq
  if (!percent || isNaN(percent)) {
    p = 0.85
  } else {
    p = percent
  }

  eq = equity(p)

  if (eq <= 0) {
    $('.congrats').hide()
    $('#refi_purpose').val('Lower Payments')
    $('[name=additional_cash_needed]').val('0')
  } else {
    $('.congrats').show()
    $('#refi_purpose').val('Cash Out')
    $('[name=additional_cash_needed]').val(eq)
  }
  $('[name=equity]').val(eq)
  //$('#equity_amount').text(eq.toLocaleString());
}

// utility function to convert formdata to an object that can be JSONified.
function getFormData($form) {
  var unindexed_array = $form.serializeArray()
  var indexed_array = {}

  $.map(unindexed_array, function (n, i) {
    indexed_array[n.name] = n.value
  })

  return indexed_array
}

function offerId() {
  return getParameterByName('o') || $('input[name="offer_id"]').val()
}

function affiliateGTM() {
  agtm = getParameterByName('agtm')
  if (agtm) {
    return '&agtm=' + agtm
  } else {
    return ''
  }
}

function affiliateId() {
  return getParameterByName('a') || storage('session', 'get', 'affiliateId')
}

function subAffiliate() {
  subAff = getParameterByName('s1')
  if (subAff) {
    return '&subaffiliateName=' + subAff
  } else {
    return ''
  }
}

function noPush() {
  nP = getParameterByName('np')
  if (nP) {
    return '&np=' + nP
  } else {
    return ''
  }
}

function trafficSource() {
  tS = getParameterByName('ts')
  if (tS) {
    return '&ts=' + tS
  } else {
    return '&ts='
  }
}

// sets the campaign id if the param exists in the URL
function getCampaignId() {
  var cpid = getParameterByName('cpid')
  if (cpid) {
    return cpid
  } else {
    return ''
  }
}

function detectMSIE() {
  var ua = window.navigator.userAgent
  var msie = ua.indexOf('MSIE ')

  return msie > 0
}

function stageParam() {
  var stage = getParameterByName('stage')
  if (stage) {
    return '&stage=' + stage
  } else {
    return ''
  }
}

function tierStorage() {
  var lmbTier = storage('session', 'get', 'tl')
  if (lmbTier) {
    return '&t=' + lmbTier
  } else {
    return '&t='
  }
}

function handleDisclosures() {
  const disclosureReqId = requestId()
  const disclosureOfferId = offerId()
  assignDisclosures(disclosureOfferId, disclosureReqId)
}

// pulls url params needed for cake pixel to fire properly
function getCakeURLParams() {
  let oid = getParameterByName('o') || $('input[name="offer_id"]').val() || '',
    aid = getParameterByName('a') || $('input[name="affiliate_id"]').val() || '',
    subaid = getParameterByName('s1') || '',
    subaid2 = getParameterByName('s2') || '',
    subaid3 = getParameterByName('s3') || '',
    subaid4 = getParameterByName('s4') || '',
    subaid5 = getParameterByName('s5') || '',
    creative = getParameterByName('c') || '',
    cpid = getParameterByName('cpid') || '',
    pid = getParameterByName('p') || '',
    tsDomain = 'suited45trk.com/?cp=js'

  // if any of these params are empty then return false and use sites indv organic click pixel
  if (oid === '' || aid === '' || creative === '' || cpid === '') {
    return false
  } else {
    if (rmpDCP) {
      tsDomain = 'rmptk.com/?cp=js'
    }
    return `https://${tsDomain}&o=${oid}&a=${aid}&s1=${subaid}&s2=${subaid2}&s3=${subaid3}&s4=${subaid4}&s5=${subaid5}&c=${creative}&cpid=${cpid}&p=${pid}`
  }
}

function getCakeOrganic(organicLink, verifyLink) {
  const reqId = getParameterByName('req_id'),
    getCakeParams = getCakeURLParams(),
    affiliate = affiliateId() || '',
    affiliateRedirectArray = ['737']

  let useLink = ''

  if (verifyLink && !getCakeParams && document.URL.indexOf('verify') >= 0) {
    useLink = verifyLink
  } else if (!getCakeParams) {
    useLink = organicLink
  } else {
    useLink = getCakeParams
  }

  // if affiliate id is in the array we direct or if no reqid in url we fire DCP or Organic cake pixel
  if (!reqId && affiliateRedirectArray.includes(affiliate)) {
    window.location = '404.html'
  } else if (!reqId && noFireCakePixel !== true) {
    // store DCP or organic cake pixel to pass on form submit
    storage('session', 'set', 'cakePixel', useLink)

    $.getScript(useLink)
      .done(function (response) {
        storage('session', 'set', 'request_id', window.ckm_request_id)
        handleDisclosures()
      })
      .fail(function (err) {
        console.error('getCakeOrganic -> err.statusText =', err.statusText)
        console.error('getCakeOrganic -> err.status =', err.status)
        handleDisclosures()
      })
    console.log(useLink)
  } else {
    console.log('cl')
  }
  return
}

// handle modals

var disclosureTermsOfUse, disclosurePrivacyPolicy, disclosureLicensure, disclosureDoNotSell

$('#modalCloseX, #modalClose, #modalOverlay').click(function () {
  $('#termsModal').hide()
  $('#contactModal').hide()
  $('#privacyModal').hide()
  $('#resourceModal').hide()
  $('#faqModal').hide()
  $('.modalContainer').hide()
  $('#modalOverlay').hide()
})

$(document).on('click touchend touchcancel', '#termsModalOpen, .tou-modal', function (e) {
  e.stopPropagation()
  $('#termsContent').html(disclosureTermsOfUse)
  window.scrollTo(0, 0)
  $('#termsModal').show()
  $('#modalOverlay').show()
})
$(document).on('click touchend touchcancel', '#licensureModalOpen, .lic-modal', function (e) {
  e.stopPropagation()
  $('#licensureContent').html(disclosureLicensure)
  window.scrollTo(0, 0)
  $('#licensureModal').show()
  $('#modalOverlay').show()
})
$(document).on('click touchend touchcancel', '#privacyModalOpen, .pp-modal', function (e) {
  e.stopPropagation()
  $('#privacyContent').html(disclosurePrivacyPolicy)
  window.scrollTo(0, 0)
  $('#privacyModal').show()
  $('#modalOverlay').show()
  $('#doNotSellModal').hide() // hides this modal so we don't have overlapping modals if opened in ccpa
})
$(document).on('click touchend touchcancel', '#doNotSellModalOpen', function (e) {
  e.stopPropagation()
  $('#doNotSellContent').html(disclosureDoNotSell)
  window.scrollTo(0, 0)
  $('#doNotSellModal').show()
  $('#modalOverlay').show()
  $('#privacyModal').hide() // hides this modal so we don't have overlapping modals if opened in PP
})
$('#contactModalOpen').click(function () {
  window.scrollTo(0, 0)
  $('#contactModal').show()
  $('#modalOverlay').show()
})
$('#resourceModelOpen').click(function () {
  window.scrollTo(0, 0)
  $('#resourceModal').show()
  $('#modalOverlay').show()
})
$('.va-faq').click(function () {
  window.scrollTo(0, 0)
  $('#faqModal').show()
  $('#modalOverlay').show()
})

function handlebarsFunctions() {
  var followUpRefi = $('#msform-refinance .followUp').length,
    followUpPurchase = $('#msform-purchase .followUp').length,
    refiFields = $('#msform-refinance fieldset').length + 1 - followUpRefi,
    purchaseFields = $('#msform-purchase fieldset').length + 1 - followUpPurchase,
    hvParam = getParameterByName('hv'),
    noNext = getParameterByName('nb')

  if (noNext == '1') {
    noNextButton = true
  }

  if (typeof preFormQuestions !== 'undefined') {
    refiFields = refiFields + preFormQuestions
    purchaseFields = purchaseFields + preFormQuestions
  } else {
    refiFields = refiFields + 1
    purchaseFields = purchaseFields + 1
  }

  /*****************Set number of fields and current field number*****************/
  $('#msform-refinance fieldset .stepNum').each(function () {
    $(this).text(fieldCount)
    fieldCount++
  })
  if (typeof preFormQuestions !== 'undefined') {
    fieldCount = preFormQuestions + 1
  } else {
    fieldCount = 2
  }
  $('#msform-purchase fieldset .stepNum').each(function () {
    $(this).text(fieldCount)
    fieldCount++
  })

  $('.refiFieldTotal').text(refiFields)
  $('.purchaseFieldTotal').text(purchaseFields)
  /***********************End***********************/

  /************Eliminate enter to progress and remove defaults************/
  if (getParameterByName('pp') != 1) {
    if (noNextButton) {
      $('input[type=radio]').each(function () {
        $(this).removeAttr('checked')
      })
      $('.remove-btn .next-button').each(function () {
        $(this).removeClass('btn-primary')
      })
    }
  } else {
    $('.next-button-container').removeClass('remove-btn')
  }

  /**********************End*************************/

  /*******Add first-step and init-back classes*******/
  $('form fieldset:first-of-type').addClass('first-step')
  $('form fieldset:first-of-type .back-button').addClass('init-back')
  /**********************End*************************/

  runBackButtonLogic()

  /******100k sites credit step purchase******/
  $('.cs-purchase-100k .radio-button, .cs-purchase-100k .next-button').on(
    'click touchend touchcancel',
    $.debounce(300, function () {
      var creditScore = $('[name=credit_rating_purchase]:checked').val()
      if (getParameterByName('ts')) {
        tsp = trafficSource() + '-p'
      } else {
        tsp = '&ts=-p'
      }

      if (creditScore == 'good' || creditScore == 'excellent' || creditScore == 'average') {
        location.href = 'rateGCP.html?loan_purpose=Purchase' + tsp + noPush()
      } else {
        location.href = 'rateBCP.html?loan_purpose=Purchase' + tsp + noPush()
      }
    })
  )
}

// Updates both paths to help prevent missing lead data
$('input[name="email"]').change(function () {
  $('input[name="email"]').val($(this).val())
})

$('input[name="first_name"]').change(function () {
  $('input[name="first_name"]').val($(this).val())
})

$('input[name="last_name"]').change(function () {
  $('input[name="last_name"]').val($(this).val())
})

$('input[name="phone_primary"]').change(function () {
  $('input[name="phone_primary"]').val($(this).val())
})

$('input[name="address"]').change(function () {
  $('input[name="address"]').val($(this).val())
})

// utility function that returns either the select value or the radio button value
function radioOrSelectValue(inputName, currentForm) {
  var selectValue
  if (currentForm === true) {
    selectValue = $('#' + current_form.form_id + ' select[name=' + inputName + ']')
    if (selectValue.length > 0) {
      // handles dropdown form elements
      return selectValue.val()
    } else {
      // handles hidden inputs
      if ($('#' + current_form.form_id + ' input[name=' + inputName + ']').attr('type') === 'hidden') {
        return $('#' + current_form.form_id + ' input[name=' + inputName + ']').val()
      } else {
        // handles inputs that have been checked
        return $('#' + current_form.form_id + ' input[name=' + inputName + ']:checked').val()
      }
    }
  } else {
    selectValue = $('select[name=' + inputName + ']')
    if (selectValue.length > 0) {
      // handles dropdown form elements
      return selectValue.val()
    } else {
      // handles hidden inputs
      if ($('input[name=' + inputName + ']').attr('type') === 'hidden') {
        return $('input[name=' + inputName + ']').val()
      } else {
        // handles inputs that have been checked
        return $('input[name=' + inputName + ']:checked').val()
      }
    }
  }
}

/**
 * checks Advertiser ID from Disclosures call and maps it to a phone number.  If no number then return null
 * @param  {} advId
 */
// function advertiserIdSchema( advId ) {
//     var phoneDash, phoneNoDash;
//     switch ( advId ) {
//         case '99':
//             phoneDash = '844-903-3867';
//             break;
//         case '102':
//             phoneDash = '844-903-4153';
//             break;
//         case '101':
//             phoneDash = '844-903-4416';
//             break;
//         case '104':
//             phoneDash = '844-903-3908';
//             break;
//         case '103':
//             phoneDash = '844-903-4370';
//             break;
//         case '1':
//             phoneDash = '844-903-3901';
//             break;
//         case '100':
//             phoneDash = '844-903-4040';
//             break;
//         default:
//             phoneDash = '';
//             break;
//     }
//     if ( phoneDash !== '' ) {
//         phoneNoDash = phoneDash.replace( /-/g, "" );
//         if(noPhoneOnSite === false){
//         return '<h3> Mortgage Resource Specialist:<br><a href="tel:' + phoneNoDash + '" id="phoneNumber">' + phoneDash + '</a></h3>';
//         }else{
//             return
//         }
//     } else {
//         return null;
//     }

// }

/**
 * utility function to decide what thank you page to redirect to, if it opens in a new tab and if another page should open as well.
 * @param  {string} thankyouPage
 * @param  {object} tyOptions
 * @param  {string} standardTYPage
 * @param  {string} defaultTyParams
 * @param  {string} mcrUrl
 * @param  {object} ckData
 * @param  {string} insuranceTyParams
 */
function processTYRedirect(
  thankyouPage,
  tyOptions,
  standardTYPage,
  defaultTyParams,
  mcrUrl,
  ckData,
  insuranceTyParams
) {
  // TODO: FEDP-1867: Temp disable of popUnder functionality
  let popUnder = false

  // if (getParameterByName('nlb') === '1') {
  //   popUnder = false
  // }

  // sites that should not run the popUnder functionality
  // TODO: Need to refactor this because it triggers indexOf errors in MS Edge 18
  // if (
  //   document.URL.indexOf('ratemarketplace') !== -1 ||
  //   document.URL.indexOf('thesolarsurvey') !== -1 ||
  //   document.URL.indexOf('next-steps') !== -1 ||
  //   document.URL.indexOf('insurancespecialists') !== -1 ||
  //   document.URL.indexOf('usasolarsurvey') !== -1 ||
  //   document.URL.indexOf('solarsurveyusa') !== -1 ||
  //   document.URL.indexOf('rent2ownqualified') !== -1 ||
  //   document.URL.indexOf('usaroofingsurvey') !== -1 ||
  //   document.URL.indexOf('usawindowsurvey') !== -1 ||
  //   callDotRMP
  // ) {
  //   popUnder = false
  // }

  // if (ckData.loanPurpose === 'Sell Home' || ckData.ckprefix === 'GCR') {
  //   popUnder = false
  // }

  // running test on one site FEDP-1963
  if (getParameterByName('ag') === '1') {
    popUnder = true
  }

  if (popUnder) {
    openTabUnder('http://trkme3.com/?r3x=PHdcGnBU1ijzQZ%2f%2fLy8EOOcV2pp1jy6g&s1=')
    setTimeout(function () {
      window.location.href = standardTYPage + defaultTyParams + trafficSource()
    }, 500)
  }

  /* if (popUnder) {
    if (tyOptions.newTab === true && tyOptions.plp === true) {
      openTabUnder(thankyouPage)
      setTimeout(function() {
        if (tyOptions.isExclusive === true) {
          window.location.href = tyOptions.exTYPage + defaultTyParams + tyOptions.tsValue
        } else {
          window.location.href = mcrUrl + tyOptions.tsValue
        }
      }, 500)
    } else if (tyOptions.newTab === true && tyOptions.showMCR === false) {
      openTabUnder(thankyouPage)
      setTimeout(function() {
        window.location.href = standardTYPage + defaultTyParams + trafficSource()
      }, 500)
    } else if (tyOptions.newTab === true && tyOptions.showMCR === true) {
      openTabUnder(mcrUrl + tyOptions.tsValue)
      setTimeout(function() {
        window.location.href = standardTYPage + defaultTyParams + trafficSource() + '-ty'
      }, 500)
    } else {
      window.location.href = thankyouPage + defaultTyParams + trafficSource() + tierStorage()
    }
  } else {
    if (document.URL.indexOf('insurancespecialists.com') !== -1) {
      window.location.href = thankyouPage + insuranceTyParams + trafficSource()
    } else if (callDotRMP) {
      window.location.href = '/leadSubmitted.html'
    } else {
      window.location.href = thankyouPage + defaultTyParams + trafficSource() + tierStorage()
    }
  } */

  // temp from else statement above
  if (isInsurance) {
    window.location.href = thankyouPage + insuranceTyParams + trafficSource()
  } else if (callDotRMP) {
    window.location.href = '/leadSubmitted.html'
  } else {
    window.location.href = thankyouPage + defaultTyParams + trafficSource() + tierStorage()
  }
}
/**
 * Best practice for using window.open()
 * @param  {string} url
 */
function openTabUnder(url) {
  var windowObjectReference = null

  if (getParameterByName('lbw') !== '1') {
    if (windowObjectReference == null || windowObjectReference.closed) {
      windowObjectReference = window.open(url)
    } else {
      windowObjectReference.focus()
    }
  } else {
    return false
  }
}

function removeHash() {
  history.pushState('', document.title, window.location.pathname + window.location.search)
}

// checks if timeKey exists and sets to current time if not.  Deletes timeKey and formData if older than 24hrs
function checkStorageTime() {
  if (storage('local', 'get', 'timeKey') === null) {
    const timeStamp = new Date().getTime()
    storage('local', 'set', 'timeKey', timeStamp)
  } else {
    const currentDateTimestamp = new Date().getTime(),
      storedTime = storage('local', 'get', 'timeKey')

    //Check if the timestamp is within 24 hours, 24 hours = 60 seconds * 60 minutes * 24 hours * 1000 milliseconds
    if (Math.abs(currentDateTimestamp - storedTime) >= 60 * 60 * 24 * 1000) {
      //Within 24 hours
      console.log('time expired')
      storage('local', 'remove', 'timeKey')
      storage('local', 'remove', 'formData')
      storage('local', 'remove', 'plp')
    }
  }
}
/**
 * validates the user ip
 * @param  {string} ipaddress
 */
function validateUserIp(ip) {
  if (
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      ip
    )
  ) {
    return true
  }
  return false
}

/**
 * logs stuff in stage or localhost
 * @param  {string} item
 * @param  {any data type} value
 */
function stageLog(item, value) {
  if (document.URL.indexOf('test') >= 0 || document.URL.indexOf('localhost') >= 0) {
    console.log(`Staging Log of - '${item}' = ${value}`)
  }
}

/**
 * updates lender value once selected from current lender autocomplete
 * @param  {string} lender
 */
// function setCurrentLender(lender) {
//     $('[name=current_lender]').val(lender)
// }

// function enableLenderOther() {
//     $('#lender-search').on('keyup', function() {
//         const that = $(this)
//             .val()
//             .toLowerCase()
//         if (that && that === 'other') {
//             $('[name=current_lender]').val('Other')
//         }
//     })
// }

/**
 * trusted form postback contains the cert url and token value
 * @param  {string} certificateUrl
 */
function trustedFormCertUrlCallback(certificateUrl) {
  storage('session', 'set', 'trustedFormUrl', certificateUrl)
  storage('session', 'set', 'trustedFormToken', certificateUrl)
}

// Trusted Form
function trustedForm() {
  var field = 'xxTrustedFormCertUrl'
  var provideReferrer = false
  var invertFieldSensitivity = false
  var tf = document.createElement('script')
  tf.type = 'text/javascript'
  tf.async = true
  tf.src =
    'http' +
    ('https:' == document.location.protocol ? 's' : '') +
    '://api.trustedform.com/trustedform.js?provide_referrer=' +
    escape(provideReferrer) +
    '&field=' +
    escape(field) +
    '&l=' +
    new Date().getTime() +
    Math.random() +
    '&invert_field_sensitivity=' +
    invertFieldSensitivity
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(tf, s)
}

function jornayaReRun() {
  var s = document.createElement('script')
  s.id = 'LeadiDscript_campaign'
  s.type = 'text/javascript'
  s.async = true
  s.src =
    '//create.lidstatic.com/campaign/f21bcfe7-421d-0b59-65fe-3d36e8d9c8d6.js?snippet_version=2&f=reset&callback=reloadLeadId'
  document.body.appendChild(s)

  try {
    if (typeof LeadiD !== 'undefined') {
      LeadiD.reInit()
    }
  } catch (error) {
    console.log(error)
  }
}

function getCreditLoanPurpose(credit, loanPurpose) {
  if ($.inArray(credit, ['good', 'excellent', 'average']) !== -1) {
    return 'GC' + loanPurpose
  } else {
    return 'BC' + loanPurpose
  }
}

function sendAlertToSlack(tcpa, reason, url) {
  try {
    const d = new Date()
    const tfURL = JSON.parse(storage('session', 'get', 'formData'))
    const payload = {
      text: '*Warning!* ' + reason + ' --',
      attachments: [
        {
          title: 'Website: ' + window.location.hostname,
          text:
            'TCPA: ' +
            tcpa +
            '\nPage URL: ' +
            window.location.href +
            '\n Date: ' +
            d.toUTCString() +
            '\n TrustedFormURL: ' +
            tfURL.xxTrustedFormCertUrl,
        },
      ],
    }
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        console.log('Successfully sent Alert')
      })
      .catch(function (error) {
        console.log('Error:', error)
      })
  } catch (error) {
    console.log('Error with Fetch POST', error)
  }
}

/**
 * Translate suco payload to post directly to RMP cake
 * @param  {object} payload
 */
function rmpToCakeTranslation(payload) {
  const campaignID = storage('session', 'get', 'campaignId')

  payload.ckm_campaign_id = campaignID || '100174'
  payload.ckm_key = 'ChG0bDF5JSJfBm1BwpUrA'
  if (campaignID === '100169') {
    payload.ckm_key = 'PZdk9BW2g3NfBm1BwpUrA'
  } else if (campaignID === '100173') {
    payload.ckm_key = 'wWEuT9KeCcdfBm1BwpUrA'
  } else if (campaignID === '100216') {
    payload.ckm_key = 'aHerBqWJIxRfBm1BwpUrA'
  }

  // add translated properties to fit cake's post
  payload.off_id = payload.offer_id
  payload.aff_id = payload.affiliate_id
  payload.property_use = payload.HomeUse
  payload.estimated_home_value = payload.est_property_value
  payload.current_loan_amount = payload.mortgage_amount
  payload.current_interest_rate = payload.mortgage_rate
  payload.harp_loan_type = payload.current_loan_type
  payload.military_service = payload.opt_served_military
  payload.zip_code = payload.zipcode
  payload.email_address = payload.email
  payload.phone_home = payload.phone_primary
  payload.trusted_form = payload.xxTrustedFormCertUrl
  payload.lead_id_com = payload.universal_leadid
  payload.ip_address = payload.user_ip
  payload.estimated_purchase_price = payload.est_purchase_price
  payload.down_payment = payload.estimated_down_payment
  payload.realtor = payload.agent_found
  payload.found_home = payload.home_found

  // delete offending properties that cake doesn't like
  delete payload.offer_id
  delete payload.affiliate_id
  delete payload.HomeUse
  delete payload.est_property_value
  delete payload.mortgage_amount
  delete payload.mortgage_rate
  delete payload.current_loan_type
  delete payload.opt_served_military
  delete payload.zipcode
  delete payload.email
  delete payload.phone_primary
  delete payload.xxTrustedFormCertUrl
  delete payload.universal_leadid
  delete payload.user_ip
  delete payload.est_purchase_price
  delete payload.estimated_down_payment
  delete payload.agent_found
  delete payload.home_found

  return payload
}

/**
 * Calculates the offset of an element in pixels
 * @param  {object} el
 */
function tcpaOffset(el) {
  const rect = el.getBoundingClientRect(),
    scrollTop = window.pageYOffset || document.documentElement.scrollTop
  return Math.floor(rect.top + scrollTop)
}

// fires doTCPA() after prepop and then again if the user updates any inputs or selects in the form
function isVerifyTCPA() {
  stageLog('I am a verify site', true)
  if (showMissingQuestions) {
    checkForEmptySelect()
  }
  doTCPA()
  $('input, select').change(function () {
    $('.submit-button').prop('disabled', true)
    $('.submit-button-translate').prop('disabled', true)
    $('#tcpa').hide()
    doTCPA()
    stageLog('Input Change Detected', this.name)
  })
}

function checkForEmptySelect() {
  $('select').each(function () {
    if ($(this).val() === null || $(this).val() === undefined) {
      var closestDiv = $(this).closest('.questionContainer')
      closestDiv.show()
    }
  })

  if (refiOnly) {
    $('[name=loan_purpose').val('Refinance')
  }

  var emailCheck = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  var validEmail = emailCheck.test($('[name=email]').val())
  if (!validEmail) {
    $('#emailContainer').removeClass('hidden')
  }
}

/**
 * Fires after zip code step by popping over the same site and fast forwarding to frame after zip step (@param - fieldsetId).
 * Leaves behind a TY page redirect.
 * @param  {string} fieldsetId
 * @param  {string} tyURL
 */
function ffInsurancePopUnder(fieldsetId, tyURL) {
  window.addEventListener('stepChange', function (e) {
    var frameId = e.detail,
      width = $(window).width(),
      apo = '?apo=1&lbw=1'
    try {
      if (width <= 801 || navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
        console.log('IE11 no fast forward or its a mobile device')
      } else {
        if (frameId.indexOf(fieldsetId) !== -1 && getParameterByName('lbw') !== '1') {
          removeHash()
          if (document.location.search.length > 0) {
            apo = '&apo=1&lbw=1'
          }
          openTabUnder(window.location.href + apo)
          setTimeout(function () {
            window.location.href = `/${tyURL}?lbw=1${trafficSource()}-alb`
          }, 500)
        }
      }
    } catch (error) {
      stageLog('error on popunder', error)
    }
  })

  if (getParameterByName('apo') === '1') {
    fastForward()
  }
}

const moveLogo = (size, pos) => {
  $('.logo-container img').width(size + '%')
  if (pos === 'bottom' && window.innerWidth < 801 && $('#bottomLogo').length <= 0) {
    $('.top-bar').hide()
    $('.main-container')
      .append(
        '<div id="bottomLogo" class="' +
          pos +
          '"><img src="img/logo.png" class="img-responsive" alt="logo" width="' +
          size +
          '%"></div>'
      )
      .addClass('moveLogo')
  }
}

const openInNewTab = (url) => {
  var win = window.open(url, '_blank')
  win.focus()
}

// variable of 365.25 days a year in milliseconds to calculate getAge including leap year
const yearInMs = 3.15576e10

/**
 * calulates the current age of the user based on the day of year and includes leap year calculations
 * @param  {string} birthDate - year-month-day
 */
const getAge = (birthDate) => ((new Date() - new Date(birthDate).getTime()) / yearInMs).toFixed(2)

//Helper function for VWO so that a function only fires one time on a site

function runOnce(fn, context) {
  var result
  return function () {
    if (fn) {
      result = fn.apply(context || this, arguments)
      fn = context = null
    }
    return result
  }
}
/**
 * Checks if all refinance rateZip criteria is met before running the rateZip redirect API call
 */
const rateZipRedirectRefinanceCheck = () => {
  //prettier-ignore
  const statesArray = ['AL','IN','WI','VT','UT','SC','OH','NC','NV'] // states not allowed to redirect
  const creditRating = radioOrSelectValue('credit_rating', true)
  const military = radioOrSelectValue('opt_served_military', true)
  const ma = parseInt(radioOrSelectValue('mortgage_amount', true))
  const acn = parseInt(radioOrSelectValue('additional_cash_needed', true))
  const epv = parseInt(radioOrSelectValue('est_property_value', true))
  const totalLoanRefinance = Math.floor(ma + acn)
  const loanToValue = ma / epv
  const state = $('[name=state]').val()
  const property_type = radioOrSelectValue('property_type', true)
  const employer = radioOrSelectValue('employer', true)
  const notManufacturedOrMobile = !['Manufactured', 'Mobile Home'].includes(property_type)
  const notUnOrSelfEmployed = !['selfemployed', 'unemployed'].includes(employer)
  if (
    totalLoanRefinance >= 250000 &&
    creditRating === 'excellent' &&
    loanToValue < 0.95 &&
    !statesArray.includes(state) &&
    notManufacturedOrMobile &&
    military !== '1' &&
    notUnOrSelfEmployed
  ) {
    return true
  }

  return false
}

/**
 * Checks if all purchase rateZip criteria is met before running the rateZip redirect API call
 */
const rateZipRedirectPurchaseCheck = () => {
  //prettier-ignore
  const statesArray = ['AL','IN','WI','VT','UT','SC','OH','NC','NV'] // states not allowed to redirect
  const credit_rating = radioOrSelectValue('credit_rating', true)
  const military = radioOrSelectValue('opt_served_military', true)
  const epp = parseInt(radioOrSelectValue('est_purchase_price', true))
  const edp = parseInt(radioOrSelectValue('estimated_down_payment', true))
  const state = $('[name=state]').val()
  const property_type = radioOrSelectValue('property_type', true)
  const moving_date = radioOrSelectValue('moving_date', true)
  const employer = radioOrSelectValue('employer', true)
  const notManufacturedOrMobile = !['Manufactured', 'Mobile Home'].includes(property_type)
  const notSelfEmployed = !['selfemployed'].includes(employer)
  const notPoorAverageOrFairCredit = !['average', 'fair', 'poor'].includes(credit_rating)
  const notOver3MonthMovingDate = !['6-12 Months', '12+ Months'].includes(moving_date)

  if (
    getParameterByName('a') !== '174' && // this affiliate is blocked for some reason per cake team
    notManufacturedOrMobile &&
    edp >= 5 &&
    epp >= 150000 &&
    epp <= 548000 &&
    notSelfEmployed &&
    notOver3MonthMovingDate &&
    notPoorAverageOrFairCredit &&
    military !== '1' &&
    !statesArray.includes(state)
  ) {
    return true
  }

  return false
}

//pushnami step tracking
doPushnamiTrack = function (stepId) {
  if (!Pushnami) {
    return
  } else {
    $('#' + stepId)
      .find('input')
      .each(function () {
        var inputName = $(this).prop('name'),
          inputValue = $(this).val(),
          data = JSON.parse('{' + '"' + inputName + '"' + ':' + '"' + inputValue + '"' + '}')
        if (this.type == 'radio' && this.checked == true) {
          Pushnami.update(data)
        } else if (
          this.type == 'text' ||
          this.type == 'tel' ||
          this.type == 'email' ||
          this.type == 'number' ||
          this.type == 'hidden'
        ) {
          Pushnami.update(data)
        }
      })
    $('#' + stepId)
      .find('select')
      .each(function () {
        var selectName = $(this).prop('name'),
          selectValue = $(this).val(),
          data = JSON.parse('{' + '"' + selectName + '"' + ':' + '"' + selectValue + '"' + '}')
        Pushnami.update(data)
      })
  }
}

//pushnami conversion tracking
pushnamiSubmit = function () {
  if (window.Pushnami) {
    var finalFrame = 'final-frame-' + current_form.fullLoanType()
    doPushnamiTrack(finalFrame)
    if (!Pushnami) {
      return
    } else {
      Pushnami.update({
        submit: '1',
      })
    }
  }
}

doPushnamiLoanPurpose = function () {
  if (window.Pushnami) {
    loan_purpose = current_form.fullLoanType()
    Pushnami.update({
      loan_purpose: loan_purpose,
    })
  }
}

//ga step tracking
doGAtrack = function (frameId) {
  try {
    if ('ga' in window) {
      if (!ga) {
        return
      }
      var tracker = ga.getAll()[0]
      var reportUrl = '/' + frameId
      if (tracker) tracker.send('pageview', reportUrl)
    }
    return this
  } catch (error) {
    // do nothing
  }
}

gaTrackEmailPartial = function () {
  try {
    if ('ga' in window) {
      if (!ga) {
        return
      }
      var tracker = ga.getAll()[0]
      if (tracker) tracker.send('event', 'Email Partial')
    }
    return this
  } catch (error) {
    // do nothing
  }
}

//criteo step tracking
doCriteoTrack = function (frameId, accountId) {
  if (window.criteo_q) {
    // prettier-ignore
    var deviceType = /iPad/.test(navigator.userAgent) ? 't' : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? 'm' : 'd'
    window.criteo_q.push(
      {
        event: 'setAccount',
        account: accountId,
      },
      {
        event: 'setSiteType',
        type: deviceType,
      },
      {
        event: 'viewItem',
        item: 1,
      }
    )
    if (current_fs.fs.prop('id').indexOf('credit') !== -1) {
      var creditRating
      if ($('select[name=credit_rating]').length) {
        creditRating = $('select[name=credit_rating]').val()
      } else {
        creditRating = $('input[name=credit_rating]:checked').val()
      }
      window.criteo_q.push({
        event: 'setData',
        ui_credit: creditRating,
      })
    }
  }
}

//criteo final step
doCriteoFinalStep = function (accountId) {
  if (window.criteo_q) {
    // prettier-ignore
    var deviceType = /iPad/.test(navigator.userAgent) ? 't' : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? 'm' : 'd'
    window.criteo_q.push(
      {
        event: 'setAccount',
        account: accountId,
      },
      {
        event: 'setSiteType',
        type: deviceType,
      },
      {
        event: 'viewBasket',
        item: [
          {
            id: '1',
            price: '0',
            quantity: 1,
          },
        ],
      }
    )
  }
}

// timeTracker object stores time in seconds
var timeTracker = {
  timeStart: 0,
  timeElapsed: 0,
  timeLap: 0,
  start: function () {
    this.timeStart = new Date().getTime() / 1000
  },
  lap: function () {
    if (this.timeStart == 0 || this.timeStart == null || this.timeStart == 'undefined') {
      this.timeLap = 0
    } else {
      this.timeLap = Math.floor(new Date().getTime() / 1000 - this.timeStart)
      storage('session', 'set', 'tcpaTime', this.timeLap)
    }
  },
  stop: function () {
    if (this.timeStart == 0 || this.timeStart == null || this.timeStart == 'undefined') {
      this.timeElapsed = 0
    } else {
      this.timeElapsed = Math.floor(new Date().getTime() / 1000 - this.timeStart)
      $('form:visible').prepend('<input type="hidden" name="time_on_form" value="' + this.timeElapsed + '" />')
    }
  },
}

/**
 * ga event tracking
 * @param  {string} category
 * @param  {string} value
 * @param  {string} inputName
 */
function gaEventTracking(category, value, inputName) {
  try {
    if (ga && value !== '') {
      ga.getAll()[0].send('event', category, value, inputName, 0)
      stageLog('gaEventTracking', value)
    }
  } catch (error) {
    console.log(error)
    // do nothing
  }
}

/**
 * high price tracking
 * @param  {string} inputName
 * @param  {string} category
 */

function highPriceTracking(inputName, category) {
  try {
    var gtmEst = document.querySelector('[name="' + inputName + '"]').value

    if (parseInt(gtmEst) > 125000) {
      ga.getAll()[0].send('event', category, 'yes', inputName, 0)
    } else {
      ga.getAll()[0].send('event', category, 'no', inputName, 0)
    }
    stageLog('highPriceTracking', gtmEst)
  } catch (error) {
    stageLog('highprice tracking error', error)
  }
}

$('[name="est_property_value"], [name="PropertyValue"]').on(
  'change touchend touchcancel',
  $.debounce(300, function (e) {
    highPriceTracking(this.name, 'high_price')
  })
)

$('[name="est_purchase_price"], [name="PurchasePrice"]').on(
  'change touchend touchcancel',
  $.debounce(300, function (e) {
    highPriceTracking(this.name, 'high_price')
  })
)

$('[name="mortgage_amount"], [name="MortgageAmount"]').on(
  'change touchend touchcancel',
  $.debounce(300, function (e) {
    highPriceTracking(this.name, 'high_price_mortgage')
  })
)

$('.btn-primary').on('click', function () {
  if ($('[name="est_property_value"], [name="PropertyValue"]').parent().is(':visible')) {
    const propertyValue = $('[name="est_property_value"], [name="PropertyValue"]')[0].name
    highPriceTracking(propertyValue, 'high_price')
  }
  if ($('[name="est_purchase_price"], [name="PurchasePrice"]').parent().is(':visible')) {
    const purchasePrice = $('[name="est_purchase_price"], [name="PurchasePrice"]')[0].name
    highPriceTracking(purchasePrice, 'high_price')
  }
  if ($('[name="mortgage_amount"], [name="MortgageAmount"]').parent().is(':visible')) {
    const mortgageAmount = $('[name="mortgage_amount"], [name="MortgageAmount"]')[0].name
    highPriceTracking(mortgageAmount, 'high_price_mortgage')
  }
})

// ga tracking for opt_served_military question. Also handles military first question
$(
  'label[for="military-yes"], label[for="military-yes-p"], label[for="military-no"], label[for="military-no-p"], .milt-opt-button'
).on(
  'click touchend touchcancel',
  $.debounce(300, function (e) {
    const value = radioOrSelectValue('opt_served_military', false)
    gaEventTracking('military', value, 'opt_served_military')
  })
)

/**
 * This module is the helper function to make sending http requests easy
 * It handles the sending of a XHR requests through an ajax wrapper
 * @param {json} requestData
 * @param {url} url
 * @param {function} successFunction
 * @param {string} authKey
 * @param {string} method
 * @param {string} dontRun
 */

function sendRequest(requestData, url, successFunction, authKey, method, syncType) {
  checkForUUID()

  var header,
    requestParameters,
    reqData = '',
    contextId = storage('session', 'get', 'scUUID')

  if (syncType !== true || syncType !== false) {
    syncType = true
  }

  if (requestData !== null) {
    reqData = JSON.stringify(requestData)
  }

  if (authKey != '' && authKey != null && authKey != undefined) {
    header = {
      Authorization: 'Bearer ' + authKey,
      'Content-Type': 'application/json',
      ContextId: contextId,
    }
  } else {
    header = {
      'Content-Type': 'application/json',
    }
  }
  requestParameters = {
    url: url,
    method: method,
    crossDomain: true,
    async: syncType,
    headers: header,
    data: reqData,
    timeout: 10000, // 10 second timeout
    success: function (response) {
      successFunction(response)
    },
    error: function (jqXHR, textStatus, errorThrown) {
      successFunction(null)
      if (textStatus === 'timeout') {
        console.log('Initiate API Timeout', textStatus)
      }

      // sends log that the API called failed.  For debugging purposes
      var newUrl = {
        apiUrl: url,
      }
    },
  }
  $.ajax(requestParameters)
}

/**
 * Helper function i wrote to make easy sending sychronous http requests without ajax
 * It handles the sending of a XHR requests with a javascript wrapper
 * @param {json} requestData
 * @param {url} url
 * @param {function} successFunction
 * @param {string} authKey
 * @param {string} method
 */

function sendSyncRequest(requestData, url, successFunction, authKey, contextId, method) {
  var request = new XMLHttpRequest()
  var params = JSON.stringify(requestData)
  request.open(method, url, false)
  request.setRequestHeader('Content-type', 'application/json')

  if (contextId && authKey) {
    request.setRequestHeader('Authorization', 'Bearer ' + authKey)
    request.setRequestHeader('ContextId', contextId)
  } else if (authKey) {
    request.setRequestHeader('Authorization', 'Bearer ' + authKey)
  }
  try {
    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        if (request.status === 200) {
          successFunction(request.responseText)
        } else {
          successFunction(null)
        }
      }
    }
    request.onerror = function (e) {
      successFunction(null)
    }
    request.send(params)
  } catch (error) {
    console.log('Error: request.send failed... continuing')
    successFunction(null)
  }
}

function postDirectlyToCake(requestData, url, successFunction, authKey, contextId, method) {
  var request = new XMLHttpRequest()
  var params = JSON.stringify(requestData)
  request.open(method, url, false)
  request.setRequestHeader('Content-type', 'application/json')

  if (contextId && authKey) {
    request.setRequestHeader('Authorization', 'Bearer ' + authKey)
    request.setRequestHeader('ContextId', contextId)
  } else if (authKey) {
    request.setRequestHeader('Authorization', 'Bearer ' + authKey)
  }
  try {
    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        if (request.status === 200) {
          successFunction(request.responseText)
        } else {
          successFunction(null)
        }
      }
    }
    request.onerror = function (e) {
      successFunction(null)
    }
    request.send(params)
  } catch (error) {
    console.log('Error: request.send failed... continuing')
    successFunction(null)
  }
}

/* this module is to control the browsers back button on the survey
 * it requires that there are a .back-button element on the fieldset to work, hidden or otherwise
 */

var backUrl = 'back.html',
  autoInsuranceBackUrl = 'ai-back.html',
  disableIntroBackButton = false,
  enableIntroBackButton = false,
  backButton = function () {
    $('.card:visible').find('.back-button').trigger('click')
  }

//add ability to disable the back button
if (getParameterByName('bc') === '1') {
  disableIntroBackButton = true
}

//add ability to enable the back button
if (getParameterByName('gb') === '1') {
  enableIntroBackButton = true
}

// enable back button on intro frame if its a ratequotecomparison site
if (!getParameterByName('gb') && document.URL.indexOf('ratequotecomparison') >= 0) {
  enableIntroBackButton = true
}

// adds the ts and/or a value to back button redirect url
if (getParameterByName('ts') && getParameterByName('a')) {
  const ts = getParameterByName('ts')
  const a = getParameterByName('a')
  backUrl = `${backUrl}?ts=${ts}-back&a=${a}`
  autoInsuranceBackUrl = `${autoInsuranceBackUrl}?ts=${ts}-back&a=${a}`
} else if (getParameterByName('ts')) {
  const ts = getParameterByName('ts')
  backUrl = `${backUrl}?ts=${ts}-back`
  autoInsuranceBackUrl = `${autoInsuranceBackUrl}?ts=${ts}-back`
} else if (getParameterByName('a')) {
  const a = getParameterByName('a')
  backUrl = `${backUrl}?a=${a}`
  autoInsuranceBackUrl = `${autoInsuranceBackUrl}?a=${a}`
}

/**
 * when called it turns off the go back redirects based on your param
 * @param  {string} enabled
 */
function enableGB(enabled) {
  if (enabled === '1') {
    enableIntroBackButton = true
  }
}

function noBackButton() {
  history.pushState(null, document.title, location.href)
  window.addEventListener('popstate', function () {
    history.pushState(null, document.title, location.href)
  })
}

function enableBackButton() {
  history.go(-2)
  window.addEventListener('popstate', function () {
    history.go(-2)
  })
}

// back button for browsers reverse the survey
window.onload = function () {
  if (typeof history.pushState === 'function') {
    history.pushState('back', null, null)
    window.onpopstate = function () {
      history.pushState('back', null, null)

      // Handle the back (or forward) buttons here
      if (
        $(
          '#intro-frame, #intro-frame-mobile, #you-do-step-refinance, #first_frame, .lander, .prequiz, .onePath fieldset:first-of-type'
        ).is(':visible')
      ) {
        if (disableIntroBackButton) {
          noBackButton()
        } else if (enableIntroBackButton) {
          enableBackButton()
        } else {
          if ($('fieldset:first-of-type').is(':visible') || $('#intro-frame fieldset').length <= 1) {
            if (isCarInsurance) {
              window.location = autoInsuranceBackUrl
            } else {
              window.location = backUrl
            }
          } else {
            backButton()
          }
        }
      } else {
        backButton() //if they aren't leaving the page rewind the survey a step
      }
    }
  } else {
    var ignoreHashChange = true
    window.onhashchange = function () {
      if (!ignoreHashChange) {
        ignoreHashChange = true
        window.location.hash = Math.random()

        // Handle the back (or forward) buttons here
        if (
          $(
            '#intro-frame, #you-do-step-refinance, #first_frame, .lander, .prequiz, #homeowner-step-solar, .one-path fieldset:first-of-type'
          ).is(':visible')
        ) {
          if (isCarInsurance) {
            window.location = autoInsuranceBackUrl //redirect if they are leaving the page
          } else {
            window.location = backUrl //redirect if they are leaving the page
          }
        } else {
          backButton() //if they aren't leaving the page rewind the survey a step
        }
      } else {
        ignoreHashChange = false
      }
    }
  }
}

// Global back button click functions

function runBackButtonLogic() {
  $(document).on('click', '.back-button', function () {
    if (
      $('.first-step-refinance:visible').index() >= 0 ||
      $('.first-step-purchase:visible').index() >= 0 ||
      $('.first-step:visible').index() >= 0
    ) {
      //put them back to the intro frame
      $('form:visible').hide()
      //had to change the id of the path choice question for thecurrentlenderquiz.com to path so we could add more questions before the form.
      if (
        document.URL.indexOf('thecurrentlenderquiz.com') >= 0 ||
        document.URL.indexOf('health.insurancespecialists.com') >= 0
      ) {
        $('#path').show()
      } else {
        $('#intro-frame').show()
      }
      $('#path_choice').show()
      if ($('#intro-frame').length == 1) {
        $('.headline-container').show()
      }
      $('.progress-bar').attr('style', 'width: 10%')
      $('.title_container').removeClass('hide_title')
      window.scrollTo(0, 0)
      $('#tcpa').hide()
      window.replaceHash($('.card:visible').prop('id'))
    } else if ($('#path_choice').is(':visible')) {
      if ($('fieldset:first-of-type').is(':visible') != true) {
        $('#path_choice').hide()
        $('#path_choice').prev().show()
        $('.headline-container').show()
      } else {
        $('#path_choice').hide()
        $('.lander').fadeIn()
      }
    } else if ($('.first-frame').is(':visible')) {
      $('#intro-frame').show()
      $('form:visible').hide()
    } else {
      switchFieldSets($(this), '.card', 'prev')
      $('#tcpa').hide()
      $('body').removeClass('final-frame-body')
    }
  })
}

// This module includes the response handler for TCPA requests

/**
 * This function takes the response body and parses it for validity, then assigning the returned data to the document
 * @param {*} body
 */

var doNotRunTCPA = false
var date = new Date()
function assignTCPA(body, scbc) {
  var lmbDisclosureText = `<div id="footer"> Data is collected by the owner of this site on behalf of Lower My Bills.<div id="links"><a href="https://www.lowermybills.com/index.php#about" name="&amp;lid=Footer+-+About+Us">About Us</a> <small>•</small> <a href="https://www.themuse.com/jobs?company=Core Digital Media" target="_blank">Careers</a> <small>•</small> <a href="https://www.lowermybills.com/misc/for-lenders.php" name="&amp;lid=Footer+-+For+Lenders">For Lenders</a> <small>•</small> <a href="https://www.lowermybills.com" onclick="lmb.util.openUnsubscribeForm();" name="&amp;lid=Footer+-+Unsubscribe">Unsubscribe</a> <small>•</small> <a href="https://www.lowermybills.com" name="&amp;lid=Footer+-+Home">Home</a> <small>•</small> <a href="https://www.lowermybills.com/legal/terms.php">Terms of Use</a> <small>•</small> <a href="https://www.lowermybills.com/legal/privacy.php" name="&amp;lid=Footer+-+Privacy">Privacy</a> <small>•</small> <a href="https://www.lowermybills.com/legal/licenses.php" name="&amp;lid=Footer+-+Licenses">Licenses &amp; Disclosures</a> <small>•</small> <a href="https://www.lowermybills.com/legal/ad-targeting.php" name="&amp;lid=Footer+-+DataUsage">Ad Targeting Policy</a> </div> <div id="copyright">© 2000-${date.getFullYear()} LowerMyBills, Inc. <a href="http://www.nmlsconsumeraccess.org/">NMLS</a> ID 167283 All Rights Reserved. Patent Pending. 4859 W Slauson Ave #405, Los Angeles, CA 90056</div> </div>`

  if (!body || body.Payload === null) {
    if (isHealthInsurance) {
      let tcpaTypeHI = 'Health - U65_d'
      storage(
        'session',
        'set',
        'tcpaDefaultsOnFail',
        JSON.stringify({ tyPageContent: null, TcpaType: tcpaTypeHI, TcpaContent: 'FE Default' })
      )
      $('#tcpa').html(
        '<div class="privacy_rights well" id="srDisclosure"><input id="leadid_tcpa_disclosure" type="hidden" /> <label for="leadid_tcpa_disclosure">By clicking the button above, you are providing your electronic signature in which you consent, acknowledge and agree to the following: (a) our <a href="/rmp-tos.html" target="_blank">Terms of Service</a> and <a href="/rmp-privacy.html" target="_blank">Privacy Policy</a>, including our arbitration provision. (b) You are providing express written consent to share your information with RateMarketplace, and up to <a href="/HealthPartners.html" target="_blank">5 Insurance Partners</a> that may contact you about their products or services. (c) You give consent (consent not required as a condition to purchase a good/service) for us, or them and authorized third parties calling on our, or their behalf to contact you for marketing purposes through automated means (e.g. automatic telephone dialing system, text messages, artificial and pre-recorded messaging) at the phone number(s) and at the email address you have provided via telephone, mobile device (including SMS and MMS) and/or email, even if your telephone number is currently listed on any state, federal or corporate Do Not Call registry. You may opt-out from SMS or Text messages at any time by replying STOP. Data and Msg rates may apply. As an alternative, you may contact us by email at: <a href="mailto:customercare@ratemarketplace.com">customercare@ratemarketplace.com</a>. You understand that you may revoke this consent at any time. Agents are not affiliated with or endorsed by the U.S. government, the Health Insurance Marketplace or any federal Medicare program.</label></div>'
      )
      $('#tcpaValue').val(tcpaTypeHI)
    } else if (isHomeAlarm) {
      // needs to fire before the isInsurance block since some sites are both.
      let tcpaTypeHA = 'Home Alarm - HS_d'
      storage(
        'session',
        'set',
        'tcpaDefaultsOnFail',
        JSON.stringify({ tyPageContent: null, TcpaType: tcpaTypeHA, TcpaContent: 'FE Default' })
      )
      $('#tcpa').html(
        '<div class="privacy_rights well" id="srDisclosure"><input id="leadid_tcpa_disclosure" type="hidden" /> <label for="leadid_tcpa_disclosure">By clicking the button above, you are providing your electronic signature in which you consent, acknowledge and agree to the following: (a) our <a href="/rmp-tos.html" target="_blank">Terms of Service</a> and <a href="/rmp-privacy.html" target="_blank">Privacy Policy</a>, including our arbitration provision. (b) You are providing express written consent to share your information with RateMarketplace, and up to <a href="/ServicePartners.html" target="_blank">4 home service and solar professionals</a> or authorized third parties calling on our, or their behalf who may contact you about their products and services. (c) You give consent (consent not required as a condition to purchase a good/service) for them/us to contact you through automated means, for marketing purposes at the phone number(s) and at the email address you have provided (e.g. automatic telephone dialing system, text, artificial or pre-recorded messaging) via telephone, mobile device (including SMS and MMS) and/or email, even if your telephone number is currently listed on any state, federal or corporate Do Not Call registry. You may opt-out from SMS or Text messages at any time by replying STOP. Data and Msg rates may apply. As an alternative, you may contact us by email at: <a href="mailto:customercare@ratemarketplace.com">customercare@ratemarketplace.com</a>. You understand that you may revoke this consent at any time.</label></div>'
      )
      $('#tcpaValue').val(tcpaTypeHA)
    } else if (isMedicare) {
      let tcpaTypeMC = 'Medicare_d'
      storage(
        'session',
        'set',
        'tcpaDefaultsOnFail',
        JSON.stringify({ tyPageContent: null, TcpaType: tcpaTypeMC, TcpaContent: 'FE Default' })
      )
      $('#tcpa').html(
        '<div class="privacy_rights well" id="srDisclosure"><label><input id="leadid_tcpa_disclosure_rmp" type="hidden" /> By clicking the button above you are providing your electronic signature in which you consent, acknowledge and agree to the following: (a) our <a href="/rmp-tos.html" target="_blank">Terms of Service</a> and <a href="/rmp-privacy.html" target="_blank">Privacy Policy</a>. (b) You are providing express written consent to share your information with RateMarketplace, and up to <a href="/HealthPartners.html" target="_blank">5 insurance professionals</a> that we may connect you with. (c) You give consent (consent not required as a condition to purchase a good/service) for them, us, or third parties calling on behalf of those professionals to contact you through automated means at the phone number(s) and at the email address you have provided (e.g. autodialing, text and pre-recorded messaging) via telephone, mobile device (including SMS and MMS) and/or email, even if your telephone number is currently listed on any state, federal or corporate Do Not Call registry. You may opt-out from SMS or Text messages at any time by replying STOP. Data and Msg rates may apply. As an alternative, you may contact us by email at: <a href="mailto:customercare@ratemarketplace.com">customercare@ratemarketplace.com</a>. You understand that you can revoke this consent at any time. Agents are not connected with or endorsed by the U.S. government or the federal Medicare program. </label></div>'
      )
      $('#tcpaValue').val(tcpaTypeMC)
    } else if (isHomeServices) {
      let tcpaTypeHS = 'Home Services_d'
      storage(
        'session',
        'set',
        'tcpaDefaultsOnFail',
        JSON.stringify({ tyPageContent: null, TcpaType: tcpaTypeHS, TcpaContent: 'FE Default' })
      )
      $('#tcpa').html(
        '<div class="privacy_rights well" id="srDisclosure"><input id="leadid_tcpa_disclosure" type="hidden" /> <label for="leadid_tcpa_disclosure">By clicking the button above, you are providing your electronic signature in which you consent, acknowledge and agree to the following: (a) our <a href="/rmp-tos.html" target="_blank">Terms of Service</a> and <a href="/rmp-privacy.html" target="_blank">Privacy Policy</a>, including our arbitration provision. (b) You are providing express written consent to share your information with RateMarketplace, and up to <a href="/ServicePartners.html" target="_blank">4 home service and solar professionals</a> or authorized third parties calling on our, or their behalf who may contact you about their products and services. (c) You give consent (consent not required as a condition to purchase a good/service) for them/us to contact you through automated means, for marketing purposes at the phone number(s) and at the email address you have provided (e.g. automatic telephone dialing system, text, artificial or pre-recorded messaging) via telephone, mobile device (including SMS and MMS) and/or email, even if your telephone number is currently listed on any state, federal or corporate Do Not Call registry. You may opt-out from SMS or Text messages at any time by replying STOP. Data and Msg rates may apply. As an alternative, you may contact us by email at: <a href="mailto:customercare@ratemarketplace.com">customercare@ratemarketplace.com</a>. You understand that you may revoke this consent at any time.</label></div>'
      )
      $('#tcpaValue').val(tcpaTypeHS)
    } else if (isInsurance) {
      let tcpaTypeINS = 'Insurance_d'
      storage(
        'session',
        'set',
        'tcpaDefaultsOnFail',
        JSON.stringify({ tyPageContent: null, TcpaType: tcpaTypeINS, TcpaContent: 'FE Default' })
      )
      $('#tcpa').html(
        '<div class="privacy_rights well" id="srDisclosure"><input id="leadid_tcpa_disclosure" type="hidden" /> <label for="leadid_tcpa_disclosure">By clicking the "See My Results" button above, you are providing your electronic signature in which you consent, acknowledge and agree to the following: (a) our <a href="/rmp-tos.html" target="_blank">Terms of Service</a> and <a href="/rmp-privacy.html" target="_blank">Privacy Policy</a>, including our arbitration provision. (b) You are providing express written consent to share your information with RateMarketplace, and up to <a href="/ServicePartners.html" target="_blank">5 Industry Partners</a>, or authorized third parties calling on our, or their behalf who may contact you for marketing purposes. (c) You give consent (consent not required as a condition to purchase a good/service) for them/us to contact you through automated means at the phone number(s) and at the email address you have provided (e.g. automatic telephone dialing system, text, artificial or pre-recorded messaging) via telephone, mobile device (including SMS and MMS) and/or email, even if your telephone number is currently listed on any state, federal or corporate Do Not Call registry. You may opt-out from SMS or Text messages at any time by replying STOP. Data and Msg rates may apply. As an alternative, you may contact us by email at: <a href="mailto:customercare@ratemarketplace.com">customercare@ratemarketplace.com</a>. You understand that you may revoke this consent at any time.</label></div>'
      )
      $('#tcpaValue').val(tcpaTypeINS)
    } else {
      let tcpaTypeDefault = 'RMP_d'
      storage(
        'session',
        'set',
        'tcpaDefaultsOnFail',
        JSON.stringify({ tyPageContent: 'tel-thankyou', TcpaType: tcpaTypeDefault, TcpaContent: 'FE Default' })
      )
      $('#tcpa').html(
        '<div class="privacy_rights well" id="srDisclosure"><label><input id="leadid_tcpa_disclosure_rmp" type="hidden" />By clicking &quot;See My Results&quot;, you are providing express written consent to the <a href="/rmp-tos.html" target="_blank">Terms of Service</a> and <a href="/rmp-privacy.html" target="_blank">Privacy Policy</a>, to share your information with RateMarketplace, up to 5 <a href="/generalPartners.html" target="_blank">lenders</a> with whom you have been matched and/or other <a href="/generalPartners.html" target="_blank">business partners</a> and consent (not required as a condition to purchase a good/service) for them to contact you through automated means (e.g. autodialing, text and pre-recorded messaging) via telephone, mobile device (including SMS and MMS) and/or email, even if it is a cellular phone number or other service for which the called person(s) could be charged for such call and even if your telephone number is currently listed on any state, federal or corporate Do Not Call registry. You may opt-out from SMS or Text messages at any time by replying STOP. As an alternative, you may contact us by email at customercare@ratemarketplace.com.</label></div>'
      )
      $('#tcpaValue').val(tcpaTypeDefault)
    }

    // commented out until LMB takes leads again
    /*    } else {
      let tcpaTypeDefault = 'LMB_d'
      storage(
        'session',
        'set',
        'tcpaDefaultsOnFail',
        JSON.stringify({ tyPageContent: 'tel-thankyou', TcpaType: tcpaTypeDefault, TcpaContent: 'FE Default' })
      )
      $('#tcpa').html(
        '<div id="srDisclosure" class="privacy_rights well"><div id="disclosure"><label><input type="hidden" id="leadid_tcpa_disclosure_lmb"><p>By clicking the button above, you express your understanding and consent, electronically via E-sign, to the following:</p><p>1. To be matched with, and contacted by, up to 5 participants in the <a href="https://www.lowermybills.com/lending-images/lmb_provider_network.html" target="_blank">LMB Provider Network</a> about mortgage and financial services products, and consent (not required as a condition to purchase a good/service) for us and them to contact you (including through automated or prerecorded means) via telephone at the phone number provided above, on mobile devices (including SMS and MMS), and email, even if you are on a corporate, state or national Do Not call Registry. As an alternative, you may contact us by email at <a href="mailto:customercare@coredigital.com">customercare@coredigital.com</a>.</p><p>2. To the LMB Lending <a href="https://www.lowermybills.com/legal/terms" target="_blank">Terms of Use</a>, <a href="https://www.lowermybills.com/legal/privacy" target="_blank">Privacy Policy</a>, and Consent to Doing Business Electronically.</p><p>3. And that as a condition of such consent, you are providing express Written Instructions (as defined under applicable law(s)) to LMB to utilize your information in order to reference your consumer credit report for the purpose of validating your self-reported information. Matched Providers will contact you directly to discuss their financial services and products, and to gather additional information, in order to best service your request for information and products.</p><p>4. Additionally, if selected above, you consent to be matched to up to an additional 3 providers about solar services, home improvement services, and home insurance services, and consent (not required as a condition to purchase a good/service) for us and them to contact you (including through automated or prerecorded means) via telephone at the phone number provided above, on mobile devices (including SMS and MMS), and email, even if you are on a corporate, state or national Do Not call Registry. As an alternative, you may contact us by email at <a href="mailto:customercare@coredigital.com">customercare@coredigital.com</a>.</p></label></div></div>'
      )
      $('#tcpaValue').val(tcpaTypeDefault)
      $('#lmbDisclosure').html(
        '<div id="footer"> Data is collected by the owner of this site on behalf of Lower My Bills.<div id="links"><a href="https://www.lowermybills.com/index.php#about" target="_blank" name="&amp;lid=Footer+-+About+Us">About Us</a> <small>•</small> <a href="https://www.themuse.com/jobs?company=Core Digital Media" target="_blank">Careers</a> <small>•</small> <a href="https://www.lowermybills.com/misc/for-lenders.php" target="_blank" name="&amp;lid=Footer+-+For+Lenders">For Lenders</a> <small>•</small> <a href="https://www.lowermybills.com" target="_blank" onclick="lmb.util.openUnsubscribeForm();" name="&amp;lid=Footer+-+Unsubscribe">Unsubscribe</a> <small>•</small> <a href="https://www.lowermybills.com" target="_blank" name="&amp;lid=Footer+-+Home">Home</a> <small>•</small> <a href="https://www.lowermybills.com/legal/terms.php" target="_blank">Terms of Use</a> <small>•</small> <a href="https://www.lowermybills.com/legal/privacy.php" target="_blank" name="&amp;lid=Footer+-+Privacy">Privacy</a> <small>•</small> <a href="https://www.lowermybills.com/legal/licenses.php" target="_blank" name="&amp;lid=Footer+-+Licenses">Licenses &amp; Disclosures</a> <small>•</small> <a href="https://www.lowermybills.com/legal/ad-targeting.php" target="_blank" name="&amp;lid=Footer+-+DataUsage">Ad Targeting Policy</a> </div> <div id="copyright">© 2000-2018 LowerMyBills, Inc. <a href="http://www.nmlsconsumeraccess.org/" target="_blank">NMLS</a> ID 167283 All Rights Reserved. Patent Pending. 4859 W Slauson Ave #405, Los Angeles, CA 90056</div> </div>'
      )
      $('#lmbDisclosure').show()
    } */
    $('#disclosure-form').show()
    $('#tcpa').show()
    $('.submit-button').prop('disabled', false)
    $('.submit-button-translate').prop('disabled', false)

    return
  }

  var payload = JSON.parse(body.Payload),
    submitBtnText,
    submitBtnArray = ['lendingtree', 'rates_marketplace', 'reallygreatrate', 'revi', 'HomeAlarm - SS'],
    tcpa = payload.TcpaType,
    verbiage = payload.TcpaContent,
    splitBuyerPayload = {
      SplitScenarioId: payload.SplitScenarioId,
      SplitScenarioName: payload.SplitScenarioName,
      BuyerGroupId: payload.BuyerGroupId,
      BuyerGroupName: payload.BuyerGroupName,
      Scenario: payload.Scenario,
      TierLevel: payload.TierLevel,
      tyPageContent: payload.ThankYouPageURL,
      BuyerId: payload.BuyerId,
      BuyerName: payload.BuyerName,
      BuyerGroupCurrentCount: payload.BuyerGroupCurrentCount,
      BuyerGroupFilter: payload.BuyerGroupFilter,
      BuyerGroupDailyCap: payload.BuyerGroupDailyCap,
      BuyerGroupContractId: payload.BuyerGroupContractId,
      SplitScenarioOrdinal: payload.SplitScenarioOrdinal,
      TcpaId: payload.TcpaId,
      TcpaType: payload.TcpaType,
      AffiliateAssociation: storage('session', 'get', 'AffiliateAssociation') || '',
      scbc: scbc,
    }

  if (tcpa && verbiage) {
    $('#tcpa').html(verbiage)
    $('.tcpa-topmort').html(verbiage)
    $('#tcpaValue').val(tcpa)

    // if the tcpaType is in the submitBtnArray then perform the text update based on the switch case values
    if (submitBtnArray.indexOf(tcpa) !== -1) {
      switch (tcpa) {
        case 'lendingtree':
          submitBtnText = 'View My Rates'
          break
        case 'rates_marketplace':
          submitBtnText = 'See My Results'
          break
        case 'reallygreatrate':
          submitBtnText = 'SUBMIT'
          break
        case 'revi':
          submitBtnText = 'Get My Quotes'
          break
        case 'HomeAlarm - SS':
          submitBtnText = 'Submit'
          break
        default:
          break
      }

      $('.submit-button').text(submitBtnText)
    }

    //get rid of leadpoints scripts if they aren't the buyer
    if (tcpa !== 'LeadPoint' && tcpa !== 'QuinStreet') {
      $('head script[src*="GTM-KCMVZ6"]').remove()
      $('#leadpointWrapper').remove()
      $('#leadiDCode').remove()
      $('#srScript').remove()
      $('#disclosureScript').remove()
      $('input[name="SR_TOKEN"]').remove()
    }
    //lmb has some extra stuff they need us to load in
    if (tcpa === 'LMB' || tcpa === 'LMB_x' || tcpa === 'LMB_d' || tcpa === 'granthood_lmb' || tcpa === 'LMB_quicken') {
      $('#lmbDisclosure').html(lmbDisclosureText)
      $('#lmbDisclosure').show()
    }

    if (
      payload.SplitScenarioId ||
      payload.SplitScenarioName ||
      payload.BuyerGroupId ||
      payload.BuyerGroupName ||
      payload.Scenario ||
      payload.TierLevel ||
      payload.tyPageContent ||
      payload.BuyerId ||
      payload.BuyerName ||
      payload.BuyerGroupCurrentCount ||
      payload.BuyerGroupFilter ||
      payload.BuyerGroupDailyCap ||
      payload.BuyerGroupContractId ||
      payload.SplitScenarioOrdinal ||
      payload.TcpaId ||
      payload.TcpaType ||
      scbc
    ) {
      storage('session', 'set', 'splitBuyerPayload', JSON.stringify(splitBuyerPayload))
    }

    if (verbiage.length < 400) {
      const alertUrl = 'https://hooks.slack.com/services/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'
      const reason = 'TCPA Length is only ' + verbiage.length + ', this may indicate an issue.'

      sendAlertToSlack(tcpa, reason, alertUrl)
    }
  }

  $('#disclosure-form').show()
  $('#tcpa').show()
  $('.submit-button').prop('disabled', false)
  $('.submit-button-translate').prop('disabled', false)

  // triggers the auto scroll on tcpa function after tcpa has loaded
  autoScrollTCPA()

  //blurred rates
  if ($('.ads-wrapper').length != 0 && window.screen.width > 801) {
    $('.ads-wrapper').show()
    $('#v-container').addClass('shadow')
    $('#v-container').removeClass('container-overlay')
  }

  // only run partial save after the TCPA call is complete.
  doPartialSave(current_form)
}

/**
 * Handles payability check and returns object of various items
 * -- @param {boolean} payable
 * -- @param {string} pixels
 * -- @param {boolean} throttled
 * -- @param {string} throttle_id
 * @param  {object} formJson
 * @param  {boolean} requiresTranslation
 */

doPayable = function (formJson, requiresTranslation) {
  const campaignKey = storage('session', 'get', 'campaignId')
  if (current_form.posting === true) return

  // set to true so subsequent clicks can't post
  current_form.posting = true

  var validationData = []
  $('fieldset:visible')
    .find('.input')
    .each(function () {
      var valType = this.dataset.validation
      validationData.push(valType)
    })

  if (validate(validationData) === false) {
    current_form.posting = false
    $('.submit-button').prop('disabled', false)
    $('.submit-button-translate').prop('disabled', false)
    return
  }

  // parse bad characters and add alphanumerics to address, first and last name
  inputValOnSubmit()

  //determine payability
  if (campaignKey && campaignKey != '') {
    payAbility()
  } else {
    if (!formJson) {
      formJson = current_form.form
    }

    if (isGetLastSignUp) {
      getLastSignUp(formJson, requiresTranslation)
    } else {
      current_form.postLead(formJson, requiresTranslation)
    }
  }
  $('.submit-button').prop('disabled', true)
  $('.submit-button-translate').prop('disabled', true)
}

/**
 * This module handles building http request to the rules engine
 */

var url,
  formData,
  successFunction,
  requestData,
  hardCodedSCBC,
  userIp,
  envToggle,
  envToggle2,
  v2ExternalAuthkey,
  tcpaSize,
  cpid = getParameterByName('cpid'),
  allFormData

// sets staging key and envToggle if this param exists in the URL
if (getParameterByName('stage') === '1') {
  envToggle = '-stage'
  v2ExternalAuthkey =
    'dkZtbzd4cUY5NllNTWhZVmFmTEtZWHZNQ0N3dHBVaGJEUmhwMGFFVjM1TmtiYmpxdDdWRFdZTllVYWw0Qjdab1k3STQ5c2VBYjBSY0tLdmxkRjlzOWRFb0RKVWF6SlU1ZmlNZFNvcUJjVWxnSHVPS285YTU4cXA1MmQwMFhFTFNmVjZsOFJUelo3UW8yaWhUNUt2enNaN3ozUWt5eDBuWEpUQXZ5bkxYcWxnQWFBQ1Q2aDRO'
} else if (getParameterByName('dev') === '1') {
  envToggle = '-default'
  v2ExternalAuthkey =
    'dkZtbzd4cUY5NllNTWhZVmFmTEtZWHZNQ0N3dHBVaGJEUmhwMGFFVjM1TmtiYmpxdDdWRFdZTllVYWw0Qjdab1k3STQ5c2VBYjBSY0tLdmxkRjlzOWRFb0RKVWF6SlU1ZmlNZFNvcUJjVWxnSHVPS285YTU4cXA1MmQwMFhFTFNmVjZsOFJUelo3UW8yaWhUNUt2enNaN3ozUWt5eDBuWEpUQXZ5bkxYcWxnQWFBQ1Q2aDRO'
} else {
  envToggle = ''
  v2ExternalAuthkey =
    'a3Njd21WcU5rNTJXRG1hcnByemZlcWdCaERDMjB3RkVLekdXekNtc0loSjdGdFhoTUkzZlZhYzNNYVBpVHlYeHp4TU5mRTJuRkdXN2dpNnhxZXFyM2t0dVhNS1l3RFpVS1ZIU2hLQklRUFpPRGZXbmViMnlJcDRQRGMwVDNlMEJyQ3dMYm5QZmRoYm5LZXExemczVkxrTWZhMVBGVXNPdlpYaEJzTEwxTVdWa05SRml2OGRX'
}

// calls rulesengine to determine if the user should be redirected based on certain criteria.  This fires after the employment step
function doVetsU() {
  if (!cpid) {
    cpid = null
  }

  var url = 'https://external' + envToggle + '.printfinger.tech:7105/api/CheckRules',
    formData = current_form.form.serialize(),
    buildTheLead = buildLead(formData, false),
    otherData = {
      activity: 'VeteransUnitedRedirect',
      site_name: window.location.hostname,
      campaignId: cpid,
      RequestId: requestId(),
      creative: getParameterByName('c') || '',
    },
    requestData = $.extend(buildTheLead, otherData)

  successFunction = function (response) {
    if (response == null) {
      return
    }
    if (response.Payload != '' && response.Payload != null && response.Payload != undefined) {
      $('#loading-gif').show()
      $('form').css('display', 'none')
      setTimeout(() => {
        window.location.href = JSON.parse(response.Payload.slice(1, response.Payload.length - 1)).RedirectUrl
      }, 1500)
    }
  }
  sendRequest(requestData, url, successFunction, v2ExternalAuthkey, 'POST', true)
}

// calls rulesengine to determine if we should redirect the user to the website in this payload based on certain criteria.
// overwrites any existing typage sessionStorage if it was populated from the TCPA call.
function doPLP() {
  var url = 'https://external' + envToggle + '.printfinger.tech:7105/api/CheckRules',
    formData = current_form.form.serialize(),
    buildTheLead = buildLead(formData, false),
    requestData = {
      activity: 'PersonalLoansProRedirect',
      SignupPayload: JSON.stringify(buildTheLead),
    },
    successFunction = function (response) {
      if (response == null) {
        return
      }
      if (response.Payload != '' && response.Payload != null && response.Payload != undefined) {
        var resData = JSON.parse(response.Payload)
        if (resData[0].RedirectUrl === '' || resData[0].RedirectUrl === null) {
          return
        } else {
          storage('local', 'set', 'plp', resData[0].RedirectUrl)
        }
      }
    }
  sendRequest(requestData, url, successFunction, v2ExternalAuthkey, 'POST', true)
}
// calls rulesengine to get existing pii based on email
function getLastSignUp(formJson, requiresTranslation) {
  var url = 'https://external' + envToggle + '.printfinger.tech:7105/api/CheckRules',
    formData = current_form.form.serialize(),
    buildTheLead = buildLead(formData, false),
    requestData = {
      activity: 'GetLastSignupForEmail',
      email: buildTheLead.email,
      zipcode: buildTheLead.zipcode,
      SiteVertical: 'Mortgage',
    },
    successFunction = function (response) {
      if (response == null) {
        return
      }
      if (response.Payload != '' && response.Payload != null && response.Payload != undefined) {
        var resData = response.Payload[0]
        $('[name=first_name]').val(resData.first_name)
        $('[name=last_name]').val(resData.last_name)
        $('[name=address]').val(resData.address)
        $('[name=city]').val(resData.city)
        $('[name=state]').val(resData.state)
        $('[name=zipcode]').val(resData.zipcode)
        current_form.postLead(formJson, requiresTranslation)
      }
    }
  sendRequest(requestData, url, successFunction, v2ExternalAuthkey, 'POST', true)
}

// calls rulesengine to get URL to redirect on poor/fair credit.
function offerRedirect(creditRating, tsValue) {
  if (tsValue === undefined) {
    tsValue = ''
  }
  var url = 'https://external' + envToggle + '.printfinger.tech:7105/api/CheckRules',
    uuid = storage('session', 'get', 'scUUID'),
    formData = current_form.form.serialize(),
    buildTheLead = buildLead(formData, false),
    requestData = {
      activity: 'OfferRedirectLink',
      CompanyName: 'QuinStreet',
      SignupPayload: JSON.stringify(buildTheLead),
    },
    doOfferRedirect = function (doPopUnder, site) {
      if (doPopUnder) {
        storage('session', 'set', 'qsq', site)
        openTabUnder(site)
      }
      setTimeout(() => {
        window.location.href = '/lb-BCR.html?credit_rating=' + creditRating + trafficSource() + tsValue
      }, 1000)
    },
    successFunction = function (res) {
      const response = JSON.parse(res)
      if (response == null) {
        doOfferRedirect(false, null)
      } else if (
        response.Payload !== '' &&
        response.Payload !== null &&
        response.Payload != undefined &&
        response.Payload !== 'null'
      ) {
        var resData = JSON.parse(response.Payload)
        if (resData[0].RedirectUrl === '' || resData[0].RedirectUrl === null) {
          doOfferRedirect(false, null)
        } else {
          doOfferRedirect(true, resData[0].RedirectUrl)
        }
      } else {
        doOfferRedirect(false, null)
      }
    }
  sendSyncRequest(requestData, url, successFunction, v2ExternalAuthkey, uuid, 'POST')
}

function getElectricProviders(status, currentState) {
  var url = 'https://external' + envToggle + '.printfinger.tech:7105/api/CheckRules',
    requestData = {
      activity: 'GetElectricalProviderForState',
      state: currentState,
    },
    successFunction = function (response) {
      $('#ec_dropdown').empty().addClass('input')
      if (response && response.Payload != '' && response.Payload != null && response.Payload != undefined) {
        var resData = response.Payload
        $('#ec_dropdown').append(`
                    <option selected disabled>Select One:</option>
                `)
        resData.map((val) => {
          $('#ec_dropdown').append('<option value="' + val.ProviderName + '">' + val.ProviderName + '</option>')
          $('#electricProvider').hide()
          $('#ec_dropdown').show()
        })
      } else {
        $('#electricProvider').show()
        // .addClass('input')
        $('#ec_dropdown').val('').hide().removeClass('input')
      }
    }
  if (status === true) {
    sendRequest(requestData, url, successFunction, v2ExternalAuthkey, 'POST', true)
  } else {
    $('#electricProvider').val('').show().addClass('input')
    $('#ec_dropdown').val('').hide().removeClass('input')
    console.log('request failed')
  }
}

/* checks db for pertaining zips offered for solar content
 * @param  {string} zipCode
 * @param  {function} callback
 */
function solarZipCheck(status, state, zipCode) {
  var url = 'https://external' + envToggle + '.printfinger.tech:7105/api/CheckRules',
    requestData = {
      activity: 'GetSolarZipCode',
      ZipCode: zipCode,
    },
    successFunction = function (response) {
      if (response && response.Payload.ZipExists) {
        const zipExists = response.Payload.ZipExists
        storage('session', 'set', 'IsSolarZip', zipExists)
        stageLog('Set IsSolarZip Storage = ', zipExists)
      } else {
        storage('session', 'set', 'IsSolarZip', false)
        stageLog('Set IsSolarZip Storage = ', false)
      }
      getElectricProviders(status, state)
    }

  sendRequest(requestData, url, successFunction, v2ExternalAuthkey, 'POST', true)
}

/**
 * gets list of current lenders for use in lender frame and uses DROPDOWNS
 */
function doCurrentLenderLookup() {
  let siteVertical = ''
  try {
    if (scData[0].siteVertical === 'VA' || scData[0].siteVertical === 'va') {
      siteVertical = 'va'
    }
  } catch (error) {
    siteVertical = ''
  }
  var lenderData = [
      '1st Liberty',
      'Amerisave Mortgage',
      'Bank of America',
      'Bank of England',
      'BB&T Mortgage',
      'Cal State Funding',
      'Caliber Home Loans',
      'Chase',
      'Citi',
      'CrossCountry Mortgage',
      'Ditech',
      'Fairway Independent Mortgage',
      'Fifth Third Bank',
      'First Choice Loan Services',
      'Freedom Mortgage Corp',
      'JFQ Lending Inc.',
      'LoanCare',
      'loanDepot.com',
      'Merrill Lynch',
      'Morgan Stanley',
      'Mortgage Research Center',
      'Mr. Cooper / Nationstar',
      'Navy Federal Credit Union',
      'New American Funding',
      'NewRez',
      'Ocwen',
      'PennyMac Loan Services',
      'PHH Mortgage',
      'PNC Mortgage',
      'Quicken Loans Inc',
      'Rocket Mortgage',
      'RoundPoint Mortgage',
      'Strong Mortgage',
      'Shellpoint',
      'Sun West Mortgage',
      'SunTrust Mortgage',
      'United Shore Financial Services',
      'United Wholesale Mortgage',
      'USAA Federal Savings Bank',
      'US Bank Home Mortgage',
      'Veterans United',
      'Wells Fargo & Company',
      'Other',
      'No Lender',
      'I Dont Know',
    ],
    vaLenders = [
      '1st Liberty',
      'Amerisave Mortgage',
      'Bank of America',
      'Bank of England',
      'Cal State Funding',
      'Caliber Home Loans',
      'CrossCountry Mortgage',
      'First Choice Loan Services',
      'Flagstar Bank',
      'Freedom Mortgage Corp',
      'JFQ Lending Inc.',
      'LoanCare',
      'loanDepot.com',
      'Merrill Lynch',
      'Morgan Stanley',
      'Mortgage Research Center',
      'Navy Federal Credit Union',
      'New Day Financial',
      'NewRez',
      'PennyMac Loan Services',
      'PHH Mortgage',
      'Quicken Loans Inc',
      'Rocket Mortgage',
      'Shellpoint',
      'Strong Mortgage',
      'Sun West Mortgage',
      'United Shore Financial Services',
      'United Wholesale Mortgage',
      'USAA Federal Savings Bank',
      'Veterans United',
      'Wells Fargo & Company',
      'Other',
      'No Lender',
      'I Dont Know',
    ],
    url = `https://external${envToggle}.printfinger.tech:7106/api/GetCurrentLenders/${siteVertical}`,
    successFunction = function (res) {
      if (res !== null) {
        if (res.Payload !== null || res.Payload !== '') {
          lenderData = res.Payload.map((ele) => `<option value="${ele.LenderName}">${ele.LenderName}</option>`)
        } else if (siteVertical === 'va' || siteVertical === 'VA') {
          lenderData = vaLenders.map((ele) => `<option value="${ele}">${ele}</option>`)
        } else {
          lenderData = lenderData.map((ele) => `<option value="${ele}">${ele}</option>`)
        }
      } else if (siteVertical === 'va' || siteVertical === 'VA') {
        lenderData = vaLenders.map((ele) => `<option value="${ele}">${ele}</option>`)
      } else {
        lenderData = lenderData.map((ele) => `<option value="${ele}">${ele}</option>`)
      }

      $('select[name="current_lender"]').empty().html('<option value="" disabled selected>Choose One:</option>')

      $('select[name="current_lender"]').append(lenderData)

      // for use with prepop
      try {
        let cl = ''
        const prepopCL = getParameterByName('current_lender')
        const { current_lender } = JSON.parse(storage('local', 'get', 'formData'))

        // checks for current_lender in the URL if it exists use it's value for the selected cl value
        prepopCL ? (cl = prepopCL) : ''

        // checks for current_lender in localStorage if it exists use it's value for the selected cl value
        current_lender ? (cl = current_lender) : ''

        // update the value and trigger the onChange method
        $('select[name="current_lender"]').val(decodeURIComponent(cl)).change()
      } catch (error) {
        // do nothing
      }
    }

  sendRequest(null, url, successFunction, v2ExternalAuthkey, 'GET', true)
}

// Performs tcpa call to determine buyer and return verbiage
function doTCPA() {
  var formData = current_form.form.serialize(),
    requestData = buildLead(formData, false),
    url = 'https://external' + envToggle + '.printfinger.tech:7105/api/BuyerTcpa/CheckRules',
    scbc = getParameterByName('scbc'),
    siteNameOverride = getParameterByName('cakekiller'),
    siteName,
    addScbc,
    tcpaType = ''

  // gets the current time on form and passes it to CheckRules TCPA
  timeTracker.lap()

  if (siteNameOverride === 'nikki') {
    siteName = 'sctest.com'
  } else {
    siteName = window.location.hostname
  }
  var otherData = {
    site_name: siteName,
    tcpa: tcpaType || '',
    time_on_form: storage('session', 'get', 'tcpaTime') || 0,
  }

  // only runs on err dot rmp dot com and offer 2222
  if (uniqueSiteName !== null) {
    otherData.site_name = uniqueSiteName
  }

  // checks if scbc param exists and if so pass only that to get our tcpa payload.  If no param and the scbc is hardcoded in custom.js then use that instead
  if (scbc && scbc != '') {
    addScbc = {
      scbc: parseInt(scbc),
    }
  } else if (requestData && requestData.employer === 'unemployed') {
    addScbc = {
      scbc: 1,
    }
  } else if (hardCodedSCBC != null && hardCodedSCBC != undefined && hardCodedSCBC != '') {
    addScbc = {
      scbc: hardCodedSCBC,
    }
  } else {
    addScbc = {
      scbc: null,
    }
  }

  requestData = $.extend(addScbc, requestData, otherData)

  successFunction = function (response) {
    // run assignTCPA function
    assignTCPA(response, addScbc.scbc)

    //calculate TCPA height to use for styling
    tcpaSize = $('#tcpa').height()

    // does call to get TY page redirect URL if it meets the criteria

    // TODO: FEDP-1867: Temp disable of plp
    // doPLP()
  }
  sendRequest(requestData, url, successFunction, v2ExternalAuthkey, 'POST', true)
}

/**
 * this function sends the persistant logging information to our logging API
 * activity = the backend "bucket" to put this data into
 * payload = the data you want to send to the db
 * errorLog = any error logs we want the db to collect
 * @param {*} activity
 * @param {*} payload
 * @param {*} errorLog
 */
function scLogging(activity, payload, errorLog) {
  const url = 'https://external' + envToggle + '.printfinger.tech:7104/api/FrontEndLog'
  const dateString = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '')

  if (payload === false) {
    payload = { fullURL: window.location.href }
  }
  if (errorLog === false) {
    errorLog = ''
  } else {
    errorLog = JSON.stringify(errorLog)
  }

  successFunction = function (res) {
    if (res) {
      console.log('Response = ' + res)
    }
  }
  var requestData = {
    Activity: activity,
    Payload: JSON.stringify(payload),
    RequestId: requestId(),
    SiteName: window.location.hostname,
    CreatedDate: dateString,
    DisclosureError: errorLog,
  }

  sendRequest(requestData, url, successFunction, v2ExternalAuthkey, 'POST', true)
}

/**
 * this takes the current forms data and format it to be sent to the partial save endpoint
 * @param {*} current_form
 */
function doPartialSave(current_form) {
  var url = 'https://external' + envToggle + '.printfinger.tech:7113/Add',
    formData = current_form.form.serialize(),
    allFormData = buildLead(formData, false)

  if (formData !== null && formData !== undefined && formData !== '') {
    successFunction = function (response) {
      // console.log(response)
    }
    var requestData = {
      RequestId: requestId(),
      SiteName: window.location.hostname,
      EmailAddress: allFormData.email,
      PhoneNumber: allFormData.phone_primary,
      Payload: allFormData,
    }

    sendRequest(requestData, url, successFunction, v2ExternalAuthkey, 'POST', true)
  }
}

function findMakeAndModel(isSecondary, getInfo, year, make) {
  let urlParam = 'GetYears'
  let vehicleNumber = ''
  if (isSecondary) {
    vehicleNumber = '2'
  }

  if (getInfo === 'GetMakesByYear') {
    urlParam = `GetMakesByYear?year=${year}`
  } else if (getInfo === 'GetModelsByYearAndMake') {
    urlParam = `GetModelsByYearAndMake?year=${year}&make=${make}`
  }

  var url = 'https://external' + envToggle + '.printfinger.tech:7118/api/Auto/' + urlParam

  successFunction = function (response) {
    if (getInfo === 'GetYears') {
      // if no years then render error
      if (response && response.length) {
        $('#VehicleYear' + vehicleNumber)
          .html('<option selected disabled>Please Select One:</option>')
          .append(
            response.map(function (v) {
              return $('<option/>', {
                value: v,
                text: v,
              })
            })
          )
      } else {
        $('#VehicleYear' + vehicleNumber).html(
          '<p style="color: #ff0000; font-style: italic; font-weight: 800; text-align: center; font-size: 14px; margin-bottom: 15px;">There was an issue retreiving vehicle years, please go back and try again.</p>'
        )
      }
    } else if (getInfo === 'GetMakesByYear') {
      // if no makes then render error
      if (response && response.length) {
        $('#VehicleMake' + vehicleNumber)
          .html('<option selected disabled>Please Select One:</option>')
          .append(
            response.map(function (v) {
              return $('<option/>', {
                value: v,
                text: v,
              })
            })
          )
        $('#VehicleModel' + vehicleNumber).html('')
      } else {
        $('#VehicleMake' + vehicleNumber).html(
          '<p style="color: #ff0000; font-style: italic; font-weight: 800; text-align: center; font-size: 14px; margin-bottom: 15px;">Sorry, No makes for that year, please go back and try again.</p>'
        )
        $('#VehicleModel' + vehicleNumber).html('')
      }
    } else if (getInfo === 'GetModelsByYearAndMake') {
      // if no models then render error
      if (response && response.length) {
        $('#VehicleModel' + vehicleNumber)
          .html('<option selected disabled>Please Select One:</option>')
          .append(
            response.map(function (v) {
              return $('<option/>', {
                value: v,
                text: v,
              })
            })
          )
      } else {
        $('#VehicleModel' + vehicleNumber).html(
          '<p style="color: #ff0000; font-style: italic; font-weight: 800; text-align: center; font-size: 14px; margin-bottom: 15px;">Sorry, No models for that make, please go back and try again.</p>'
        )
      }
    }
  }

  sendRequest(null, url, successFunction, v2ExternalAuthkey, 'GET', true)
}
function findMakeAndModelMobile(isSecondary, getInfo, year, make) {
  let urlParam = 'GetYears',
    vehicleNumber = '',
    idAppend = ''
  if (isSecondary) {
    vehicleNumber = '2'
    idAppend = '-b'
  }
  if (getInfo === 'GetMakesByYear') {
    urlParam = `GetMakesByYear?year=${year}`
  } else if (getInfo === 'GetModelsByYearAndMake') {
    urlParam = `GetModelsByYearAndMake?year=${year}&make=${make}`
  }

  var url = 'https://external' + envToggle + '.printfinger.tech:7118/api/Auto/' + urlParam

  successFunction = function (response) {
    if (getInfo === 'GetYears') {
      // if no years then render error
      if (response && response.length) {
        $('#VehicleYearMobile' + vehicleNumber)
          .empty()
          .append(
            response.reverse().map(function (v) {
              return $(
                `<input type="radio" name="VehicleYear${vehicleNumber}" id="${v}${idAppend}" value="${v}"/><label for="${v}${idAppend}" class="mobileButton selection-button yearButton">${v}</label>`
              )
            })
          )
      } else {
        $('#VehicleYearMobile' + vehicleNumber).html(
          '<p style="color: #ff0000; font-style: italic; font-weight: 800; text-align: center; font-size: 14px; margin-bottom: 15px;">There was an issue retreiving vehicle years, please go back and try again.</p>'
        )
      }
    } else if (getInfo === 'GetMakesByYear') {
      // if no makes then render error
      if (response && response.length) {
        const preloadedMakes = [
          'Chevrolet',
          'Dodge',
          'Ford',
          'Honda',
          'Hyundai',
          'Jeep',
          'Kia',
          'Nissan',
          'Subaru',
          'Toyota',
        ]
        const apiMakes = response.filter((make) => !preloadedMakes.includes(make))
        $('#VehicleModelMobile' + vehicleNumber).empty() // empties model
        $('#VehicleMakeMobileCalled' + vehicleNumber)
          .empty()
          .html('<option selected disabled>Other Models:</option>')
          .append(
            apiMakes.map(function (v) {
              return $('<option/>', {
                value: v,
                text: v,
              })
            })
          )
      } else {
        $('#VehicleMakeMobileCalled' + vehicleNumber).html(
          '<p style="color: #ff0000; font-style: italic; font-weight: 800; text-align: center; font-size: 14px; margin-bottom: 15px;">Sorry, No makes for that year, please go back and try again.</p>'
        )
      }
    } else if (getInfo === 'GetModelsByYearAndMake') {
      // if no models then render error
      if (response && response.length) {
        $('#VehicleModelMobile' + vehicleNumber)
          .empty()
          .append(
            response.map(function (v) {
              // prettier-ignore
              const id = v.replace(/[^A-Z0-9]+/ig, '')
              return $(
                `<input type="radio" name="VehicleModel${vehicleNumber}" id="${id}${idAppend}" value="${v}"/><label for="${id}${idAppend}" class="mobileButton selection-button modelButton">${v}</label>`
              )
            })
          )
        var maxHeight
        $('.mobileButton:visible').each(function () {
          maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height()
        })
        $('.mobileButton:visible').height(maxHeight)
      } else {
        $('#VehicleModelMobile' + vehicleNumber).html(
          '<p style="color: #ff0000; font-style: italic; font-weight: 800; text-align: center; font-size: 14px; margin-bottom: 15px;">Sorry, No models for that make, please go back and try again.</p>'
        )
      }
    }
  }

  sendRequest(null, url, successFunction, v2ExternalAuthkey, 'GET', true)
}

function assignDisclosures(offerId, reqID) {
  var defaultDisclosure =
      'This site contains partner and affiliate links. Any and all trademarks, logos, and service marks provided herein are registered and/or unregistered Trademarks of their respective owners.  The owners of this site assume no responsibility to you or to any third party for any errors or omissions. Contents of this website are copyrighted property of the owner of this website. This website not a government agency, lender or servicer and is in no way affiliated with any news source.',
    homeServicesDisclosure =
      '<p>This site is a free service to assist homeowners in connecting with local service contractors. All contractors are independent and this site does not warrant or guarantee any work performed. It is the responsibility of the homeowner to verify that the hired contractor furnishes the necessary license and insurance required for the work being performed. All persons depicted in a photo or video in any advertisement associated with this site are actors or models and not contractors affiliated with this site.</p><br/><p>Any service marks, logos, and trademarks (collectively the "Trademarks") displayed are registered and/or unregistered Trademarks of their respective owners.  This site contains affiliate and partner links and may receive compensation for referrals or purchases made through our links. Subject matter within this website are copyrighted property of the owner of this site.  This website and its owner is not responsible for any photographic or typographical errors.</p>',
    // eslint-disable-next-line
    defaultTOU = `<p style="margin-top:3.35pt; margin-right:362.95pt; margin-bottom:.0001pt; margin-left:5.0pt; margin:0in 0in 0.0001pt"><span style="font-size:12pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">TERMS OF USE AGREEMENT</span></span></span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Prior to using this site/services, Grant Hood Marketing (collectively “we”, “us”, “our”, or “the Company “) requires you to review this Terms of Use Agreement (“Agreement”). This Agreement outlines the terms of use applicable to this site/services and the products and services provided through this site.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">By accessing, browsing or using this site/services, through any direct or indirect means or by using the goods, facilities or services offered in, or through this site/services through alternative methods (including, for example, telephone, mail, text, email or facsimile), you accept and agree to be bound by this Agreement and our Privacy Policy then in effect (the terms "Site/services" and "Site/services" include use through these alternative methods).&nbsp;</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:700"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Site/Services&nbsp;</span></span></span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:700"><span style="font-style:normal"><span style="text-decoration:none">This site and services are not intended for use of any individual under 18 years of age. You certify to The Company that:&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38; text-indent:36pt"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">1. You are at least 18 years of age.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38; text-indent:36pt"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">2. You assume full responsibility for the use of this site/service by any minors.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38; margin-left:48px"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">3. That the information you have submitted to us on this site or otherwise, is accurate, complete and that you have not submitted or provided false information to us.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38; margin-left:48px"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">4. Your use of this site/service is subject to all applicable federal, state, and local laws and regulations.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">This site/service is intended for United States residents only. This site/services provides information on home goods products and services for consumer review and allows consumers to request additional information through an inquiry. We are not a lender, debt servicer, debt settlement, real estate company, insurance agent, auto sales company or automotive warranty organization.</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">You understand and agree that if you submit an inquiry on this site:&nbsp;</span></span></span></span></span></span>&nbsp;</p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">1. Your information will be shared and/or purchased by companies who provide such goods and services related to the service or product you have expressed interest in.&nbsp; As a result, different types of businesses may be provided your information and may contact you.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">2. You agree to share your information with these businesses and allow them and us to contact you through automated means; e.g. autodialing, text and pre-recorded messaging, via telephone, mobile device (including SMS and MMS) and/or email. You give permission to be contacted even if your telephone number is currently listed on any state, federal or corporate Do Not Call list. This is not, and is not intended to be, any type of application for any financial product or service. You understand and agree that your consent is not a condition, directly or indirectly of a purchase. Data and message rates may apply. We do not charge you a fee to use this site/services.</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">3. You understand that we do not endorse, warrant, or guarantee the products or services of businesses who may contact you.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">4. Licensed organizations are subject to Federal and State laws and regulations for their practices. Please review the privacy practices of all third parties who contact you. If you have any questions regarding their practices, please contact them directly.&nbsp;</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:700"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">ARBITRATION AGREEMENT AND CLASS ACTION WAIVER</span></span></span></span></span></span></span></span><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">You and we each agree that any and all disputes or claims that have arisen or may arise between you and us relating in any way to or arising out of this or previous versions of this Agreement, your use of or access to our Services, or any Product sold, offered, or purchased through our Services shall be resolved exclusively through final and binding arbitration, rather than in court, except that you may assert claims in small claims court, if your claims qualify. The Federal Arbitration Act governs the interpretation and enforcement of this Agreement to Arbitrate section (this "Agreement to Arbitrate").</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:700"><span style="font-style:normal"><span style="text-decoration:none">Prohibition of Class and Representative Actions and Non-Individualized Relief&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:700"><span style="font-style:normal"><span style="text-decoration:none">YOU AND WE AGREE THAT EACH OF US MAY BRING CLAIMS AGAINST THE OTHER ONLY ON AN INDIVIDUAL BASIS AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE ACTION OR PROCEEDING. UNLESS BOTH YOU AND US AGREE OTHERWISE, THE ARBITRATOR MAY NOT CONSOLIDATE OR JOIN MORE THAN ONE PERSON'S OR PARTY'S CLAIMS, AND MAY NOT OTHERWISE PRESIDE OVER ANY FORM OF A CONSOLIDATED, REPRESENTATIVE, OR CLASS PROCEEDING. ALSO, THE ARBITRATOR MAY AWARD RELIEF (INCLUDING MONETARY, INJUNCTIVE, AND DECLARATORY RELIEF) ONLY IN FAVOR OF THE INDIVIDUAL PARTY SEEKING RELIEF AND ONLY TO THE EXTENT NECESSARY TO PROVIDE RELIEF NECESSITATED BY THAT PARTY'S INDIVIDUAL CLAIM(S). ANY RELIEF AWARDED CANNOT AFFECT OUR OTHER USERS.</span></span></span></span></span></span><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Arbitration Procedures&nbsp;</span></span></span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Arbitration is more informal than a lawsuit in court. There is no judge or jury in arbitration, and court review of an arbitration award is very limited. However, an arbitrator can award the same damages and relief on an individual basis that a court can award to an individual. An arbitrator should apply the terms of this Agreement as a court would.&nbsp;</span></span></span></span></span></span>&nbsp;</p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">The arbitrator, and not any federal, state, or local court or agency, shall have exclusive authority to resolve any dispute arising out of or relating to the interpretation, applicability, enforceability or formation of this Agreement to Arbitrate, any part of it, or of this Agreement including, but not limited to, any claim that all or any part of the Agreement to Arbitrate or this Agreement is void or voidable.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">The arbitration will be conducted by JAMS under its rules and procedures pertaining to Consumer-Related Disputes, as modified by this Agreement to Arbitrate. The arbitration shall be held in a mutually agreed location. If the value of the relief sought is $10,000 or less, you or we may elect to have the arbitration conducted by telephone or based solely on written submissions, which election shall be binding on you and us subject to the arbitrator's discretion to require an in-person hearing, if the circumstances warrant. Attendance at an in-person hearing may be made by telephone by you and/or us, unless the arbitrator requires otherwise.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">The arbitrator will decide the substance of all claims in accordance with the laws of the State of Delaware, including recognized principles of equity, and will honor all claims of privilege recognized by law. The arbitrator shall not be bound by rulings in prior arbitrations involving our other users, but is bound by rulings in prior arbitrations involving the same user to the extent required by applicable law. The arbitrator's award shall be final and binding and judgment on the award rendered by the arbitrator may be entered in any court having jurisdiction thereof.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Costs of Arbitration</span></span></span></span></span></span></span></span><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Payment of all filing, administration and arbitrator fees will be governed by JAMS rules, unless otherwise stated in this Agreement to Arbitrate. You may obtain these costs through JAMS website.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Severability&nbsp;</span></span></span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">With the exception of "Prohibition of Class and Representative Actions and Non-Individualized Relief", if an arbitrator or court decides that any part of this Agreement to Arbitrate is invalid or unenforceable, the other parts of this Agreement to Arbitrate shall still apply. If an arbitrator or court decides that any of the provisions in this Agreement is invalid or unenforceable, then the entirety of this Agreement to Arbitrate shall be null and void. The remainder of the Agreement and any disputes sections will continue to apply and that jurisdiction over and venue of any suit shall be exclusively in the state and federal courts sitting in the County of Arapahoe, state of Colorado.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Changes to the Agreement to Arbitrate</span></span></span></span></span></span></span></span><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Notwithstanding any provision in the Agreement to the contrary, you and we agree that if we make any change to this Agreement to Arbitrate (other than a change to any notice address or site link provided herein) in the future, that change shall not apply to any claim that was filed in a legal proceeding against us prior to the effective date of the change. The change shall apply to all other disputes or claims governed by this arbitration provision that have arisen or may arise between you and us. We will notify you of changes to this Agreement to Arbitrate by posting the amended terms on our Services at least 3 days before the effective date of the changes and/or by email. </span></span></span></span></span></span><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:700"><span style="font-style:normal"><span style="text-decoration:none">THESE TERMS PROVIDE THAT ALL DISPUTES BETWEEN US WILL BE RESOLVED BY BINDING ARBITRATION. YOU GIVE UP YOUR RIGHT TO GO TO COURT TO ASSERT OR DEFEND YOUR RIGHTS. YOU ALSO GIVE UP YOUR RIGHT TO PARTICIPATE IN OR BRING CLASS ACTIONS. YOUR RIGHTS WILL BE DETERMINED BY NEUTRAL ARBITRATORS AND NOT A JUDGE OR JURY.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38">&nbsp;</p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Prohibited Use</span></span></span></span></span></span></span></span><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">You shall not use this site/service for any illegal purpose, including, but not limited to:&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">1. The transmission of any material that is:&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38; margin-left:48px"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">a. unlawful, harmful, harassing, abusive, libelous, racially or ethnically offensive, invasive of another's privacy, vulgar, threatening, obscene, sexually explicit, tortious, defamatory,&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38; margin-left:48px"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">b. or that infringes or may infringe on the intellectual property or rights of another, or in a reasonable person’s view objectionable; directly or indirectly interfere,&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38; margin-left:48px"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">c. or attempt to interfere with the proper working of this site/service or system integrities or securities; interference of any account, </span></span></span></span></span></span><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none"><span style="white-space:pre"> </span></span></span></span></span></span></span><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none"><span style="white-space:pre"> </span></span></span></span></span></span></span></p><p style="line-height:1.38; text-indent:36pt"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">d. or any communication or transaction being conducted on this site/service;&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38; margin-left:48px"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">e. use of any robot, spider, other automatic device, or manual process to monitor or access or copy our web pages or any content without our prior expressed written permission;&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38; margin-left:48px"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">f. or take any action which imposes an unreasonable or disproportionately large load on our infrastructure;&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38; margin-left:48px"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">g. or post, upload, transmit, submit, email or make available by any other means any data or content protected under any law or contractual relationship that you do not have the right to distribute;&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38; margin-left:48px"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">h. or conduct fraud, represent yourself as someone else or hide or attempt to hide your identity;&nbsp;and/or</span></span></span></span></span></span></p><p style="line-height:1.38; text-indent:36pt"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">i. interfere or attempt to interfere with the proper working of this site/service.&nbsp;</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Changes to Site, Terms and Policies&nbsp;</span></span></span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">We reserve the right to change any information, features or functions of our site/services without prior notice.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">1. We may deny you access to the site/services for any reason without prior notice if you engage in any conduct or activities that we determine, in our sole discretion, violate these Terms, our legal rights or the legal rights of any third party or are otherwise inappropriate.</span></span></span></span></span></span>&nbsp;</p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">2. We are not responsible for any errors or delays in providing the site/services whether caused by errors in the registration information you provided by any technical problems in our system.&nbsp;</span></span></span></span></span></span>&nbsp;</p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">3. We reserve the right to make changes to this Agreement and the posted Privacy Policy. Any changes made will be effective from the date of such posting without further notice to you. As such, the Privacy Policy and Terms of Service posted at the time you register on our site/services will govern our relationship for that registration and referral request.&nbsp;</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Electronic Communications&nbsp;</span></span></span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">When you visit our site/services, use our site/services or send email to us, you are communicating with us electronically and you:&nbsp;</span></span></span></span></span></span>&nbsp;</p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">1. Consent to receive communications from us electronically. Although we may choose to communicate with you by regular mail, we may also choose to communicate with you by email or by posting notices on our Services.&nbsp;</span></span></span></span></span></span>&nbsp;</p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">2. Agree that all agreements, notices, disclosures and other communications that we provide to you electronically satisfy any legal requirement that such communications be in writing.&nbsp;</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Anti-Spam Policy&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Spam is strictly against our policies and terms of use, and will result in the immediate deactivation of any partners who are found to have used spam in combination with their advertising agreements.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">The following policy details in specific terms what is considered acceptable use of bulk email/messaging by us:&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Subscriptions Mailing list subscriber information must include:</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">1 The date and time that the subscription was confirmed; and&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">2. The IP address of the subscriber at the time of the confirmation.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">All users must be able to present this information at our request.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">1. The nature of email address use must be fully disclosed, either on the page the subscription is made from or with a prominent link to the site’s Privacy Policy.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">2. It must be made reasonably clear how a user’s email address will be used and in what circumstances it will be shared.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Lists cannot be procured from outside parties unless the email sender has procured a list from an organization that sells or otherwise shares email distribution lists, and all of the following conditions are met:&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">1. The selling organization maintains a publicly viewable privacy policy disclosing that such sales may occur.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">2. The privacy policy is prominently linked to from the page the subscriber signed up from.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">3. The privacy policy has not changed substantially since the user signed up.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">4. Records are kept of the date, time, IP address, and form location where the subscribing user signed up from.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">5. Lists procured from outside parties must have been consistently handled in a manner comparable to our policies.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">6. Users cannot populate lists with addresses obtained for a substantially different purpose than was originally disclosed to the user.&nbsp;</span></span></span></span></span></span>&nbsp;</p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Mailing Practices&nbsp;</span></span></span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">1. Third Parties must not modify the headers of any message in such a way that purposefully obfuscates the origin of the message.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">2. Undeliverable addresses must be removed from all future mailings after no more than five bounces.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">3. All mailings must provide clear and simple to follow instructions for opting-out of future mailings, and all reasonable attempts must be made to facilitate the removal of a mailing list subscriber at their request.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Additionally, Third Parties using outside advertising companies or third party mailing programs must abide by the same policies and practices as those using our own bulk mailing list tools.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Third Parties are responsible for the practices of any affiliate program members they solicit the help of, as if they were hiring an outside advertising agency.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">The user of this website is advised and acknowledges that our electronic mail service equipment may be located in California. In no event shall the user use our equipment in violation of California’s anti-spam laws including California Business &amp; Professions Code sections 17538.4 and 17538.45.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Predominately promotional messages must not be posted to bulletin boards, discussion forums, guestbooks, Usenet newsgroups, or any other similar service unless the operator of that service explicitly allows such messages. In the case of Usenet newsgroups, such messages must be specifically allowed in that group’s charter. Deactivation We reserve the right to cancel a marketing services agreement at any time should it feel there is a reasonable suspicion that marketing partner in violation of these policies and / or engaged in the practice of spamming.&nbsp;</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Copyright and Trademark Notice Information&nbsp;</span></span></span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Our site/services may contain intellectual property owned by us and other parties. Under these terms and the relationship between users and us, we are the sole owner of the site/services and all materials on or available through our site/services including without limitation, all applicable U.S. and non-U.S. copyrights, patents, trademarks, and trade secrets, and other intellectual property rights thereto (collectively “site/services Content”).&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Except as otherwise specifically provided in this Agreement:&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">1. You may not download or save a copy of the site/services Content or any portion thereof, for any purpose; however, you may print a copy of individual screens appearing as part of the site/services Content solely for your personal, non-commercial use or records, provided that our marks, logos or other legends that appear on the copied screens remain on, and are not removed from the printed or stored images of such screens.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Except as otherwise expressly permitted herein, you may not:&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">1. Modify, copy, publish, display, transmit, adapt or in any way exploit any portion of our site/services content unless you first obtain prior written consent from us -- and from all other entities with an interest in the relevant intellectual property. Any unauthorized attempt to modify our site/services Site/services content, to defeat or circumvent our security features, or to utilize our site/services for other than its intended purposes is strictly prohibited.&nbsp;</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">LIMITATION OF LIABILITY</span></span></span></span></span></span></span></span><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">IN NO EVENT WILL WE, OUR PARENTS, SUBSIDIARIES, PARTNERS, AGENTS, AFFILIATES, LICENSORS, SUCCESSORS AND ASSIGNS AND THEIR RESPECTIVE OFFICERS, DIRECTORS, AND EMPLOYEES AND SHAREHOLDERS BE LIABLE TO ANY PARTY (i) FOR ANY INDIRECT, DIRECT, SPECIAL, PUNITIVE, INCIDENTAL OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR LOSS OF BUSINESS PROFITS, BUSINESS INTERRUPTION, LOSS OF PROGRAMS OR INFORMATION, AND THE LIKE), OR ANY OTHER DAMAGES ARISING IN ANY WAY OUT OF THE AVAILABILITY, USE, RELIANCE ON, OR INABILITY TO USE THE SITE/SERVICES OR SITE/SERVICES CONTENT, EVEN IF ALL SUCH PARTIES SHALL HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, AND REGARDLESS OF THE FORM OF ACTION, WHETHER IN CONTRACT, TORT, OR OTHERWISE; OR (ii) FOR ANY CLAIM ATTRIBUTABLE TO ERRORS, OMISSIONS, OR OTHER INACCURACIES IN, OR DESTRUCTIVE PROPERTIES OF THE SITE/SERVICES OR THE SITE/SERVICES CONTENT. YOU AND WE AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO OUR SERVICE MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, OUR LIABILITY IN SUCH JURISDICTION SHALL BE LIMITED TO THE MAXIMUM EXTENT PERMITTED BY LAW.&nbsp;</span></span></span></span></span></span>&nbsp;</p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">NO WARRANTY&nbsp;</span></span></span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Except as expressly set forth herein, we are not responsible for any incorrect or inaccurate information or entry of information, whether caused by a user of our site/services or by any of the equipment or programming associated with or utilized in connection with our site/services or any Services provided on or through our site, or by any technical or human error which may occur in the processing of information received by us. We assume no responsibility for any error, omission, interruption, deletion, defect, delay in operation or transmission, communications line failure, theft or destruction or authorized access to, or alteration of, information received or submitted in connection with our site/services. We are not responsible for any problems, errors or technical malfunction of any telephone network or lines, computer online systems, servers or providers, computer equipment, or software, or any failure of email on account of technical problems or traffic congestion on the Internet or at our site/services or combination thereof, including injury or damage to participants or to any other person’s computer related to or resulting from use of our site/services or site/services Content.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">THE CONTENT AND ALL SERVICES ASSOCIATED WITH OUR SERVICES ARE PROVIDED TO YOU ON AN "AS-IS" AND "AS AVAILABLE" BASIS. WE MAKE NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF OUR SERVICES OR THE INFORMATION, CONTENT, MATERIALS, SERVICES INCLUDED ON OR ASSOCIATED WITH OUR SERVICES INCLUDING ANY LOAN YOU MAY CHOOSE. YOU EXPRESSLY AGREE THAT YOUR USE OF OUR SERVICES IS AT YOUR SOLE RISK.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">WE DO NOT MAKE, AND EXPRESSLY DISCLAIM, ANY REPRESENTATIONS, WARRANTIES OR GUARANTEES, EXPRESS OR IMPLIED, REGARDING THE ACCURACY, CORRECTNESS, OR COMPLETENESS OF THE CONTENT OR THE SERVICES OR THE SAFETY, RELIABILITY, TITLE, TIMELINESS, COMPLETENESS, MERCHANTABILITY, CONFORMITY OR FITNESS FOR A PARTICULAR PURPOSE OF THE CONTENT OR THE SERVICES AND PRODUCTS ASSOCIATED WITH OUR SERVICES. IT IS YOUR SOLE RESPONSIBILITY TO INDEPENDENTLY EVALUATE THE ACCURACY, CORRECTNESS OR COMPLETENESS OF THE CONTENT AND THE SERVICES AND PRODUCTS ASSOCIATED WITH OUR SERVICES AND ANY LOAN YOU ACCEPT. WE MAKE NO REPRESENTATION, WARRANTY OR GUARANTEE THAT THE CONTENT OF OUR SITE/SERVICES MAY BE AVAILABLE FOR DOWNLOADING FROM OUR SERVICES IS FREE OF INFECTION FROM ANY VIRUSES, WORMS, TROJAN HORSES, TRAP DOORS, BACK DOORS, EASTER EGGS, TIME BOMBS, CANCELBOTS OR OTHER CODE OR COMPUTER PROGRAMMING ROUTINES THAT CONTAIN CONTAMINATING OR DESTRUCTIVE PROPERTIES OR THAT ARE INTENDED TO DAMAGE, DETRIMENTALLY INTERFERE WITH, SURREPTITIOUSLY INTERCEPT OR EXPROPRIATE ANY SYSTEM, DATA OR PERSONAL INFORMATION. WE DO NOT MAKE ANY REPRESENTATIONS, WARRANTIES OR GUARANTEES, EXPRESS OR IMPLIED, REGARDING ANY QUOTES OR OFFERS PROVIDED ON OR THROUGH OUR SERVICES. WITHOUT LIMITING THE FOREGOING, YOU ACKNOWLEDGE AND AGREE THAT WE ARE NOT A LENDER, BROKER, INVESTOR, FINANCIAL INSTITUTION OR OTHER SERVICE PROVIDER. YOU ACKNOWLEDGE AND AGREE THAT WE ARE SOLELY AN INTERMEDIARY BETWEEN YOU AND SUCH PERSONS OR INSTITUTION AND, THEREFORE, WE EXPRESSLY DISCLAIM ANY AND ALL LIABILITY FOR ANY CONTENT, SERVICES OR LOANS PROVIDED BY SUCH SERVICE PROVIDERS.&nbsp;</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">RELEASE</span></span></span></span></span></span></span></span><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">YOU HEREBY AGREE TO RELEASE, REMISE AND FOREVER DISCHARGE THE COMPANY AND ITS SERVICE PROVIDERS AND EACH OF THEIR RESPECTIVE AGENTS, DIRECTORS, OFFICERS, EMPLOYEES, INFORMATION PROVIDERS, AND EACH OF THEIR RESPECTIVE AGENTS, DIRECTORS, OFFICERS, EMPLOYEES AND ALL OTHER RELATED, ASSOCIATED, OR CONNECTED PERSONS FROM ANY AND ALL MANNER OF RIGHTS, CLAIMS, COMPLAINTS, DEMANDS, CAUSES OF ACTION, PROCEEDINGS, LIABILITIES, OBLIGATIONS, LEGAL FEES, COSTS, AND DISBURSEMENTS OF ANY NATURE WHATSOEVER WHETHER KNOWN OR UNKNOWN, WHICH NOW OR HEREAFTER EXIST, WHICH ARISE FROM, RELATE TO, OR ARE CONNECTED WITH YOUR USE OF THE SERVICE.&nbsp;</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Indemnification&nbsp;</span></span></span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">You agree to indemnify and hold The Company , its subsidiaries, affiliates, agents, shareholders, officers contractors, vendors, employees, and service providers harmless from any claim or demand, including reasonable attorneys' fees, made by any third party due to or arising out of your use of this site/service, the violation of this Agreement by you, or the infringement by you, or other user of this site/service using your computer, of any intellectual property or other right of any person or entity.&nbsp;</span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">The Company and its Service providers assume no responsibility of any kind for such content or actions. The Company reserves the right, at its own expense, to assume the exclusive defense and control of any matter otherwise subject to indemnification by you.&nbsp;</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Termination&nbsp;</span></span></span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">If you breach or violate any part of this Agreement or provisions in the Privacy Policy you may no longer use this site/service. The Company may, in its sole discretion, change, suspend, or terminate, temporarily or permanently, this site/service or any part of it at any time, for any reason, without notice to you and without liability to you or any other person. You agree that all terminations for cause shall be made in The Company’s sole discretion and shall not be liable to you or any third party for any termination.&nbsp;</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:underline"><span style="-webkit-text-decoration-skip:none"><span style="text-decoration-skip-ink:none">Entire Agreement&nbsp;</span></span></span></span></span></span></span></span></p><p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">This Agreement constitutes the entire terms of use agreement between you and The Company and governs your use of this site/service which supersedes any prior agreements between you and The Company . You also may be subject to additional terms and conditions that may apply when you use other services, affiliate services, third party content or third party software.&nbsp;</span></span></span></span></span></span></p>&nbsp; <p style="line-height:1.38"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Arial"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:normal"><span style="text-decoration:none">Revised 1/1/2020</span></span></span></span></span></span></p>`,
    // eslint-disable-next-line
    defaultPP = `<div class="ghPP"><p>Date last revised: August 14, 2020</p><h2>PRIVACY POLICY</h2><p>PLEASE READ THIS PRIVACY POLICY CAREFULLY. BY ACCESSING OR USING THE SITES OR SERVICES, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTAND, AND AGREE TO BE BOUND TO ALL THE TERMS AND CONDITIONS OF THIS PRIVACY POLICY.</p><p>IF YOU DO NOT AGREE TO THIS PRIVACY POLICY, PLEASE EXIT THIS PAGE AND DO NOT ACCESS OR USE THE SITES OR SERVICES.</p><p>Please note that we are not a mortgage lender, debt servicer, debt settlement, real estate company, insurance agent, auto sales company or automotive warranty organization. This site and the services offered is not, and is not intended to be, any type of application for any financial/insurance product or service.</p><p>This Privacy Policy discloses the privacy practices of Grant Hood Marketing, its affiliates and subsidiaries, (collectively &ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;, or &ldquo;the Company&rdquo;) and governs the collection, sharing and security of information through our website, or other Company products and services (collectively, the &ldquo;Services&rdquo;) by users of the Services (&ldquo;you&rdquo; or &ldquo;your&rdquo;).</p><h4>Types of Information We Collect</h4><p><span class="underline">Personal information:</span> This is information that can be used to identify you. Most of this information is provided by you on this site to fulfill your request. The information may include your name, address, telephone number(s), mobile numbers and email address, employment status or self-employment or other unique information about you which you provide to us on this site, or through the course of communicating with us about the products and services provided on this site.</p><p><span class="underline">Behavioral information:</span> This is information which is automatically collected when you use the site. It includes the areas of the site that you visit, what services you engage with, and information about your computer hardware and software, including your IP address, geographic location, browser preference, operating system type, domain names, times that you access the internet, and other web properties you may have visited.</p><p><span class="underline">Demographic information:</span> This is information that refers to selected population characteristics. Such as zip code, military status, personal and online interests. When we can identify you through this information, it is personal Information.</p><p><span class="underline">Third party information:</span> This is information about you that we may collect from a third party which could include personal, demographic, behavioral and indirect information. This collection may include, but not limited to, first party cookies, third party cookies, anonymous cookies, persistent identifiers, email opt in, and search engine keywords. Since these are third party cookies, we have no access or control over these cookies and other&nbsp;tracking technology used or owned by third party advertisers and networks. Because we do not have ownership or control over this technology and it is governed by third party policies, we have no responsibility or liability for those parties or their policies and practices.</p><p><span class="underline">Web technology information:</span> This is information that could be personal or non-personal information that we, or a third party service we employ will&nbsp;automatically track, collect and record from you when you enter the site and will cease when you exit the site. This includes internet protocol (IP) addresses, browser type, internet service provider (ISP), referring/exit pages, operating system, date/time stamp, and/or tracking user movements and/or clickstream data. This information is combined with other aggregate data to assign a unique ID for that site visit. This information is collected from the use of tracking technologies, cookies, web beacons, or javascript.&nbsp;</p><p>We will never knowingly collect any Personal Information from children under the age of 13. If we obtain actual knowledge that we have collected Personal Information about a child under the age of 13, that information will be immediately deleted from its database. Because it does not collect such information, we have no such information to use or to disclose to third parties.</p><h4>How We Use and Share Information</h4><p>The information collected on this site is used and shared for the following purposes:</p><ol><li>We will share your information with multiple businesses who offer the product/service that you have inquired about.<br/>We will share your information with third parties who help us in the delivery of the products and services you have requested. You understand and agree that when you submit an inquiry for these services, you explicitly authorize us to share your information with third parties so that they may contact you by email, SMS, telephone and/or direct mail.</li><li>We share your personal information with third parties who will provide you with their opportunities, products or services. This includes your interests and preferences, so they may determine whether you might be interested in their products or services.<br/>You agree to receive autodialed or prerecorded calls, texts and emails from us and any affiliates or third parties to the phone numbers (including mobile numbers) and email addresses you provide on this site. Your consent is not a condition, directly or indirectly of any type of purchase.<br/>The information you provided on this site will be shared and purchased by these businesses in order to provide such services. As a result, we provided your personal and non personal information to these businesses so they may contact you. This will allow for you to compare different services/products and providers prior to purchasing such services/products.</li><li>We also share your personal information with companies and individuals we employ to perform web technology&nbsp;or mechanical functions on our behalf, such as third parties who host our website, verify submissions,&nbsp;analyze our data, provide marketing assistance, process credit card payments, and provide customer service.</li></ol><p>We will share your information with third party services who perform web technology functions to certify form submissions on the site. These functions will track and record user engagement and movements within the form pages. This information is shared for legal purposes in providing proof of proper consumer consents and internal audits to ensure proper consumer disclosures were provided per Federal and State laws and regulations.&nbsp;</p><p>CrossDevice Advertising and Tracking: We may collect and use and share the above data with a third party for cross-device advertising purposes. This allows consumers to experience a personalized, informative marketing that delivers specific product interests over multiple devices. This information may be used for analytics, and reporting purposes.<br/>Push Notifications: We may use push notifications and alerts to notify you of services and/or products that you have expressed interest in on multiple devices. If you no longer wish to receive these types of communications, you may turn them off at the device level. You may optout of push notifications or alerts. through your browser settings.</p><ol><li>We may share aggregated anonymous information about you, combined with other persons using our website with third parties, so that they can understand the diversity of visitors and their activity/use of our website.</li><li>We will disclose your information if legally required to do so, or at our discretion, pursuant to a request from a governmental entity, or if we believe in good faith that such action is necessary to stay legally compliant&nbsp;or prevent a crime; and we will share your information if we sell our company or merge with another company.</li><li>We will share your information in order to process Opt-Out requests with affiliated partners and/or third parties in order to process and monitor these requests.</li><li>We may disclose your information to improve, manage and protect our information technology infrastructure and security. We may also disclose your information for any other purpose with your consent and may share non-personal at any time for any purpose.</li><li>We may disclose and transfer your information to a third party who acquires part or all of our business through a merger, consolidation or purchase of all or part of our assets. We may disclose your information in an insolvency proceeding, whether voluntary or involuntary, as our role of liquidator, administrator, receiver or administrative receiver we may sell, license or otherwise dispose of such information in an event approved by the court.</li></ol><h4>Technology We Utilize</h4><p>The use of technologies such as cookies, web beacons and java script may be implemented by us and third parties. These will be placed and used as tracking technologies by us, third parties and advertisers.</p><p>These technologies and some that are similar collect web technology information about you such as:&nbsp;&nbsp;internet protocol (IP) addresses, browser type, internet service provider (ISP), referring/exit pages, operating system, date/time stamp, and/or mouse and clickstream data. We may receive reports based on these technologies on an individual or aggregated basis for analysis purposes.</p><ol><li>Cookies. Cookies are small text files that are stored on a user&rsquo;s computer for record-keeping purposes and which contain information about that user&rsquo;s computer. Cookies allows us to identify files on your computer and record your preferences and other data about your visit to our website so that when you return to the website we are able to identify you and can personalize repeat visits. When cookies settings are disabled or changed you may experience site or service features that do not function properly. You may control these permissions by modifying your browser preferences to reject all cookies.<br/>Third Party Cookies. We allow third party vendors and advertisers to set their own cookies on and through this site. We do not control the practices of those third parties and we are not responsible for their technology or tracking. It is important to review the policies of such persons or entities on their websites. We use AdWords Remarketing through Google which is a Remarketing and Behavioral Targeting service provided by Google Inc. which connects the activity on this site with the AdWords advertising network and the DoubleClick cookie. That Cookie collects information regarding certain patterns in your browsing history. To optout of this tracking, please see <a href="https://support.google.com/ads/answer/2662922?hl=en" target="_blank">here</a>.<br/>Social Media Cookies. This site may include social media features. These features may collect your IP address, the web properties you engage with, and may set a cookie to enable the feature to function properly. Social media features are either hosted by a third party or hosted directly on our web properties. Your interactions with these features are governed by the privacy policy of the company providing it.</li><li>We utilize Google Analytics Advertising. This includes: Remarketing with Google Analytics; Google Display Network Impression Reporting; DoubleClick Campaign Manager integration; Google Analytics Demographics and Interest Reporting. Google uses cookies to track activity performed by Google Analytics and its AdWords or DoubleClick cookie. To opt-out please see <a href="https://tools.google.com/dlpage/gaoptout/" target="_blank">here</a>.</li><li>We use Google Analytics services which is an analysis service. Google utilizes the data collected through its cookies to track and examine the use of this site, to prepare reports on its activities, and to share them with other Google services. You may opt-out of the Google Analytics service <a href="https://tools.google.com/dlpage/gaoptout/" target="_blank">here</a>.</li><li>Web Beacons. We use electronic images known as Web Beacons (ie, single-pixel gifs, clear gifs or action tags) this allows the collection of information about your visit to this site to measure and improve the effectiveness of any marketing and track delivery of marketing and other communication methods. Web Beacons collect only a limited set of information like a cookie number, time and date the page was viewed, as well as a description of the page on which the Web Beacon resides. We may also use Web beacons in email messages. This allows us to determine if you opened or engaged with the email messages. Web Beacons may be rendered ineffective by either opting out of cookies or changing the cookie setup in your browser.</li><li>JavaScript. We may also use JavaScript. JavaScript is a computer language that enhances the functionality of web properties, particularly with respect to pictures. We or third parties also use it to track, record and&nbsp;analyze user interactions, provide proof of legal compliance, and improve our site&rsquo;s functions. You may deactivate JavaScript through your browser settings or activate it the same way.</li></ol><h4>Unsubscribe, Opt Out or Revoke</h4><ol><li>To opt-out of receiving SMS or email communications from us, please follow the instructions in our SMS or emails to unsubscribe from our email list. You may also reach us via email at: <a href="mailto:support@granthoodmkt.com">support@granthoodmkt.com</a>.</li><li>To opt-out of communications from third parties, please follow the instructions to opt- out in those entities&rsquo; communications.</li><li>To revoke consent at any time for any use of personal information you may have provided, please reach us via email at: <a href="mailto:support@granthoodmkt.com">support@granthoodmkt.com</a> with &ldquo;revoke Personal Information&rdquo; referenced in the message.</li></ol><p>Data collected which is purchased and/ or transferred to our third parties takes place in real-time. Should you choose to unsubscribe, opt-out or revoke consent, your data may have already been sent to our third parties. We cannot revoke your information from a third party if it has already been sent. We will notify third parties that we have shared your information of your request. We will remove your personal information (as permitted by law) from our internal programs and further communication from us will cease. If any third parties contact you, please follow the instructions to opt-out in those entities&rsquo; specific communications.</p><h4>Third Party Information</h4><p>We have relationships with other companies that we allow to place ads on our site to market offers that you may be interested in. When you visit our site, ad server companies may collect information such as your domain type, your IP address and clickstream information. For further information, consult the privacy policies of the companies representing the ads or click <a href="http://www.google.com/privacy_ads.html" target="_blank">here</a>.</p><p>Third parties may provide certain features on this site or to display advertising based upon your web browsing or application activity use Flash cookies and HTML5 to collect and store information. Various browsers may offer their own management tools for removing HTML5. To manage Flash cookies, please click <a href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html" target="_blank">here</a>.</p><p>This site and communications such as email messages sometimes contain hypertext links to websites owned by third parties. We are not responsible for the privacy practices or the content of such other websites. These links are provided for your convenience and reference only. We do not operate or control any information, software, products or services available on these third party websites. The inclusion of a link on our site does not imply any endorsement of the services, products or website, or its sponsoring organization.</p><p>&ldquo;Do-Not-Track&rdquo; is an optional browser setting that allows you to express your preferences regarding tracking by advertisers and other third-parties. We do not currently respond to Do-Not-Track signals.</p><p>If you wish to limit the collection of information by us or third party partners to provide you with marketing based upon your website browsing activities and interests, you may click <a href="http://preferences-mgr.truste.com/" target="_blank">here</a> to opt out.</p><p>To opt out of targeted advertising on your mobile device, iOS users can click <a href="https://support.apple.com/en-us/HT205223" target="_blank">here</a> to learn how to limit ad tracking and Android users can click <a href="https://support.google.com/ads/answer/2662922?hl=en" target="_blank">here</a> to learn how to opt out of interest-based ads.</p><p>Please note that opting out of interest-based/targeted advertising will not limit all advertising.</p><h4>Privacy Policies of Third Parties</h4><p>This Privacy Policy only addresses the Services offered by us. Other websites or services, for example, those websites we provide links to, or services you may have clicked-on that directed you to the Services, or websites that may be accessible to you through the Services, all have their own privacy policies regarding data collection, use and disclosure practices. If you visit any such website, we encourage you to review that website or service&rsquo;s privacy policy.</p><p>We are not responsible for the policies or practices of third parties.</p><h4>Storage and Security</h4><ol><li>We utilize acceptable commercial security measures to protect against the loss, misuse and alteration of your information under our control. Even with commercially reasonable technological precautions to protect your data, no data transmission over the Internet can be guaranteed to be a hundred percent secure. We cannot and do not warrant that your information will be absolutely secure. Any transmission of data at or through our website is at your own risk.</li><li>We will retain personal information, including user location information, only as long as our business needs require. We will then destroy or render unreadable any such information upon disposal.</li><li>Depending on site requirements, we may employ Secure Sockets Layer (SSL) encryption technology to transmit data between a consumer&rsquo;s browser and our web server. To use our websites, a consumer will need an SSL-capable browser such as MS Internet Explorer 4.0 (or higher) or Netscape Navigator 4.0 or higher.</li><li>We contractually require that third parties handle your personal information similar to our practices. Although we do have agreements in place for third party activities, we cannot monitor such practices and cannot be responsible for third party security or handling of personal information. Please do not communicate any information to us or any third party through unsecured channels.</li></ol><h4>Your Information- Request/Edit</h4><ol><li>Users may edit/change profile settings, if applicable. If information is removed from a profile, copies of that information may remain accessible elsewhere if it has been shared with others or it was copied or stored by other users.</li><li>We may be required to retain your information by law or for legitimate business purposes, such as to prevent identity theft or other misconduct.</li><li>For questions regarding your personal information that we have collected or to correct factual inaccuracies within this information please email us at: <a href="mailto:support@granthoodmkt.com">support@granthoodmkt.com</a>.</li></ol><h4>Minors and Privacy Statement</h4><p>No part of the Services is designed to attract anyone under the age of 18. Children under the age of 18 may not use the Services.</p><p>Children&rsquo;s Online Privacy Protection Act- This site is intended to be used by people the age of 18 and older. We do not knowingly allow any users under the age of 13 to use our service. However, if you become aware of the existence of a user who is under the age of 13, or that an individual under 13 has provided their information to us, contact us immediately with details by emailing us at: <a href="mailto:support@granthoodmkt.com">support@granthoodmkt.com</a>.</p><p>If you are a parent or guardian and believe that your child under the age of 13 has provided personal information to us, you may contact us to request this information be deleted.</p><h4>CALIFORNIA RESIDENTS- California Privacy Rights</h4><p>The California Consumer Protection Act has granted specific rights and remedies. For your California Privacy Rights and Remedies please click here.</p><h4>Revisions to this Privacy Policy</h4><p>We may change this Privacy Policy at any time. Upon any revisions, we will change the updated date at the top of this page accordingly. Any revised Privacy Policy will be effective immediately when posted on the Services We suggest users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect. Your continued use of the Services after the effectiveness of such revisions will constitute your acknowledgment and acceptance of the terms of the revised Privacy Policy.</p><h4>Contact</h4><p>For questions or comments regarding this policy, or to report any abuse of personal information collected under this Privacy Policy, email us at: <a href="mailto:support@granthoodmkt.com">support@granthoodmkt.com</a>.</p></div><style type="text/css">.ghPP .center{text-align: center;}.phPP .underline{text-decoration: underline;}.ghPP p{margin-bottom: 15px;}.ghPP br{margin-top: 10px;margin-bottom: 10px;}.ghPP li{margin-bottom: 10px;}.ghPP a{color: #065398;}.ghPP a:hover{color: #00b;}</style>`,
    //eslint-disable-next-line
    defaultCCPA = `<h2>PRIVACY POLICY NOTICE - CALIFORNIA</h2><p>&nbsp;</p><p> This PRIVACY NOTICE IS FOR CALIFORNIA RESIDENTS intended to apply solely to visitors, users, and persons who are residents in the State of California ("consumers" or "you").</p><p> This notice is an addendum for information contained in the existing <a id="privacyModalOpen" style="text-decoration: underline; color: #1155cc;">Privacy Policy</a> of the Company and its affiliates (collectively, "we," "us," or "our").</p><p> We adopt this notice to comply with the California Consumer Privacy Act of 2018 ("CCPA") and other California privacy laws. Any terms defined in the CCPA have the same meaning when used in this notice.</p><h4>Information We Collect -</h4><p> We collect information that identifies, relates to, describes, references, is capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular consumer or device ("personal information").</p><p> We have collected the following Statutory Defined Categories of personal information from consumers within the last twelve (12) months:</p><p> <strong>Category: "Identifiers"</strong> - which may include: A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, or other similar identifiers.</p><p> <strong>Category: "Personal Information"</strong> - which may include: A name, signature, address, telephone number, education level, employment, and driver license status. Some personal information included in this category may overlap with other categories.</p><p> <strong>Category: "Protected Classification Characteristics"</strong>- which may include: Age, marital status, gender, and Veteran or military status.</p><p> <strong>Category: "Internet or Other Similar Network Activity"</strong>- which may include: Browsing history, search history, information on a consumer's interaction with a website, application, or advertisement.</p><p> <strong>Category: "Professional or Employment-Related Information"</strong>- which may include employment status, ie. Employed, Self-Employed or Retired Status</p><p> The above categories of personal information are obtained from the following categories of sources:</p><ul> <li> Directly from you. For example, from your interaction on this platform and the information you provide on any forms this platform which you submit. In some instances we may also automatically collect certain information from you through the technology on the platform. </li><li> Information you provide in connection with a product/service offered by our affiliates, partners or vendors. </li><li> Information you provide the platform for communication permissions and consents. </li><li> Indirectly from our clients or their agents. For example, through information we collect from our clients in the course of providing marketing or technology services to them. </li><li> Directly or indirectly from our clients or their agents. For example, through information we collect from our clients in the course of providing services to them. </li><li> From thirdparties that interact with us in connection with the platform function or services we perform. For example, verification services used for state and federal permission and consent records. </li><li> Information you provide us through telephone and websites, customer service correspondence, and general feedback. </li><li> In addition, we may receive information about you from other online or offline sources, including service providers from whom we validate consumer selfreported information, and verify information we already have about you. </li></ul><h4>Use of Personal Information</h4><p> We may use or disclose the personal information we collect for one or more of the following business purposes:</p><ul> <li> To process an inquiry or request you provide. For example, if you provide us with your information to share with businesses who will contact you regarding a product or service you expressed interest in. </li><li> To provide you with personalized email, SMS or tele communications concerning products or services, information or news, that you may be of interest to you through targeted offers and ads (with proper consents, where required by law). </li><li> To carry out our obligations and enforce our rights arising from any contracts entered into between us and any affiliates, client network, and/or vendors. </li><li>To improve our platform and the services offered.</li><li> For testing, research, analysis and technological/product development. </li><li> To help maintain and protect the rights, safety, security, and integrity of our platforms, products and services, databases and other technology assets. </li><li> To respond to any law enforcement requests and as required by applicable law, court order, or governmental regulations. </li><li> To evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which personal information held by us is among the assets transferred. </li><li> As described to you when collecting your personal information or as otherwise set forth in the CCPA. </li></ul><p> We will not collect additional categories of personal information or use the personal information we collected for any other purpose than described herein without first providing you notice.</p><h4>Sharing Personal Information</h4><p> We may share your personal information with a third party for business purposes. When we disclose personal information for a business purpose, we enter a contract that describes the purpose and requires the recipient to both keep that personal information confidential and not use it for any purpose except performing the services outlined in the contract.</p><p> In the preceding twelve (12) months, we have disclosed the following categories of personal information (as identified above) for a business purpose:</p><ul> <li>Category: Identifiers</li><li>Category: Personal information</li><li>Category: Protected classification characteristics</li><li>Category: Internet or other similar network activity</li><li>Category: Professional or employmentrelated information</li></ul><p> We share the above following categories of personal information for a business purpose to the following third parties:</p><ul> <li>Our affiliates.</li><li>Service providers.</li><li>Data aggregators.</li><li> Third parties to whom you or your agents authorize us to disclose your personal information in connection with the products or services you have expressed interest in. </li></ul><p> Per California CCPA Section 1798.140(t): A business does not sell personal information when: A consumer uses or directs the business to intentionally disclose personal information or uses the business to intentionally interact with a third party, provided the third party does not also sell the personal information, unless that disclosure would be consistent with the provisions of this title.</p><p> In the preceding twelve (12) months, we have shared your information with providers of the services or products you have requested. We have also shared your information with third parties as described above.</p><h4>Your Rights and Choices</h4><p>Access to Specific Information and Data Portability Rights-</p><p> You have the right to request that we disclose certain information to you about our collection and use of your personal information over the past 12 months. Once we receive and confirm your verifiable consumer request, we will provide:</p><ul> <li>The categories of personal information we collected about you.</li><li>The categories of sources for the personal information we collected about you. </li><li>Our business or commercial purpose for collecting that personal information. </li><li>The categories of third parties with whom we share that personal information. </li><li>The specific pieces of personal information we collected about you (also called a data portability request). </li><li>If we disclosed your personal information for a business purpose, two separate lists disclosing the following will be provided: <ul> <li> Information you provided that was shared with third parties for the purposes set forth above and resulted in payment to us which will identify the personal information categories that the third party purchased; and </li><li> Disclosures for a business purpose, identifying the personal information categories that each category of recipient obtained. </li></ul> </li></ul><h4>Deletion Request Rights-</h4><p> You have the right to request that we correct and/or delete any of your personal information you provided to this platform and retained, subject to certain exceptions. Upon receipt and confirmation of your verifiable consumer request, we will delete (and direct our service providers to delete) your personal information from our records, unless an exception applies.</p><p> We may retain your information despite your deletion request if retaining the information is necessary for us or our vendors/ service providers to perform any of the following:</p><ol> <li>Process your request for which you provided your personal information</li><li> Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or prosecute those responsible for such activities. </li><li> Debug products to identify and repair errors that impair existing intended functionality of this platform/service. </li><li> Internal uses that are reasonably aligned with consumer expectations based on your engagement with the platform/services.. </li><li>Comply with a legal obligation.</li><li> Make other internal and lawful uses of that information that are compatible with the context in which you provided it. </li></ol><h4>Exercising Rights, Data Portability, and Deletion Rights-</h4><p> To exercise your rights, data portability, and deletion rights described above, please submit a verifiable <a href="https://secureconsumerinfo.com/?referer=${window.location.host}" style="text-decoration: underline; color: #1155cc;">consumer request here</a> or send and email to: <a href="mailto:ccpa-request@secureconsumerinfo.com" style="text-decoration: underline; color: #1155cc;">ccpa-request@secureconsumerinfo.com</a>.</p><p> Only you or a person registered with the California Secretary of State that you authorize to act on your behalf, may make a verifiable consumer request related to your personal information or on behalf of your minor child.</p><p> You may only make a verifiable consumer request for access or data portability twice within a 12-month period. The verifiable consumer request must:</p><ul> <li> Provide sufficient information that allows us to reasonably verify you are the person (or authorized agent) who provided personal information on the platform. </li><li> Describe your request with satisfactory detail that allows us to accurately understand, evaluate, and provide a response. </li></ul><p> The above details are important we will be unable to process/respond to your request or provide you with personal information if we cannot conclusively verify your identity or any authority to make the request and/or confirm the personal information relates to you.</p><p> We will only use the personal information provided in a verifiable consumer request to actually verify the requestor's identity or authority in order to process such request.</p><h4>Response Timing and Format-</h4><p> We will respond to a verifiable consumer request within 45 days of its receipt as required. If more time is required (up to 90 days), we will inform you of the reason and extension period in writing. We will deliver a written response by mail or electronically, at your request. The information provided will cover a 12-month period preceding the verifiable consumer request's receipt. The response we provide may also explain the reasons we cannot process a request, if applicable. For requests made, we will select a format to provide your personal information that is readily useable.</p><p> We do not charge a fee to process or respond to your verifiable consumer request unless it is excessive, repetitive, or manifestly unfounded. If we determine that the request warrants a fee, we will tell you why we made that decision and provide you with a cost estimate before completing your request.</p><h4>Non-Discrimination-</h4><p> We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA, we will not:</p><ul> <li>Deny these services.</li><li> Charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties. </li><li> Suggest that you may receive a different price or rate for goods or services or a different level or quality of services. Please note: We do not charge consumers for use of these services. </li><li>Provide you a different level or quality of services.</li></ul><h4>Changes to Our Privacy Notice-</h4><p> We reserve the right to amend this privacy notice at our discretion and at any time. When we make changes to this privacy notice, we will notify you by email or through a notice on this platform.</p><h4>Contact Information-</h4><p> If you have any questions or comments regarding this notice, please contact us at: info@suitedconnector.com or write to us with your specific instructions at: Suited Connector, LLC Mortgage.Info - Attention: Consumer Services, Mortgage.Info<br>NMLS ID #1237615 | MB #0928735<br>8123 South Interport Blvd. Suite A Englewood, CO 80112</p>`
  url = 'https://external' + envToggle + '.printfinger.tech:7105/api/CheckRules'

  successFunction = function (response) {
    var disclosureOfferId
    var disclosureName
    var disclosureContent
    var disclosureCompanyAddress
    var disclosureAdvertiserId
    var AffiliateAssociation

    try {
      if (!response || !response.Payload) {
        // set default disclosure
        if (isHomeServices) {
          $('#disclosureValue').html(homeServicesDisclosure)
        } else {
          $('#disclosureValue').html(defaultDisclosure)
        }
        $('#termsContent').html(defaultTOU)
        $('#privacyContent').html(defaultPP)
        $('#doNotSellContent').html(defaultCCPA)
      } else {
        var disclosureParsed = JSON.parse(response.Payload)

        if (disclosureParsed !== null && disclosureParsed !== undefined && disclosureParsed !== '') {
          // loop through the array of objects then loop through each object in the index to assign the variable
          for (var keys in disclosureParsed) {
            for (var key in disclosureParsed[keys]) {
              if (disclosureParsed[keys].hasOwnProperty(key)) {
                if (key === 'OfferId') {
                  disclosureOfferId = disclosureParsed[keys][key]
                }
                if (key === 'DisclosureName') {
                  disclosureName = disclosureParsed[keys][key]
                }
                if (key === 'DisclosureContent') {
                  disclosureContent = disclosureParsed[keys][key]
                }
                if (key === 'TermsOfUse') {
                  // do not add var here, it's declared in utils.js
                  disclosureTermsOfUse = disclosureParsed[keys][key]
                }
                if (key === 'PrivacyPolicy') {
                  // do not add var here, it's declared in utils.js
                  disclosurePrivacyPolicy = disclosureParsed[keys][key]
                }
                if (key === 'DoNotSellLink') {
                  // do not add var here, it's declared in utils.js
                  disclosureDoNotSell = disclosureParsed[keys][key]
                }
                if (key === 'Licensure') {
                  // do not add var here, it's declared in utils.js
                  disclosureLicensure = disclosureParsed[keys][key]
                }
                if (key === 'CompanyAddress') {
                  disclosureCompanyAddress = disclosureParsed[keys][key]
                }
                if (key === 'AdvertiserId') {
                  disclosureAdvertiserId = disclosureParsed[keys][key]
                }
                if (key === 'AffiliateAssociation') {
                  AffiliateAssociation = disclosureParsed[keys][key]
                  storage('session', 'set', 'AffiliateAssociation', AffiliateAssociation)
                }
              }
            }
          }
          storage('session', 'set', 'disclosureName', disclosureName)
          $('#disclosureValue').html(disclosureContent)
          $('.disclosureLocation').html(disclosureCompanyAddress)
        } else {
          $('#disclosureValue').html(defaultDisclosure)
        }
      }
    } catch (error) {
      // set default disclosure
      $('#disclosureValue').html(defaultDisclosure)

      // will log the error to our fe logging api
      console.log(error)
    }
  }

  var requestData = {
    activity: 'Disclosure',
    RequestId: reqID,
    OfferId: offerId,
    SiteName: window.location.hostname,
    AffiliateId: affiliateId(),
  }

  sendRequest(requestData, url, successFunction, v2ExternalAuthkey, 'POST', true)
}

/*
 * this function sends a call to get pii data if the sih exists in the url
 * sih = the sih from the db
 * @param {*} sih
 */
function prePopAPI(sih) {
  var url = 'https://external' + envToggle + '.printfinger.tech:7105/api/CheckRules',
    successFunction = function (res) {
      if (res) {
        const splitURL = window.location.href.split('?')[0]
        const JSONtoQS = $.param(res.Payload[0])
        prePopActions(res.Payload[0], doQueryStringSave(`${splitURL}?${JSONtoQS}`))
      } else {
        console.log('No SIH Payload Found')
      }
    },
    requestData = {
      activity: 'GetPrepop',
      SIH: sih,
    }

  sendRequest(requestData, url, successFunction, v2ExternalAuthkey, 'POST', true)
}

/**
 * gets the user ip address from ipify.org
 * @param  {function} callback
 */
function getUserIp(callback) {
  $.getJSON('https://api.ipify.org?format=json', function (data) {
    userIp = data.ip
    if (callback) {
      callback()
    }
  }).fail(function (data, textStatus, error) {
    userIp = 'IP API Call Failed'
    console.log('IP API Call Failed')
    // scLogging('Failed API Call', data, error)
    if (callback) {
      callback()
    }
  })
}

function getIleadsLite() {
  var url = 'https://external' + envToggle + '.printfinger.tech:7113/CheckLender',
    formData = current_form.form.serialize(),
    allFormData = buildLead(formData, false)

  if (formData !== null && formData !== undefined && formData !== '') {
    var successFunction = function (response) {
      if (response && response.property !== null) {
        if (response.property.lenderName) {
          const lenderResponse = response.property.lenderName
          stageLog('ileads response = ', lenderResponse)
          const lenders = $('#' + current_form.form_id + ' [name=current_lender] option')
          if (lenders) {
            for (let i = 0; i < lenders.length; i++) {
              const lender = lenders[i].value
              if (lenderResponse === lender) {
                $('[name=current_lender]').val(lenderResponse)
                break // once it's found we break out of the loop
              } else {
                $('[name=current_lender]').val('Other')
              }
            }
          }
          $('[name=current_lender]').change()
          doTCPA()
        } else {
          doTCPA()
        }
      } else {
        doTCPA()
      }
    }
    sendRequest(allFormData, url, successFunction, v2ExternalAuthkey, 'POST', true)
  } else {
    doTCPA()
  }
}

/**
 * returns the direct to cake API call with either suco or rmp as the instance
 * @param  {string} envToggle
 * @param  {string} instance
 */
function postToCakeEndpoint(envToggle, instance) {
  return 'https://external' + envToggle + '.printfinger.tech:8090/api/PostToCake/' + instance || 'suco'
}

/**
 * SUBMIT API to lmb prequal and bedrock
 * @param  {string} jsonForm
 * @param  {function} callback
 */

function submitFormData(jsonForm, callback) {
  checkForUUID()
  doPartialSave(current_form)
  var uuid = storage('session', 'get', 'scUUID'),
    buyer = $('[name=tcpa]').val(),
    url = 'https://external' + envToggle + '.printfinger.tech:7113/api/BuyerPreQualification',
    requestData = {
      BuyerName: buyer,
      Uuid: uuid,
      Payload: jsonForm,
    },
    successFunction = function (res) {
      var response = JSON.parse(res)

      try {
        if (response.TierLevel !== null || response.TierLevel !== undefined) {
          storage('session', 'set', 'tl', response.TierLevel)
        }
      } catch (error) {
        console.log(error)
      }

      if (callback) callback()
    }
  if (callDotRMP) {
    const payload = requestData.Payload,
      directToCakeUrl = postToCakeEndpoint(envToggle, 'rmp'),
      translatedPayload = rmpToCakeTranslation(payload)
    postDirectlyToCake(translatedPayload, directToCakeUrl, successFunction, v2ExternalAuthkey, uuid, 'POST')
  } else {
    sendSyncRequest(requestData, url, successFunction, v2ExternalAuthkey, uuid, 'POST')
  }
}

/*
 * Handles the payablity call to back-end if the url contains a campaign id
 * @param {}
 */
function payAbility() {
  let url = 'https://external' + envToggle + '.printfinger.tech:7113/payability',
    payabilityData = current_form.form.serialize() + '&' + $('#disclosure-form').serialize(),
    zipCheck = storage('session', 'get', 'IsSolarZip'),
    payabilityDataFormatted = {}

  if (zipCheck) {
    payabilityDataFormatted = $.extend({ IsSolarZip: zipCheck }, buildLead(payabilityData))
  } else {
    payabilityDataFormatted = buildLead(payabilityData)
  }

  let payableCallback = function (body) {
    if (body != null && body != undefined && body != '') {
      // destructure response

      const { IsPayable, Pixels, IsThrottled, ThrottleDecisionId } = body

      const newPayableJSON = JSON.stringify({
        throttled: IsThrottled,
        payable: IsPayable,
        throttle_id: ThrottleDecisionId,
      })

      storage('session', 'set', 'payablity', newPayableJSON)
      storage('session', 'set', 'pixelHtml', Pixels)
      if (isGetLastSignUp) {
        getLastSignUp()
      } else {
        current_form.postLead()
      }
    }
  }

  sendRequest(payabilityDataFormatted, url, payableCallback, v2ExternalAuthkey, 'POST', true)
}

/**
 * Send the query string after Prepop runs
 * @param  {string} qs
 */
function doQueryStringSave(qs) {
  const url = 'https://external' + envToggle + '.printfinger.tech:7102/api/StorePrePop'

  if (qs !== null && qs !== undefined && qs !== '') {
    successFunction = function (response) {
      stageLog('QS String Saved', response)
    }
    var requestData = {
      Payload: qs,
    }

    if (location.search) {
      sendRequest(requestData, url, successFunction, v2ExternalAuthkey, 'POST', true)
    }
  }
}

// calls rulesengine to determine if the user should be redirected based on certain criteria.  This fires after the property value step
function doRateZip() {
  const url = 'https://external' + envToggle + '.printfinger.tech:7105/api/CheckRules',
    formData = current_form.form.serialize(),
    buildTheLead = buildLead(formData, false),
    otherData = {
      activity: 'BridgePageRedirect',
      BridgePageName: 'RateZip',
      site_name: window.location.hostname,
      campaignId: getCampaignId(),
      RequestId: requestId(),
      creative: getParameterByName('c') || '',
    },
    requestData = $.extend(buildTheLead, otherData)

  successFunction = function (response) {
    if (response == null) {
      return
    }
    const result = JSON.parse(response.Payload).filter((obj) => obj.RedirectUrl)
    if (
      result &&
      result[0].RedirectUrl !== '' &&
      result[0].RedirectUrl !== null &&
      result[0].RedirectUrl !== undefined
    ) {
      $('#loading-gif').show()
      $('form').css('display', 'none')

      setTimeout(() => {
        window.location.href = result[0].RedirectUrl
      }, 1500)
    }
    return
  }
  sendRequest(requestData, url, successFunction, v2ExternalAuthkey, 'POST', true)
}

/**
 * This function handles building the lead data object to be sent over http (see /js/modules/http/request.js)
 * It also retrieves a request id to attach to the lead data, and stores the object in the session data
 * @param {formData} data //must be serialized
 * @param {boolean} submit //is it final submission
 */
buildLead = function (data, submit) {
  var uuid = storage('session', 'get', 'scUUID'),
    cpid = storage('session', 'get', 'campaignId'),
    currentLender = storage('session', 'get', 'cl') || $('[name=current_lender]').val(),
    disclosureName = storage('session', 'get', 'disclosureName'),
    splitBuyerPayload = storage('session', 'get', 'splitBuyerPayload'),
    tcpaDefaultsOnFail = storage('session', 'get', 'tcpaDefaultsOnFail'),
    trustedFormUrl = storage('session', 'get', 'trustedFormUrl'),
    trustedFormToken = storage('session', 'get', 'trustedFormToken'),
    payablity = storage('session', 'get', 'payablity'),
    crlp = storage('session', 'get', 'crlp'),
    cakePixel = storage('session', 'get', 'cakePixel') || '',
    req_id = requestId(),
    leadID = $('[name=universal_leadid]').val(),
    formData = queryStringToJSON(data),
    siteVertical = scData[0].siteVertical || '',
    s1 = storage('session', 'get', 'subAffiliate'),
    s2 = storage('session', 'get', 's2'),
    s3 = storage('session', 'get', 's3'),
    s4 = storage('session', 'get', 's4'),
    s5 = storage('session', 'get', 's5')

  try {
    splitBuyerStorage = JSON.parse(splitBuyerPayload)
  } catch (error) {
    // do nothing
  }

  if (tcpaDefaultsOnFail) {
    let tcpaDefaultStorage = JSON.parse(tcpaDefaultsOnFail)
    formData.tyPageContent = tcpaDefaultStorage.tyPageContent
    formData.TcpaType = tcpaDefaultStorage.TcpaType
    formData.TcpaContent = tcpaDefaultStorage.TcpaContent
  }

  formData.offer_id = offerId()
  formData.affiliate_id = affiliateId()
  formData.SiteVertical = siteVertical

  if (uuid) {
    formData.uuid = uuid
  } else {
    checkForUUID()
    formData.uuid = uuid
  }

  if (cpid) {
    formData.campaign_id = cpid
  }

  if (disclosureName) {
    formData.disclosure_name = disclosureName
  }

  if (formData.phone_primary) {
    formData.phone_primary = formData.phone_primary.replace(/[^\d]/g, '')
  }

  formData.request_id = req_id

  if (!req_id) {
    formData.CakeRequestIdUrl = cakePixel
  }

  formData.server = 'greenfield'

  // use the unique site name if it exists in custom.js
  if (uniqueSiteName !== null) {
    formData.site_name = uniqueSiteName
  } else {
    formData.site_name = window.location.hostname
  }
  formData.site_url = window.location.href
  formData.user_agent = navigator.userAgent

  // if userIp global var doesn't exist set it here in the else block
  if (userIp !== '' && userIp !== null && userIp !== undefined) {
    formData.user_ip = userIp
  } else {
    formData.user_ip = 'IP var is empty null or undefined'
  }

  // checks if the lead id exists and if not set it to nothing
  if (leadID) {
    formData.universal_leadid = $('[name=universal_leadid]').val()
  } else {
    formData.universal_leadid = ''
  }

  formData.tcpa = $('[name=tcpa]').val() || ''

  // set trusted form's values if the html doesn't exist but exists in session storage
  if (trustedFormUrl && trustedFormToken && $('[name=xxTrustedFormCertUrl]').length === 0) {
    formData.xxTrustedFormCertUrl = trustedFormUrl
    formData.xxTrustedFormToken = trustedFormToken
  }

  if (splitBuyerPayload) {
    formData.SplitScenarioId = splitBuyerStorage.SplitScenarioId
    formData.SplitScenarioName = splitBuyerStorage.SplitScenarioName

    // only pass these two items if it's the final submit. Can't pass these items on TCPA call especially
    if (submit === true) {
      formData.BuyerGroupId = splitBuyerStorage.BuyerGroupId
      formData.BuyerGroupName = splitBuyerStorage.BuyerGroupName
      formData.BuyerId = splitBuyerStorage.BuyerId
      formData.BuyerName = splitBuyerStorage.BuyerName
      formData.BuyerGroupCurrentCount = splitBuyerStorage.BuyerGroupCurrentCount
      formData.BuyerGroupFilter = splitBuyerStorage.BuyerGroupFilter
      formData.BuyerGroupDailyCap = splitBuyerStorage.BuyerGroupDailyCap
      formData.BuyerGroupContractId = splitBuyerStorage.BuyerGroupContractId
      formData.SplitScenarioOrdinal = splitBuyerStorage.SplitScenarioOrdinal
      formData.TcpaId = splitBuyerStorage.TcpaId
      formData.TcpaType = splitBuyerStorage.TcpaType

      if (splitBuyerStorage.scbc !== '' && splitBuyerStorage.scbc !== null) {
        formData.scbc = splitBuyerStorage.scbc
      }
    }
    formData.Scenario = splitBuyerStorage.Scenario
    formData.TierLevel = splitBuyerStorage.TierLevel
    if (
      splitBuyerStorage.tyPageContent === undefined ||
      splitBuyerStorage.tyPageContent === null ||
      splitBuyerStorage.tyPageContent === '' ||
      splitBuyerStorage.tyPageContent === 'undefined' ||
      splitBuyerStorage.tyPageContent === 'null'
    ) {
      formData.TyPageShown = crlp
    } else {
      formData.TyPageShown = splitBuyerStorage.tyPageContent
    }
  } else {
    formData.TyPageShown = crlp
  }

  if (submit === true) {
    if (isHomeServices || isInsurance || isFinance) {
      formData.loan_purpose = null
    }
  }

  // passing this to each API call
  formData.MapName = 'Bedrock Signup'

  // if currentLender field exists and is an ileads form set CurrentLenderOriginal to the original current lender
  if ($('[name=current_lender]').length > 0 && ileads) {
    if (currentLender === 'Other') {
      formData.CurrentLenderOriginal = currentLender
    }
  }

  // if not on purchase path and current lender form element doesn't exist then set it to Other here.
  if (current_form.form_id !== 'msform-purchase' && $('[name=current_lender]').length === 0) {
    formData.current_lender = 'Other'
  }

  if (current_form.form_id === 'msform-refinance') {
    // variables for calculating total_loan_amount
    var ma = parseInt(radioOrSelectValue('mortgage_amount', false)),
      acn = parseInt(radioOrSelectValue('additional_cash_needed', false)),
      epv = parseInt(radioOrSelectValue('est_property_value', false)),
      totalLoanRefinance = Math.floor(ma + acn),
      loanToValue = ma / epv

    // updates total_loan_amount to be stored in sessionStorage
    if (totalLoanRefinance) {
      formData.total_loan_amount = totalLoanRefinance.toString()
    }

    // FEDP-1394 sets calculated loan to value variable and sets it to storage
    if (loanToValue) {
      loanToValue = loanToValue.toFixed(2)
      formData.loan_to_value = loanToValue.toString()
    }
  }

  if (current_form.form_id === 'msform-purchase') {
    // variables for calculating total_loan_amount
    var epp = parseInt(radioOrSelectValue('est_purchase_price', false)),
      edp = parseInt(radioOrSelectValue('estimated_down_payment', false)),
      totalLoanPurchase = Math.floor(epp - (epp * edp) / 100)

    // updates total_loan_amount to be stored in sessionStorage
    if (totalLoanPurchase) {
      formData.total_loan_amount = totalLoanPurchase.toString()
    }
  }

  // for use with auto insurance vertical
  if (isCarInsurance === true) {
    if (radioOrSelectValue('CurrentlyInsured', true) !== '1') {
      formData.InsuranceCarrier = 'Uninsured'
    }
  }

  if (payablity) {
    const throttleId = JSON.parse(payablity)
    if (throttleId) {
      formData.throttle_id = throttleId.throttle_id
    }
  }

  // Append CKM parameters to post

  if (s1) {
    formData.ckm_subid_1 = s1
  }

  if (s2) {
    formData.ckm_subid_2 = s2
  }

  if (s3) {
    formData.ckm_subid_3 = s3
  }

  if (s4) {
    formData.ckm_subid_4 = s4
  }

  if (s5) {
    formData.ckm_subid_5 = s5
  }

  if (getParameterByName('adgroup')) {
    formData.ckm_subid_3 = getParameterByName('adgroup')
  }

  if (getParameterByName('campaign')) {
    formData.ckm_subid_2 = getParameterByName('campaign')
  }

  if (getParameterByName('keyword')) {
    formData.ckm_subid_4 = getParameterByName('keyword')
  }

  // rounds the number of acres up or down and converts to an INT
  if (formData.NumberOfAcres) {
    formData.NumberOfAcres = parseInt(Math.round(formData.NumberOfAcres))
  }

  //store the data in a session variable
  try {
    if (!callDotRMP) {
      var sessionData = JSON.stringify(formData)
      storage('session', 'set', 'formData', sessionData)
      storage('local', 'set', 'formData', sessionData)
    }
  } catch (error) {
    console.log('Error with localStorage', error)
  }

  return formData
}

/**
 * This modules handles the generation & storage of a UUID
 */

var uuid

// do some maths and make a uuidV4
generateUUID = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

//store it in their local storage
storeUUID = function (uuid) {
  storage('session', 'set', 'scUUID', uuid)
}

//callback for postUUID (see js/modules/http/controllers/rulesEngine.js)
uuidCallback = function (data) {
  uuid = storage('session', 'get', 'scUUID')
}

//check the UUID at the start of a session, if there isn't one we generate
checkForUUID = function () {
  uuid = storage('session', 'get', 'scUUID')
  if (!uuid) {
    uuid = generateUUID()
    storeUUID(uuid)
  }
}

/**
 * This module contains the main validation function which is used when switching fieldests
 * or posting the form. It also includes smaller individual validation functions
 */

// prettier-ignore
const areaCodes=['201','202','203','205','206','207','208','209','210','212','213','214','215','216','217','218','219','220','223','224','225','228','229','231','234','239','240','248','251','252','253','254','256','260','262','267','269','270','272','276','279','281','301','302','303','304','305','307','308','309','310','312','313','314','315','316','317','318','319','320','321','323','325','326', '327', '330','331','332','334','336','337','339','340', '341', '346','347','351','352','360','361','364','380','385','386','401','402','404','405','406','407','408','409','410','412','413','414','415','417','419','423','424','425','430','432','434','435','440','442','443','445','447', '458','463','469','470','475','478','479','480','484','501','502','503','504','505','507','508','509','510','512','513','515','516','517','518','520','530','531','534','539','540','541','551','559','561','562','563','564','567','570','571','573','574','575','580','585','586','601','602','603','605','606','607','608','609','610','612','614','615','616','617','618','619','620','623','626','628','629','630','631','636','640','641','646','650','651','657', '659', '660','661','662','667','669','670','671','678','680','681','682','684','701','702','703','704','706','707','708','712','713','714','715','716','717','718','719','720','724','725','726','727','731','732','734','737','740','743','747','754','757','760','762','763','765','769','770','772','773','774','775','779','781','785','786','787','801','802','803','804','805','806','808','810','812','813','814','815','816','817','818','820','828','830','831','832','838', '839', '843','845','847','848','850','854','856','857','858','859','860','862','863','864','865','870','872','878','901','903','904','906','907','908','909','910','912','913','914','915','916','917','918','919','920','925','928','929','930','931','934','936','937','938','939','940','941','947','949','951','952','954','956','959','970','971','972','973','978','979','980','984','985','986','989'
]

/**
 * Checks if phone area code is in the above array
 * @param  {string} val
 */
function phoneAreaCheck(val) {
  let valCheck,
    isValid = false
  valCheck = val.replace(/\D/g, '').substr(0, 3)
  areaCodes.forEach((e) => {
    if (e === valCheck) {
      isValid = true
    }
  })
  return isValid
}

/**
 * This function will take an array of input types in a current frame and validate them appropriately
 * array format = ["zip","phone","email"] etc
 * @param {array} inputs
 */
function validate(inputs) {
  var valid = true,
    //inputs = array, based on html5 data attribute
    frame = $('fieldset:visible')

  frame.find('.input').each(function () {
    //basic validation for empty or null / undefined
    if (
      $(this).val() === '' ||
      $(this).val() === undefined ||
      $(this).val() === null ||
      $(this).val().replace(/\s/g, '').length < 1
    ) {
      //if fails basic validation
      valid = false
      console.log($(this).prop('id') + ' generic input class failure')
      $(this).addClass('border-error')

      // special border error for surrounding div of input error
      $(this).parent('.special-border-error').addClass('border-error')

      //custom error message under input
      $(this).next('.custom-error').css('display', 'block')

      // only shows prop-city-state-error if the city/state element isvisible
      if ($('.city-state-prop').is(':visible')) {
        $(this).next('.prop-city-state-error').css('display', 'block')
      }

      if ($('[id^="msform-"] [name=state]').val() === null || $('[id^="msform-"] [name=state]').val() == '') {
        $('.city-state-second').show()
      }

      if ($('[id^="msform-"] [name=city]').val() === null || $('[id^="msform-"] [name=city]').val() == '') {
        $('.city-state-second').show()
      }

      // shows custom city/state error if this class exists.
      $(this).next('.city-state-error').css('display', 'block')

      // for sites with a dropdowns
      $('#label-current_loan_type').show()
      $('#label-own_rent').show()
      $('#label-moving_date').show()
    } else {
      $(this).removeClass('border-error')
      //remove custom error message under input
      $(this).next('.custom-error').css('display', 'none')
      //remove custom error message under input
      $(this).next('.city-state-error').css('display', 'none')
      $(this).next('.prop-city-state-error').css('display', 'none')
      // for sites with a dropdowns
      $('#label-current_loan_type').hide()
      $('#label-own_rent').hide()
      $('#label-moving_date').hide()

      curValue = $(this).val()

      if ($(this).is('input')) {
        cleanValue = curValue.replace(/\+/g, ' ')
        $(this).val(cleanValue)
      } else {
        $(this).val(curValue)
      }

      // mirrors the value to some name attributes in all forms on survey. Helps prevent split forms
      if (this.name === 'email' || this.name === 'first_name' || this.name === 'last_name') {
        $(`[name=${this.name}]`).val($(this).val())
      }
    }
  })

  //validation for if the frame includes zip
  if (inputs.includes('zip')) {
    zipValue = frame.find('.zipcode').val()
    zip = frame.find('.zipcode')
    //do zip validation
    if (checkZip(zipValue) === true) {
      //proceed
      $(this).removeClass('border-error')
      $('.zipcode-error-state').css('display', 'none')
    } else if (checkZip(zipValue) === false) {
      zip.addClass('border-error')
      $('.zipcode-error-state').css('display', 'block')
      valid = false
      console.log($(this).prop('id') + ' zip class failure')
    }
  }

  if (inputs.includes('prop-zip')) {
    zipValue = frame.find('.property-zipcode').val()
    zip = frame.find('.property-zipcode')
    //do zip validation
    if (checkZip(zipValue) === true) {
      //proceed
      $(this).removeClass('border-error')
      $('.zipcode-error-state').css('display', 'none')
    } else if (checkZip(zipValue) === false) {
      zip.addClass('border-error')
      $('.zipcode-error-state').css('display', 'block')
      valid = false
      console.log($(this).prop('id') + ' prop-zip class failure')
    }
  }

  //validation for if the frame includes email
  if (inputs.includes('email')) {
    emailValue = frame.find('.email').val()
    email = frame.find('.email')
    // do email validation
    if (validateEmail(emailValue) === true) {
      //proceed
      $(this).removeClass('border-error')
      // remove custom email error message
      $('.custom-error-email').css('display', 'none')
    } else if (validateEmail(emailValue) === false) {
      email.addClass('border-error')
      // show custom email error message
      $('.custom-error-email').css('display', 'block')
      valid = false
      console.log($(this).prop('id') + ' email class failure')
    }
  }

  //validation for YearHomeBuilt
  if (inputs.includes('YearHomeBuilt')) {
    yearValue = parseInt(frame.find('.year').val())
    year = frame.find('.year')
    // do year validation
    if (validateYear(yearValue) === true) {
      //proceed
      $(this).removeClass('border-error')
      // remove custom error message
      $('.custom-error').css('display', 'none')
    } else if (validateYear(yearValue) === false) {
      year.addClass('border-error')
      // show custom email error message
      $('.custom-error-year').css('display', 'block')
      valid = false
      console.log($(this).prop('id') + ' invalid year')
    }
  }

  if (inputs.includes('phone')) {
    phone = frame.find('.phone')
    var phoneValue = phone.val().replace(/[^\d]/g, '')
    if (phoneValue.charAt(0) === '0' || phoneValue.charAt(0) === '1') {
      phone.addClass('border-error')
      var x = phone
        .val()
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      phone.val(!x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''))
      phone.val(phoneValue.slice(1))
      valid = false
      console.log('1 or 0 to start a phone number is not allowed')
    } else if (!phoneAreaCheck(phone.val()) && phone.val() !== '') {
      phone
        .addClass('border-error')
        .val('')
        .next('.custom-error')
        .text('Please enter a valid area code')
        .css('display', 'block')
      valid = false
    } else if (phoneValue.length == 10) {
      phone.removeClass('border-error')
    } else {
      phone.addClass('border-error').next('.custom-error').text('Please complete this field')
      valid = false
      console.log($(this).prop('id') + ' phone class failure')
    }
  }

  if (inputs.includes('name')) {
    const name = frame.find('.name')
    let triggerError = false
    let fnameMsg = 'Please complete this field'
    let lnameMsg = 'Please complete this field'

    name.each(function () {
      $(this).val(
        $(this)
          .val()
          .replace(/[\^\d\u0300-\u036f&/\\#=+()[\]$~%":*?<>{},.`']+/g, '')
      )

      // doesn't allow for three or more repeating characters
      if (/(.)\1{2,}/.test($(this).val())) {
        if ($(this).attr('name') === 'first_name') {
          fnameMsg = 'No repeating characters please'
        } else {
          lnameMsg = 'No repeating characters please'
        }

        triggerError = true
        valid = false
      } else if ($(this).val().length < 2 && $(this).val().length > 0) {
        triggerError = true

        if ($(this).attr('name') === 'first_name') {
          fnameMsg = 'Please enter your first name for best results'
        } else {
          lnameMsg = 'Please enter your last name for best results'
        }

        valid = false
      } else if (
        $(this).val() === '' ||
        $(this).val() === undefined ||
        $(this).val() === null ||
        $(this).val().replace(/\s/g, '').length < 1
      ) {
        triggerError = true
        valid = false
      }

      if (triggerError) {
        $(this).addClass('border-error')
        if ($(this).attr('name') === 'first_name') {
          $(this).next('.custom-error').text(fnameMsg).css('display', 'block')
        } else {
          $(this).next('.custom-error').text(lnameMsg).css('display', 'block')
        }
        triggerError = false
      } else {
        $(this).removeClass('border-error')
        $($(this)).next('.custom-error').css('display', 'none')
      }
    })
  }

  //validation for BirthDay Drop downs
  try {
    if (frame[0].id === 'birthday-step') {
      let today = new Date()
      const day = today.getDate()
      const month = today.getMonth() + 1
      const year = today.getFullYear()
      const ogErrorText = $('.custom-error').text()
      let errorReason = ogErrorText
      const bday = year - 16 + '-' + month + '-' + day
      today = year + '-' + month + '-' + day
      if ($('#birthDate').val() >= bday) {
        errorReason = `Please enter a year less than ${year - 16}`
        $('.custom-error').show().text(errorReason)
        valid = false
      } else if ($('#birthDate').val() <= '1910-01-01') {
        errorReason = 'Please enter a year greater than 1910'
        $('.custom-error').show().text(errorReason)
        valid = false
      } else {
        $('.custom-error').hide().text('Please complete this field')
      }
    }
  } catch (error) {
    // do nothing
  }

  //validation for BirthYear
  try {
    if (frame[0].id === 'birth-year-step' || frame[0].id === 'path') {
      const birthMonth = $('.birthMonthButton:checked').val()
      const birthDay = $('.birthDayButton:checked').val()
      const birthYearValue = $('#birthYearMobile').val()
      const ogErrorText = $('.birth-year-error').text()
      const BirthDate = `${birthYearValue || 1990}-${birthMonth || 10}-${birthDay || 21}`
      let errorReason = ogErrorText

      if (+birthYearValue >= 1900 && +birthYearValue <= 2013 && birthYearValue.length === 4) {
        $('[name=BirthDate]').val(BirthDate)
        // adds calculated age if on med dot insurance site
        if ($('#medAge').length) {
          $('#medAge').val(getAge(BirthDate))
        }
      } else {
        if (+birthYearValue <= 1900) {
          errorReason = 'Please enter a year greater than 1900'
        } else if (+birthYearValue >= 2013) {
          errorReason = 'Please enter a year less than 2013'
        } else if (birthYearValue.length !== 4) {
          errorReason = 'Year must be 4 numbers in length'
        }

        $('.birth-year-error').show().text(errorReason)
        $('#birthYearMobile').addClass('border-error')
        valid = false
      }
    }
  } catch (error) {
    // do nothing
  }
  // validation for personal loan survey desired amount question
  try {
    if (frame[0].id === 'desired-amount') {
      const amount = $('#amount').val()
      if (amount >= 50001 || amount <= 999) {
        $('.custom-error').show()
        $('.input').addClass('border-error')
        valid = false
      } else {
        $('.custom-error').hide()
        $('.input').removeClass('border-error')
      }
    }
    // validation for personal loan survey desired amount question
    if (frame[0].id === 'annual-income') {
      const annualIncome = $('#annualIncome').val()
      if (annualIncome >= 1000001 || annualIncome <= 999) {
        $('.custom-error').show()
        $('.input').addClass('border-error')
        valid = false
      } else {
        $('.custom-error').hide()
        $('.input').removeClass('border-error')
      }
    }
  } catch (error) {
    // do nothing
  }
  //for med2.insurancespecialists.com
  try {
    if (document.URL.indexOf('med2.insurancespecialists.com') >= 0) {
      if (frame[0].id === 'birth-year-step') {
        if (!$("input[name='Gender']").is(':checked')) {
          $('.custom-error').show()
          $('.mobileButton').addClass('border-error')
          valid = false
        } else {
          $('.custom-error').hide()
          $('.mobileButton').removeClass('border-error')
        }
      }
    }
  } catch (error) {
    // do nothing
  }
  // for mpi2.insurancespecialists.com
  try {
    if (document.URL.indexOf('mpi2.insurancespecialists.com') >= 0 || document.URL.indexOf('localhost') >= 0) {
      const birthDay = $('#birthDate')
      if (birthDay.val() <= '1900-01-01') {
        $('.birthday-error').html('Please enter a year greater than 1900').show()
        birthDay.addClass('border-error')
        valid = false
      } else {
        $('.birthday-error').hide()
        birthDay.removeClass('border-error')
      }
    }
  } catch (error) {
    // do nothing
  }
  //for life.insurancespecialists.com
  try {
    if (frame[0].id === 'weight-step') {
      // calculates the users BMI
      const height = $('#heightFeet').val() * 12 + parseFloat($('#heightInches').val())
      console.log('height: ' + height)
      const weight = $('#weight').val()
      console.log('weight: ' + weight)
      const bmi = (weight / (height * height)) * 703
      console.log('bmi: ' + bmi)
      //return 0 if the user is not over weight and return 1 if the user is over weight
      if (bmi && weight.length >= 2) {
        if (bmi > 25 && bmi < 29.9) {
          $('[name=HasHighBMI]').val(1)
        }
        if (bmi > 35 && bmi < 40) {
          $('[name=HasHighBMI]').val(1)
        }
        if (bmi > 40) {
          $('[name=HasHighBMI]').val(1)
        }
        $('.custom-error').hide()
        $('#weight').removeClass('border-error')
      } else {
        $('.custom-error').show()
        $('#weight').addClass('border-error')
        $('[name=HasHighBMI]').val(0)
        valid = false
      }
    }
  } catch (error) {
    // do nothing
  }

  return valid
}

/**
 * From here down are a variety of helper methods used in live validation or by the core validate function
 */

//populate the refi_purpose field based on additional cash needed
function populateAdditionalCash() {
  if (
    $("[name='additional_cash_needed']").find(':selected').val() === '0' ||
    $('#no-cash').is(':checked') ||
    $('#cashOutValuePost').val() <= 0 ||
    $('#cashOutSelect').val() <= 0
  ) {
    $('#refi_purpose').val('Lower Payments')
  } else if (
    $("[name='additional_cash_needed']").find(':selected').val() === '5000' ||
    $('#yes-cash').is(':checked') ||
    $('#cashOutValuePost').val() > 0 ||
    $('#cashOutSelect').val() > 0
  ) {
    $('#refi_purpose').val('Cash Out')
  }
}

//decide whether a zipcode was good or bad and show error state or progress user
function checkZip(value) {
  return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value)
}

//Fetches zipcode data if the entered zip is the correct number of digits
function normalizeZip(that) {
  // Get zip code
  var zipcode = $(that)
    .val()
    .replace(/[^0-9]/g, '')
    .substring(0, 5)
  $(that).val(zipcode)
  return zipcode
}

// Prevents the decimal from being used on zip codes.  Still allows decimal on mobile but other functions strip it out
function preventDecimal(e) {
  if (e.key === '.') {
    e.preventDefault()
  }
}

//regex for the email validation
function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

//parse out spaces from email
function validateEmailClass() {
  $(this).val(this.value.replace(/\s/g, ''))
  $(this).val(this.value.replace(/.comm/g, '.com'))
}

//parse out wacky stuff from name field
function validateName() {
  $(this).val(this.value.replace(/[\^\d\u0300-\u036f&/\\#=+()[\]$~%":*?<>{},`.;!@_|']/i, ''))

  // won't let you put a dash as the first character which will prevent users from using only a dash for the name.
  var dash = '-'
  if ($(this).val().length === 1 && $(this).val() === dash) {
    $(this).val(this.value.replace('-', ''))
  }
}

// trims empty spaces but lets the user type in a two word name
function validateNameBlur() {
  $(this).val($.trim(this.value))
}

//live address validaiton
function validateAddressClass() {
  $(this).val(this.value.replace(/^\s+/, '').replace(/[^0-9a-z ,.#'-]/i, ''))
}

//parse out wacky stuff from city field
function validateCityClass() {
  $(this).val(this.value.replace(/^\s+/, '').replace(/[^a-z',\s\u00C0-\u017F]/i, ''))
}

//Phone validation
function validatePhone(e) {
  var last = $(this)
    .val()
    .substr($(this).val().indexOf('-') + 1)

  if (last.length == 5) {
    var move = $(this)
      .val()
      .substr($(this).val().indexOf('-') + 1, 1)
    var lastfour = last.substr(1, 4)
    var first = $(this).val().substr(0, 9)
    $(this).val(first + move + '-' + lastfour)
  }

  // prevents users from starting their phone number with a 1 or a 0
  if (this.value.charAt(1) === '0' || this.value.charAt(1) === '1') {
    this.value = this.value.slice(2)
  }

  var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
  e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
}

//Year validation
function validateYear(year) {
  const yearString = year.toString()
  let yearVal = parseInt(year)
  let currentYear = new Date().getFullYear()
  if (yearVal >= 1800 && yearVal <= currentYear && yearString.length === 4) {
    return true
  } else {
    return false
  }
}

/* this module contains some methods for getting data from a zipcode api
 */

$('.property-zipcode, .zipcode').on('keydown', function (e) {
  if (e.which == 69) {
    e.preventDefault()
  }
})

/**
 * @param  {} zipcode
 * @param  {} propZip
 * @param  {} prepop
 * @param  {} sameCity
 */
function doZipCodeOperations(zipcode, propZip, prepop, sameCity) {
  function zipcodeErrorHandler() {
    if (propZip !== true) {
      $('.city-state').show()
      $('.city-state-second').show()
      $('.address_string').hide()
      getElectricProviders(false)
    } else {
      $('.city-state-prop').show()
    }
  }

  function fetchData(zipcode) {
    var url = 'https://api.zippopotam.us/us/' + zipcode
    $.ajax({
      url: url,
      dataType: 'json',
    })
      .done(function (data) {
        isZipValid = true
        assignZipData(data)

        // passes user zipcode to start the hisCheck function in hisParam.js
        startHisCheck(zipcode, true)
      })
      .fail(function () {
        isZipValid = false
        zipcodeErrorHandler()

        // passes user zipcode to start the hisCheck function in hisParam.js
        startHisCheck(zipcode, false)
      })
  }

  function assignZipData(data) {
    var places = data.places[0],
      placesZipcode = data['post code'],
      zipObj = {
        cityName: places['place name'] || 'Default City',
        stateName: places.state || 'Virgin Islands',
        stateCode: places['state abbreviation'] || 'VI',
        locationLongitude: places.longitude,
        locationLatitude: places.latitude,
      }

    // assign the zip data
    if (isSolar === true) {
      solarZipCheck(true, zipObj.stateCode, placesZipcode)
    }

    // fires function if call.ratemarketplace.com and if that function exists.  Syncs up property zip info for purchase path
    if (callDotRMP && typeof setCALLDOTRMPPropZipData === 'function' && current_form.form_id === 'msform-purchase') {
      setCALLDOTRMPPropZipData(zipObj, placesZipcode)
    }

    if (propZip === true) {
      $('[name=property_city], [name=PropertyCity]').val(zipObj.cityName)
      $('[name=property_state], [name=PropertyState]').val(zipObj.stateCode)
      $('[name=property_zip], [name=PropertyZip]').val(placesZipcode)
      $('.city-state, .prop-city-state-error, .zipcode-error-state').hide()
      $('.city-state-error, .prop-city-state-error, .city-state-prop').hide()
    } else {
      $('[name=city]').val(zipObj.cityName)
      $('[name=state]').val(zipObj.stateCode)
      $('[name=zipcode]').val(placesZipcode)

      // populates location span data if it exists.  Has to run inside this else block to prevent property_zip data from populating here.
      if ($('.city_span').length > 0 || $('.state_span').length > 0 || $('.zip_span').length > 0) {
        $('.address_string .city_span').text(zipObj.cityName)
        $('.address_string .state_span').text(zipObj.stateCode)
        $('.address_string .zip_span').text(placesZipcode)
        $('.address_string').show()
      }

      if (sameCity == true) {
        $('[name=property_city]').val(zipObj.cityName)
        $('[name=property_state]').val(zipObj.stateCode)
        $('[name=property_zip]').val(placesZipcode)
      }

      $('.city-state-second, .city-state, .city-state-error, .zipcode-error-state').hide()
      $('[name=zipcode]').removeClass('border-error')
    }
  }

  if (zipcode.length == 5) {
    fetchData(zipcode)
  } else {
    return
  }
}

function setCityState() {
  const city = $('#' + current_form.form_id + ' [name=city]').val()
  $('.address_string .city_span').text(city)
  $('[name=city]').val(city)

  const state = $('#' + current_form.form_id + ' [name=state]').val()
  $('.address_string .state_span').text(state)
  $('[name=state]').val(state)

  const zipcode = $('#' + current_form.form_id + ' [name=zipcode]').val()
  $('.address_string .zip_span').text(zipcode)
  $('[name=zipcode]').val(zipcode)
  if (city !== '' && state !== '' && zipcode !== '') {
    $('.address_string').show()
    $('.city-state-second, .city-state, .city-state-error, .zipcode-error-state').hide()
  }
}

const winWidth = $(window).width()

// sets autoscroll defaults. Can be overwritten in custom.js
let autoScroll = {
  enabled: false, // only runs autoScrollFunction if set to true in custom.js
  scrollElements: [
    {
      scrollFieldSet: '', // this value is checked with an includes() method
      scrollToElement: '', // any element jQuery can target
      device: 'mobile', // mobile, desktop, or both
      bothPositions: 0,
      mobilePosition: 0,
      desktopPosition: 0,
    },
  ],
  disableAll: false,
  mobileTCPAOffset: 75,
}

/**
 * triggers the scrollTop animation
 * @param  {string} element
 * @param  {string} offset
 */

function animateFunction(element, offset) {
  $('html, body').animate(
    {
      scrollTop: $(element + ':visible').offset().top + offset,
    },
    0
  )
}

/**
 * Performs auto scroll functionality on each step
 * Checks an array of elements and sets it's autoscroll and position
 * Globally set variable scrolls on final frame on mobile but can be overwritten in custom.js
 * @param  {string} fsId
 */
function autoScrollFunction(fsId) {
  if (!autoScroll.enabled) {
    window.scrollTo(0, 0)
    return
  } else if (autoScroll.disableAll) {
    return
  } else {
    const array = autoScroll.scrollElements
    for (let i = 0; i < array.length; i++) {
      if (fsId.includes(array[i].scrollFieldSet)) {
        if (array[i].device === 'both') {
          animateFunction(array[i].scrollToElement, array[i].bothPositions)
        } else if (winWidth <= 800 && array[i].device === 'mobile') {
          animateFunction(array[i].scrollToElement, array[i].mobilePosition)
        } else if (array[i].device === 'desktop') {
          animateFunction(array[i].scrollToElement, array[i].desktopPosition)
        } else {
          window.scrollTo(0, 0)
        }
      } else {
        window.scrollTo(0, 0)
      }
    }
    return
  }
}

// this function is only fired on the callback of the tcpa rules engine call
function autoScrollTCPA() {
  const tcpa = document.getElementById('tcpa')
  const tcpaTop = tcpaOffset(tcpa)

  // keep logs until we go to prod
  const scrollBottom = tcpaTop - $(window).height()
  const offsetValue = scrollBottom + autoScroll.mobileTCPAOffset
  if (autoScroll.disableAll) {
    return
  } else {
    $('html, body').animate(
      {
        scrollTop: $('body').offset().top + offsetValue,
      },
      0
    )
  }
}

var hisParam = getParameterByName('his')
var hisDivWrap
var zipArray = [
  '92350',
  '92354',
  '92357',
  '92359',
  '92372',
  '92373',
  '92374',
  '92376',
  '92377',
  '92392',
  '92393',
  '92394',
  '92395',
  '92397',
  '92399',
  '92401',
  '92402',
  '92403',
  '92404',
  '92405',
  '92406',
  '92407',
  '92408',
  '92410',
  '92411',
  '92413',
  '92414',
  '92415',
  '92418',
  '92530',
  '92531',
  '92532',
  '92545',
  '92546',
  '92548',
  '92549',
  '92551',
  '92552',
  '92553',
  '92555',
  '92556',
  '92557',
  '92562',
  '92563',
  '92567',
  '92570',
  '92571',
  '92572',
  '92581',
  '92582',
  '92583',
  '92584',
  '92585',
  '92586',
  '92587',
  '92589',
  '92590',
  '92591',
  '92592',
  '92593',
  '92595',
  '92596',
  '92599',
  '92602',
  '92603',
  '92604',
  '92605',
  '92606',
  '92610',
  '92612',
  '92543',
  '92614',
  '92615',
  '92616',
  '92617',
  '92618',
  '92619',
  '92620',
  '92623',
  '92625',
  '92626',
  '92627',
  '92628',
  '92630',
  '92637',
  '92646',
  '92647',
  '92648',
  '92649',
  '92651',
  '92655',
  '92656',
  '92657',
  '92658',
  '92659',
  '92660',
  '92661',
  '92662',
  '92663',
  '92676',
  '92683',
  '92684',
  '92688',
  '92697',
  '92698',
  '92701',
  '92702',
  '92703',
  '92704',
  '92705',
  '92706',
  '92707',
  '92708',
  '92711',
  '92728',
  '92780',
  '92781',
  '92782',
  '92799',
  '92821',
  '92822',
  '92823',
  '92831',
  '92832',
  '92833',
  '92834',
  '92835',
  '92836',
  '92837',
  '92840',
  '92841',
  '92842',
  '92843',
  '92844',
  '92845',
  '92856',
  '92857',
  '92860',
  '92861',
  '92862',
  '92863',
  '92865',
  '92866',
  '92867',
  '92868',
  '92869',
  '92870',
  '92871',
  '92877',
  '92878',
  '92879',
  '92880',
  '92881',
  '92882',
  '92883',
  '92885',
  '92886',
  '92887',
  '93001',
  '93002',
  '93003',
  '93004',
  '93009',
  '93010',
  '93011',
  '93012',
  '93030',
  '93031',
  '93032',
  '93033',
  '93035',
  '93036',
  '93041',
  '93042',
  '93043',
  '93044',
  '93062',
  '93063',
  '93064',
  '93065',
  '93618',
  '93219',
  '93647',
  '93256',
  '93274',
  '93277',
  '93279',
  '93291',
  '93292',
  '93286',
  '93301',
  '93302',
  '93303',
  '93304',
  '93305',
  '93306',
  '93307',
  '93308',
  '93309',
  '93311',
  '93312',
  '93313',
  '93314',
  '93380',
  '93381',
  '93383',
  '93384',
  '93385',
  '93387',
  '93388',
  '93389',
  '93390',
  '93206',
  '93241',
  '93250',
  '93263',
  '93268',
  '93280',
  '93212',
  '93230',
  '93232',
  '93245',
  '93246',
  '93266',
  '93610',
  '93614',
  '93626',
  '93636',
  '93637',
  '93638',
  '93639',
  '95340',
  '95341',
  '95343',
  '95344',
  '95348',
  '93611',
  '93612',
  '93613',
  '93619',
  '93609',
  '93210',
  '93622',
  '93650',
  '93701',
  '93702',
  '93703',
  '93704',
  '93705',
  '93706',
  '93707',
  '93709',
  '93710',
  '93711',
  '93712',
  '93718',
  '93720',
  '93721',
  '93722',
  '93723',
  '93724',
  '93725',
  '93726',
  '93727',
  '93728',
  '93729',
  '93730',
  '93737',
  '93740',
  '93741',
  '93744',
  '93745',
  '93760',
  '93764',
  '93765',
  '93771',
  '93772',
  '93776',
  '93778',
  '93790',
  '93792',
  '93630',
  '93631',
  '93648',
  '93651',
  '93654',
  '93657',
  '93662',
  '93667',
  '93668',
  '92108',
  '92109',
  '92110',
  '92111',
  '92113',
  '92114',
  '92115',
  '92116',
  '92117',
  '92118',
  '92119',
  '92120',
  '92121',
  '92122',
  '92123',
  '92124',
  '92126',
  '92127',
  '92128',
  '92129',
  '92130',
  '92139',
  '92145',
  '92154',
  '92173',
  '92536',
  '92624',
  '92629',
  '92651',
  '92653',
  '92656',
  '92672',
  '92673',
  '92675',
  '92677',
  '92679',
  '92688',
  '92691',
  '92692',
  '92694',
  '91901',
  '91902',
  '91910',
  '91911',
  '91913',
  '91914',
  '91915',
  '91932',
  '91935',
  '91941',
  '91942',
  '91945',
  '91948',
  '91977',
  '91978',
  '92003',
  '92007',
  '92008',
  '92009',
  '92010',
  '92011',
  '92014',
  '92019',
  '92020',
  '92021',
  '92024',
  '92025',
  '92026',
  '92027',
  '92028',
  '92029',
  '92036',
  '92037',
  '92040',
  '92054',
  '92056',
  '92057',
  '92058',
  '92059',
  '92061',
  '92064',
  '92065',
  '92067',
  '92069',
  '92070',
  '92071',
  '92075',
  '92078',
  '92081',
  '92082',
  '92083',
  '92084',
  '92091',
  '92092',
  '92101',
  '92102',
  '92103',
  '92104',
  '92105',
  '92106',
  '92107',
]

function his1AddInsCheckbox() {
  if ($('.hisInsurance').length <= 0) {
    var hisInput = '<input type="checkbox" name="opt_home_insurance_quote" value="1" checked/>'
    var hisDiv =
      '<div class="hisInsurance"><label class="label">' +
      hisInput +
      "<p>I'm interested in saving money on my home insurance.</p></label></div>"
    hisDivWrap.prepend(hisDiv)
  }
}

function hisAddSolarCheckbox(zip, zipArray) {
  if ($('.hisSolar').length <= 0) {
    for (var i = 0; i < zipArray.length; i++) {
      if (zipArray[i] == zip) {
        var hisInput = '<input type="checkbox" name="solar" value="1" checked/>'
        var hisDiv =
          '<div class="hisSolar"><label class="label">' +
          hisInput +
          "<p>I'm interested in saving money by switching to solar energy for my home.</p></label></div>"
        hisDivWrap.prepend(hisDiv)
      }
    }
  }
}

function hisAddInsRadio() {
  if ($('.hisInsuranceRadio').length <= 0) {
    var hisInput =
      '<label for="hiqYes"><input type="radio" id="hiqYes" name="opt_home_insurance_quote" value="1"> <span>&nbsp;Yes</span></label><label for="hiqNo"><input type="radio" id="hiqNo" name="opt_home_insurance_quote" value="0"><span>&nbsp;No</span></label><br>'
    var hisDiv =
      '<div class="hisInsuranceRadio"><p>Check "Yes" for a quick savings quote on your <br>Homeowners Insurance Coverage</p><br><div class="inputWrapper">' +
      hisInput +
      '</div></div>'
    hisDivWrap.prepend(hisDiv)
  }
}

function hisAddSolarRadio(zip, zipArray) {
  if ($('.hisSolar').length <= 0) {
    for (var i = 0; i < zipArray.length; i++) {
      if (zipArray[i] == zip) {
        var hisInput =
          '<label for="hiqYes"><input type="radio" id="hiqYes" name="solar" value="1"> <span>&nbsp;Yes</span></label><label for="hiqNo"><input type="radio" id="hiqNo" name="solar" value="0"><span>&nbsp;No</span></label><br>'
        var hisDiv =
          '<div class="hisInsuranceRadio"><p>I\'m interested in saving money by switching to solar energy for my home.</p><br><div class="inputWrapper">' +
          hisInput +
          '</div></div>'
        hisDivWrap.prepend(hisDiv)
      }
    }
  }
}

function his2AddInsCheckbox() {
  if ($('.hisInsurance').length <= 0) {
    var hisInput = '<input type="checkbox" name="opt_home_insurance_quote" value="1" />'
    var hisDiv =
      '<div class="hisInsurance"><label class="label">' +
      hisInput +
      '<p>Check "Yes" for a quick savings quote on your Homeowners Insurance Coverage</p></label></div>'
    hisDivWrap.prepend(hisDiv)
  }
}

function startHisCheck(zip, zipApiSuccess) {
  if (hisParam === '1') {
    $('.hisWrapper').remove()
    hisDivWrap = $('<div>')
    hisDivWrap.addClass('hisWrapper')

    if (zipApiSuccess) {
      $('#msform-refinance .submit-button').parent('div').prepend(hisDivWrap)
      hisAddSolarCheckbox(zip, zipArray)
      his1AddInsCheckbox()
    } else {
      $('.hisWrapper').empty()
    }
  } else if (hisParam === '2') {
    $('.hisWrapper').remove()
    hisDivWrap = $('<div>')
    hisDivWrap.addClass('hisWrapper')

    if (zipApiSuccess) {
      $('#msform-refinance .submit-button').parent('div').prepend(hisDivWrap)
      his2AddInsCheckbox()
    } else {
      $('.hisWrapper').empty()
    }
  } else {
    // do nothing
    return
  }
}

/**
 * fired when user steps through the form and checks if certain fieldsets should be shown or not
 * @param  {} next_fs
 */
function nextFS(next_fs) {
  var fsReturned = current_fs.fs.next()

  try {
    var nextFSId = next_fs[0].id,
      creditSelect,
      currentLoanSelect,
      creditRating,
      currentLoanType,
      employmentValue
    // checks if req_id exists in the url. If it doesn't then check to see if the ckm_request_id exists in global scope.  If not then run getCakeOrganic() to get a request id
    // if there's not req id don't run partial save until there is one.
    if (!getParameterByName('req_id')) {
      if (
        isNaN(window.ckm_request_id) ||
        window.ckm_request_id == null ||
        window.ckm_request_id == undefined ||
        window.ckm_request_id === ''
      ) {
        getCakeOrganic(orgCakePix)
      }
    }

    // checks if user ip is valid. If not get a new one
    if (!validateUserIp(userIp)) {
      getUserIp()
    }

    // checks if the trusted form element exists
    if ($('[name=xxTrustedFormCertUrl]').length === 0 || $('[name=xxTrustedFormToken]').length === 0) {
      trustedForm()
    }

    // checks if the jornaya lead id value exists
    if (
      $('[name=universal_leadid]').val() === null ||
      $('[name=universal_leadid]').val() === undefined ||
      $('[name=universal_leadid]').val() === ''
    ) {
      if ($('[name=universal_leadid]').length === 0) {
        $('#disclosure-form').append(
          '<input id="leadid_token" class="leadid" name="universal_leadid" type="hidden" value="">'
        )
      }
      // try to initiate the Jornaya call again
      jornayaReRun()
    }

    // have to build the lead on each step so other things can fire.
    buildLead(current_form.form.serialize(), true)

    if (current_form) {
      creditSelect = $('#' + current_form.form_id + ' select[name=credit_rating]')
      currentLoanSelect = $('#' + current_form.form_id + ' select[name=current_loan_type]')
      creditRating = radioOrSelectValue('credit_rating', true)
      currentLoanType = radioOrSelectValue('current_loan_type', true)
      employmentValue = radioOrSelectValue('employer', true)
    } else {
      console.log('no')
      creditSelect = $('select[name=credit_rating]')
      currentLoanSelect = $('select[name=current_loan_type]')
      creditRating = radioOrSelectValue('credit_rating', false)
      currentLoanType = radioOrSelectValue('current_loan_type', false)
    }

    /************** STATIC NEXT STEP IDS - NOT DYNAMIC BASED ON USER SELECTION **************/

    /**** LATE ON MORTGAGE REFINANCE STEP ****/
    if (nextFSId === 'late-on-mortgage-refinance') {
      if (current_form.form_id === 'msform-refinance' && creditRating === 'poor' && creditSelect.length === 0) {
        if (noNextButton) {
          $('#current').prop('checked', false)
          $('#opt_mortgage_late_months').prop('selectedIndex', 0).val('0')
          fsReturned = $('#late-on-mortgage-refinance')
        } else {
          $('#current').prop('checked', true)
          $('#opt_mortgage_late_months').prop('selectedIndex', 0).val('0')
          fsReturned = $('#late-on-mortgage-refinance')
        }
      } else if (current_form.form_id === 'msform-refinance' && creditSelect.length > 0) {
        if (creditRating !== 'poor') {
          $('select[name=opt_mortgage_late_months] option:selected').val('')
          fsReturned = $('#late-on-mortgage-refinance').next()
        } else {
          $('select[name=opt_mortgage_late_months] option:selected').val('0')
          fsReturned = $('#late-on-mortgage-refinance')
        }
      } else {
        $('#opt_mortgage_late_months').prop('selectedIndex', 0).val('')
        $('[name=opt_mortgage_late_months]').prop('checked', false)
        fsReturned = $('#late-on-mortgage-refinance').next()
      }
    }

    /**** ESTIMATED DEBT PURCHASE STEP ****/
    if (nextFSId === 'estimated-debt-step-purchase') {
      if (current_form.form_id === 'msform-purchase') {
        if (creditRating === 'poor') {
          if (!noNextButton) {
            $('#estimated-debt-0-p').prop('checked', true)
          }
          fsReturned = $('#estimated-debt-step-purchase')
        } else {
          $('[name=estimated_debt]').prop('checked', false)
          fsReturned = $('#estimated-debt-step-purchase').next()
        }
      } else {
        fsReturned = $('#estimated-debt-step-purchase').next()
      }
    }

    /**** CASH NEEDED REFINANCE STEP ****/
    if (nextFSId === 'cash-needed-refinance') {
      if (equity() <= 0 && runCashOutLTV === true) {
        $('input[name=additional_cash_needed]').val('0')
        fsReturned = $('#cash-needed-refinance').next().next()
      } else {
        fsReturned = $('#cash-needed-refinance')
      }
    }

    /**** ADDITIONAL CASH REFINANCE STEP ****/
    if (nextFSId === 'additional-cash-refinance') {
      // updates the cashOutValues variable with the latest cashOutArray values and resets the cashOut Slider
      cashOutValues = createCashOutArray()

      // adds equity to this span if it exists
      if ($('.addl-cash-equity').length > 0) {
        if (equity() > 0) {
          $('.addl-cash-equity').text(equity().toLocaleString())
        } else {
          $('.addl-cash-equity').text('5,000')
        }
      }

      // this updates the refi_purpose based on the user selectiong yes or no on cash out radios
      populateAdditionalCash()

      if ($('[name=cash_needed]:checked').val() === '0') {
        $('input[name=additional_cash_needed]').val('0')
        $('[name=refi_purpose]').val('Lower Payments')
        fsReturned = $('#additional-cash-refinance').next()
      } else {
        fsReturned = $('#additional-cash-refinance')
      }
    }

    /**** INTEREST RATE REFINANCE STEP ****/
    if (nextFSId === 'interest-rate-refinance') {
      var amountOwned = parseInt($('[name=mortgage_amount]').val()),
        addlCashValChecked = $('input[name=additional_cash_needed]:checked').val()
      // processes additional cash caluculations based on users equity after they have chosen mort-amount and prop-value
      // only used on sites where global variable (set in custom.js) equityAsAddlCash is true
      // If users current_loan_type is VA then run equityAndAddlCash function and pass 1 for 100% equity
      if (equityAsAddlCash) {
        if (currentLoanType === 'VA' || currentLoanType === 'va') {
          equityAndAddlCash(0.95)
        } else {
          equityAndAddlCash()
        }
      }

      //This basically passes the equity as additional_cash_needed if the mortgage_amount is less than 100k.
      if (addlCashValChecked >= 5000) {
        if (amountOwned <= 100000) {
          if (equity() > 0) {
            $('input[name=additional_cash_needed]:checked').val(equity())
          } else {
            $('input[name=additional_cash_needed]:checked').val('5000')
          }
        } else {
          $('input[name=additional_cash_needed]:checked').val('5000')
        }
      } else {
        $('input[name=additional_cash_needed]:checked').val('0')
      }
    }

    /**** ZIPCODE2 PURCHASE STEP ****/
    if (nextFSId === 'zipcode2-step-purchase') {
      var same_city = $('#same-city').prop('checked')

      if (same_city === false || isZipValid == false) {
        // clear property values if same-city is unchecked
        $('[name=property_city], [name=PropertyCity]').val('')
        $('[name=property_state], [name=PropertyState]').val('')
        $('[name=property_zip], [name=PropertyZip]').val('')

        fsReturned = $('#zipcode2-step-purchase')
      } else if (same_city === true) {
        fsReturned = $('#zipcode2-step-purchase').next()

        //set the values of the property zip
        $('[name=property_city]').val($('[name=city]').val())
        $('[name=property_state]').val($('[name=state]').val())
        $('[name=property_zip]').val($('[name=zipcode]').val())
      }
    }

    /**** UNEMPLOYMENT STEP ****/
    if (nextFSId === 'unemployment-step-refinance' || nextFSId === 'unemployment-step-purchase') {
      if (employmentValue === 'unemployed') {
        $('[name=employer]').prop('checked', true)
        fsReturned = $('#' + nextFSId)
      } else {
        fsReturned = $('#' + nextFSId).next()
      }
    }

    /**** AGE VERIFICATION STEP FOR REVERSE MORTGAGE SITES ****/
    /*     if (nextFSId === 'age-verification-step-refinance') {
        var propStepValue = $('#property-step-refinance input[name=property_type]:checked').val(),
            propWorth = $('#' + current_form.form_id + ' [name=est_property_value]').val(),
            mortAmount = $('#' + current_form.form_id + ' [name=mortgage_amount]').val(),
            mortLTV = Math.floor((parseInt(mortAmount) / parseInt(propWorth)) * 100)
        console.log(mortLTV, ' is the ltv')
        if (propStepValue === 'Mobile Home') {
            console.log(propStepValue, ' is the prop type, skip age verification step')
            fsReturned = $('#military_opt_refinance')
        } else if (mortLTV >= 50) {
            console.log('mortLV is greater than 50%, skip age verification step')
            fsReturned = $('#military_opt_refinance')
        }
    } */

    /**** REVERSE MORTGAGE QUALIFIER TO SKIP TO FINAL FRAME ****/
    /*     if ($('#age-verification-reverse').length) {
        if (nextFSId === 'military_opt_refinance' && $('[name=age] option:selected').val() !== '61 or under') {
            fsReturned = $('#final-frame-refinance')
            $('[name=loan_purpose]').val('Reverse')
            $('[name=credit_rating]').val('good')
            $('[name=current_loan_type]').val('')
            $('[name=refi_purpose]').val('')
            $('[name=mortgage_rate]').val('')
            $('[name=opt_served_military]').val('')
        }
    } */

    //for secondary vehicle on auto insurance
    if (nextFSId === 'secondary-vehicle-auto') {
      if ($('[name=additionalVehicle]:checked').val() === '1') {
        findMakeAndModel(true, 'GetYears')
        $('#vehicleMakeBlock2, #vehicleModelBlock2').hide()
      } else {
        fsReturned = $('#secondary-vehicle-auto').next()
        $('#vehicleMakeBlock2, #vehicleModelBlock2').hide()
        $('#VehicleYear2, #VehicleMake2, #VehicleModel2').empty()
        $('[name=VehicleYear2], [name=VehicleMake2], [name=VehicleModel2]').val('')
      }
    }
    //for secondary vehicle on auto insurance for mobile
    if (nextFSId === 'vehicle2-year-auto') {
      if ($('[name=additionalVehicle-b]:checked').val() === '1') {
        findMakeAndModelMobile(true, 'GetYears')
      } else {
        fsReturned = $('#vehicle2-year-auto').next().next().next()
        $('#VehicleYear2, #VehicleMake2, #VehicleModel2').empty()
        $('[name=VehicleYear2], [name=VehicleMake2], [name=VehicleModel2]').val('')
      }
    }
    /****Hide current insurance provider if unisured****/
    if (fsReturned[0].id === 'current-insurance-auto') {
      if (radioOrSelectValue('CurrentlyInsured', true) === '1') {
        fsReturned = $('#current-insurance-auto')
      } else {
        fsReturned = $('#current-insurance-auto').next()
      }
    }
    //for homeowner question on auto mobile version
    if (nextFSId === 'home-insurance-auto-mobile') {
      if ($('#' + current_form.form_id + ' [name=own_rent]:checked').val() === 'own') {
        fsReturned = $('#home-insurance-auto-mobile')
      } else {
        fsReturned = $('#home-insurance-auto-mobile').next().next().next()
        $('#' + current_form.form_id + ' #homeowners-m').prop('checked', false)
        $('#' + current_form.form_id + ' #noHomeOwners-m').prop('checked', true)
        $('[name="PropertyType"]').val('')
        $('[name="YearHomeBuilt"]').val('')
      }
    }

    //for desired insurance question on auto mobile version
    if (nextFSId === 'property-type-auto-mobile') {
      if ($('#home-insurance-auto-mobile [name=DesireHomeownersInsurance]:checked').val() === '1') {
        fsReturned = $('#property-type-auto-mobile')
      } else {
        fsReturned = $('#property-type-auto-mobile').next().next()
        $('[name=PropertyType], [name=YearHomeBuilt]').val('')
      }
    }

    // this block only relates to my100kquiz.com and shouldn't fire on anything else.
    if (nextFSId === 'final-frame-purchase' && my100kPurchaseRedirect === true) {
      $('#loading-gif').show()

      setTimeout(function () {
        $('#final-frame-purchase').css('visibility', 'hidden')
      }, 100)

      setTimeout(function () {
        var state = $('#msform-purchase select[name=state] option:selected').val()
        if (creditRating === 'excellent' || creditRating === 'good' || creditRating === 'average' || state === 'NY') {
          window.location = 'https://suited45trk.com/?E=bmnFAnaABBVhCmwRLWAzR2MpL0%2biTEsP'
        } else {
          window.location = 'https://suited45trk.com/?E=Tx%2bVXq8wGsMd0vhPguoddXmVDTI7y6aG'
        }
      }, 300)
    }

    /************** DYNAMIC NEXT STEP IDS - NOT STATIC DOM ONLOAD - ASCENDING ORDER IS CRITICAL **************/

    /**** REAL ESTATE REFINANCE STEP ****/
    if (fsReturned[0].id === 'real-estate-refinance') {
      if (creditRating === 'poor' || creditRating === 'fair') {
        if (noNextButton) {
          $('#sell-house-no').prop('checked', false)
          fsReturned = $('#real-estate-refinance')
        } else {
          $('#sell-house-no').prop('checked', true)
          fsReturned = $('#real-estate-refinance')
        }
      } else {
        $('#sell-house-no, #sell-house-yes').prop('checked', false)
        fsReturned = $('#real-estate-refinance').next()
      }
    }

    /**** MORTGAGE PAYMENT PURCHASE STEP ****/
    if (fsReturned[0].id === 'mortgage-payment-step-purchase') {
      const ownRent = radioOrSelectValue('own_rent', true)
      if (ownRent === 'own') {
        fsReturned = $('#mortgage-payment-step-purchase')
      } else {
        $('[name=current_lender]').prop('selectedIndex', 0).val('')
        fsReturned = $('#mortgage-payment-step-purchase').next()
      }
    }

    /**** ESTIMATED DEBT REFINANCE STEP ****/
    if (fsReturned[0].id === 'estimated-debt-step-refinance') {
      if (current_form.form_id === 'msform-refinance') {
        if (creditRating === 'poor') {
          if (!noNextButton) {
            $('#estimated-debt-0').prop('checked', true)
          }
          fsReturned = $('#estimated-debt-step-refinance')
        } else {
          $('[name=estimated_debt]').prop('checked', false)
          fsReturned = $('#estimated-debt-step-refinance').next()
        }
      } else {
        fsReturned = $('#estimated-debt-step-refinance').next()
      }
    }

    /****  CURRENTLY INSURED INSURANCE STEP ****/
    // only skip if param exists
    // if (getParameterByName('ag') === '1') {
    //   if (fsReturned[0].id === 'currently-insured-step') {
    //     if ($('input[name=CurrentlyInsured]').is(':checked')) {
    //       fsReturned = $('#currently-insured-step').next()
    //     }
    //   }
    // }

    /**** FINAL FRAME STEP ****/
    if (fsReturned[0].id.indexOf('final-frame-') !== -1) {
      // populates city/state data if zip was bad.
      setCityState()

      // if an rmp site check if site is in array if so redirect user before final frame to special RMP TY page
      if (document.URL.indexOf('ratemarketplace') >= 0 && offerId() !== '2222') {
        const rmpStates = [
            'CT',
            'GA',
            'HI',
            'IL',
            'KS',
            'MD',
            'MA',
            'MI',
            'NV',
            'NJ',
            'NY',
            'OH',
            'PR',
            'RI',
            'SC',
            'TN',
            'VI',
            'WI',
          ],
          rmpFormData = JSON.parse(storage('local', 'get', 'formData')),
          rmpState = $('#' + current_form.form_id + ' select[name=state]').val(),
          rmpPrefix = rmpFormData.credit_rating.charAt(0).toUpperCase() + 'C' + rmpFormData.loan_purpose.charAt(0)

        if ($.inArray(rmpState, rmpStates) !== -1 && rmpState !== null) {
          $('#loading-gif').show()

          setTimeout(function () {
            $('#final-frame-purchase', '#final-frame-refinance').css('visibility', 'hidden')
          }, 100)

          setTimeout(function () {
            window.location = `ty.html?prefix=${rmpPrefix}&credit_rating=${rmpFormData.credit_rating}&loan_purpose=${
              rmpFormData.loan_purpose
            }${trafficSource()}-ns`
          }, 300)
        }
      }
    }
  } catch (error) {
    return fsReturned
  }
  return fsReturned
}
/**
 * fired when user goes back through the form and checks if certain fieldsets should be shown or not
 * @param  {} prev_fs
 */
function prevFS(prev_fs) {
  var fsPrevReturned
  try {
    fsPrevReturned = current_fs.fs.prev()
    var prevFSId = prev_fs[0].id,
      creditRating = radioOrSelectValue('credit_rating', true),
      creditSelect = $('#' + current_form.form_id + ' select[name=credit_rating]'),
      employmentValue = radioOrSelectValue('employer', true)

    /************** DYNAMIC PREVIOUS STEP IDS - NOT STATIC DOM ONLOAD - DESC ORDER IS CRITICAL **************/

    /****  CURRENTLY INSURED INSURANCE STEP ****/
    // only skip if param exists
    // if (getParameterByName('ag') === '1') {
    //   if (fsPrevReturned[0].id === 'currently-insured-step') {
    //     if ($('input[name=CurrentlyInsured]').is(':checked')) {
    //       fsPrevReturned = $('#currently-insured-step').prev()
    //     }
    //   }
    // }

    /****  ESTIMATED DEBT REFINANCE STEP ****/
    if (fsPrevReturned[0].id === 'estimated-debt-step-refinance') {
      if (current_form.form_id === 'msform-refinance') {
        if (creditRating === 'poor') {
          fsPrevReturned = $('#estimated-debt-step-refinance')
        } else {
          $('[name=estimated_debt]').prop('checked', false)
          fsPrevReturned = $('#estimated-debt-step-refinance').prev()
        }
      } else {
        $('[name=estimated_debt]').prop('checked', false)
        fsPrevReturned = $('#estimated-debt-step-refinance').prev()
      }
    }

    /****  REAL ESTATE REFINANCE STEP ****/
    if (fsPrevReturned[0].id === 'real-estate-refinance') {
      if (creditRating === 'poor' || creditRating === 'fair') {
        fsPrevReturned = $('#real-estate-refinance')
      } else {
        $('#sell-house-no, #sell-house-yes').prop('checked', false)
        fsPrevReturned = $('#real-estate-refinance').prev()
      }
    }

    /**** LATE ON MORTGAGE REFINANCE STEP ****/
    if (fsPrevReturned[0].id === 'late-on-mortgage-refinance') {
      if (creditRating === 'poor') {
        fsPrevReturned = $('#late-on-mortgage-refinance')
      } else {
        fsPrevReturned = $('#late-on-mortgage-refinance').prev()
        $('[name=opt_mortgage_late_months]').prop('checked', false)
        $('select[name=opt_mortgage_late_months] option:selected').val('')
        $('#opt_mortgage_late_months').prop('selectedIndex', 0).val('')
      }
    }

    /**** SECONDARY VEHICLE AUTO INSURANCE STEP ****/
    if (fsPrevReturned[0].id === 'secondary-vehicle-auto') {
      if ($('[name=additionalVehicle]:checked').val() === '1') {
        fsPrevReturned = $('#secondary-vehicle-auto')
      } else {
        fsPrevReturned = $('#secondary-vehicle-auto').prev()
      }
    }
    /**** CURRENT INSURANCE AUTO INSURANCE STEP ****/
    if (fsPrevReturned[0].id === 'current-insurance-auto') {
      if (radioOrSelectValue('CurrentlyInsured', true) === '1') {
        fsPrevReturned = $('#current-insurance-auto')
      } else {
        fsPrevReturned = $('#current-insurance-auto').prev()
      }
    }

    /**** SECONDARY VEHICLE 2 MODEL AUTO INSURANCE STEP ****/
    if (fsPrevReturned[0].id === 'vehicle2-model-auto') {
      if ($('[name=additionalVehicle-b]:checked').val() === '1') {
        fsPrevReturned = $('#vehicle2-model-auto')
      } else {
        fsPrevReturned = $('#additional-vehicle-step')
      }
    }

    /************** STATIC PREVIOUS STEP IDS - NOT DYNAMIC BASED ON USER SELECTION **************/

    /****  ESTIMATED DEBT PURCHASE STEP ****/
    if (prevFSId === 'estimated-debt-step-purchase') {
      if (current_form.form_id === 'msform-purchase') {
        if (creditRating === 'poor') {
          fsPrevReturned = $('#estimated-debt-step-purchase')
        } else {
          $('[name=estimated_debt]').prop('checked', false)
          fsPrevReturned = $('#estimated-debt-step-purchase').prev()
        }
      } else {
        $('[name=estimated_debt]').prop('checked', false)
        fsPrevReturned = $('#estimated-debt-step-purchase').prev()
      }
    }

    /**** EMPLOYMENT STEP REFINANCE ****/
    if (prevFSId === 'employment-step-refinance' || prevFSId === 'employment-step-purchase') {
      if (employmentValue === 'unemployed' || employmentValue === 'unemployed verified') {
        $('#' + prevFSId + ' input[name=employer][value="unemployed"]').prop('checked', true)
        fsPrevReturned = $('#' + prevFSId)
      }
    }

    /**** UNEMPLOYMENT STEP REFINANCE ****/
    if (prevFSId === 'unemployment-step-refinance' || prevFSId === 'unemployment-step-purchase') {
      if (employmentValue === 'unemployed' || employmentValue === 'unemployed verified') {
        $('input[name=employer][value="' + employmentValue + '"]').prop('checked', true)
        fsPrevReturned = $('#' + prevFSId)
      } else {
        fsPrevReturned = $('#' + prevFSId).prev()
      }
    }

    /**** MORTGAGE PAYMENT PURCHASE STEP ****/
    if (prevFSId === 'mortgage-payment-step-purchase') {
      const ownRent = radioOrSelectValue('own_rent', false)
      if (ownRent === 'own') {
        fsPrevReturned = $('#mortgage-payment-step-purchase')
      } else {
        $('[name=current_lender]').prop('selectedIndex', 0).val('')
        fsPrevReturned = $('#mortgage-payment-step-purchase').prev()
      }
    }

    /**** ADDITIONAL CASH REFINANCE STEP ****/
    if (prevFSId === 'additional-cash-refinance') {
      if (equity() > 0 && $('[name=cash_needed]:checked').val() === '0') {
        fsPrevReturned = $('#cash-needed-refinance')
      } else if (equity() > 0 && $('[name=cash_needed]:checked').val() === '1') {
        fsPrevReturned = $('#additional-cash-refinance')
      } else if (equity() <= 0 && $('[name=cash_needed]').length > 0) {
        fsPrevReturned = $('#additional-cash-refinance').prev().prev()
      } else if (equity() <= 0 && $('[name=cash_needed]').length <= 0) {
        fsPrevReturned = $('#additional-cash-refinance')
      }
    }

    /**** ZIPCODE2 PURCHASE STEP ****/
    if (prevFSId === 'zipcode2-step-purchase') {
      var same_city = $('#same-city').prop('checked')

      if (same_city === false) {
        fsPrevReturned = $('#zipcode2-step-purchase')
      } else if (same_city === true) {
        fsPrevReturned = $('#zipcode2-step-purchase').prev()

        //set the values of the property zip
        $('[name=property_city]').val($('[name=city]').val())
        $('[name=property_state]').val($('[name=state]').val())
        $('[name=property_zip]').val($('[name=zipcode]').val())
      }
    }

    /**** AGE VERIFICATION REFINANCE STEP ****/
    /*         if (prevFSId === 'age-verification-step-refinance') {
            var propStepValue = $('#property-step-refinance input[name=property_type]:checked').val(),
                propWorth = $('#' + current_form.form_id + ' [name=est_property_value]').val(),
                mortAmount = $('#' + current_form.form_id + ' [name=mortgage_amount]').val(),
                mortLTV = Math.floor((parseInt(mortAmount) / parseInt(propWorth)) * 100)
            console.log(mortLTV, ' is the ltv')
            if (propStepValue == 'Mobile Home' || mortLTV >= '50') {
                fsPrevReturned = $('#property-value-refinance')
            }
        } */

    /**** YEAR BUILT AUTO INSURANCE STEP ****/
    //skip home questions if they don't want homeowners insurance
    if (prevFSId === 'year-built-mobile') {
      if ($('[name=own_rent]:checked').val() === 'rent') {
        fsPrevReturned = $('#homeowner-auto-mobile')
      } else if ($('.twoCol [name=DesireHomeownersInsurance]:checked').val() === '0') {
        fsPrevReturned = $('#year-built-mobile').prev().prev()
      } else {
        fsPrevReturned = $('#year-built-mobile')
      }
    }
  } catch (error) {
    fsPrevReturned = current_fs.fs
  }

  return fsPrevReturned
}

/**
 * this module controls the creation of the fieldset object
 * it includes the method of switchfieldsets to progress the survey
 */

//this is the base fieldset or "frame" class
//it seems to have become convoluted and should be reviewed for a rewrite --erik
function FieldSet(fs) {
  this.fs = fs

  // Helper function to set appropriate focus on the active fieldset and trigger the
  this.focusFirst = function () {
    if ($('.final-frame').is(':visible')) {
      return this
    } else {
      $('input:visible:first').focus()
      return this
    }
  }

  //Helper function to scroll to the active fieldset/question
  this.scroll = function () {
    // do not fire autoscroll on final frame
    if (!fs[0].id.includes('final-frame')) {
      autoScrollFunction(fs[0].id)
    }
    return this
  }

  // helper methods that wrap jQuery show/hide methods
  this.show = function () {
    this.fs.show()
    return this
  }
  this.hide = function () {
    this.fs.hide()
    return this
  }
}

/**
 * Utility function to switch to the appropriate fieldset and allow stepping back to previous fieldset
 * as well as providing override to switch to a specific fieldset.
 * Hides old fieldset and scrolls to the active fieldset
 */
function switchFieldSets(that, label, direction, next_override) {
  label = label || '.card'
  direction = direction || 'next'
  next_override = next_override || null
  var fs
  var validationData = []

  $('fieldset:visible')
    .find('.input')
    .each(function () {
      var valType = this.dataset.validation
      validationData.push(valType)
    })

  current_fs = new FieldSet($(that).parents(label))

  if (next_override !== null) {
    fs = next_override
  } else if (direction === 'prev') {
    fs = prevFS(current_fs.fs.prev())

    //skip what should be skipped
    while (fs.hasClass('skip')) {
      fs = fs.prev()
    }
  } else {
    fs = nextFS(current_fs.fs.next())

    // skip if i gave it the skip class
    while (fs.hasClass('skip')) {
      fs = fs.next()
    }
  }

  next_fs = new FieldSet(fs)

  // runs this block if the next_override exists in the argument.
  if (direction == 'prev') {
    //hide the current fieldset
    current_fs.hide()

    // if user goes back and they were on the final frame, we disable the submit button again
    if (current_fs.fs[0].id.includes('final-frame') && !doNotRunTCPA) {
      $('.submit-button').prop('disabled', true)
      $('.submit-button-translate').prop('disabled', true)
    } else {
      $('#disclosure-form').hide()
    }

    //show the next fieldset and scroll to top
    next_fs.show().scroll()

    window.replaceHash($('.card:visible').prop('id'))
    setCookie('step', $('.card:visible').prop('id'), 1)
    var backEvent = new CustomEvent('stepBack', {
      detail: fs.prop('id'),
    })
    window.dispatchEvent(backEvent)
    return
  }

  if (!validationData || validate(validationData) === true) {
    //hide the current fieldset
    current_fs.hide()

    //show the next fieldset and scroll to top
    next_fs.show().scroll().focusFirst()

    //dispatch an event to the window so we can anchor logic on it, but not break the whole form when someone fucks up a function
    var stepEvent = new CustomEvent('stepChange', {
      detail: fs.prop('id'),
    })

    window.dispatchEvent(stepEvent)
    window.replaceHash($('.card:visible').prop('id'))
    setCookie('step', $('.card:visible').prop('id'), 1)

    //}
  } else {
    console.log('not valid')
  }
}

/* this module listens for the stepChange event, and does the associated logic on it,
 * this way if we wanted to we can extract the events inside here to google tag manager
 * or wherever, since we push the stepchange event to the window this code can live
 * almost anywhere without interrupting the main javascript stream if it errors
 */

window.addEventListener('stepChange', function (e) {
  var frameId = e.detail,
    blurredRates = getParameterByName('br'),
    pushFrameId = current_fs.fs.prop('id'),
    gtmFrameId = $('.card:visible').prop('id')
  doGAtrack(gtmFrameId)
  // console.log(gtmFrameId)

  if (window.Pushnami) {
    doPushnamiTrack(pushFrameId)
  }

  if (frameId.indexOf('final-frame-') !== -1) {
    const currentLender = radioOrSelectValue('current_lender', true)

    // fires ileads call if ileads global var exists, if the current lender is other or no lender and if there is no nil=1 param. Else run normal tcpa
    if (
      ileads &&
      getParameterByName('nil') !== '1' &&
      (currentLender === 'Other' || currentLender === 'No Lender' || currentLender === 'I Dont Know')
    ) {
      stageLog('Running getIleadsLite API', currentLender)
      getIleadsLite()
    } else {
      if (!doNotRunTCPA) {
        doTCPA()
      } else {
        $('#disclosure-form').show()
        setTimeout(() => {
          autoScrollTCPA()
        }, 300)
      }
    }
    // checks param and shows blurred rates if the var isn't undefined, is equal to 1, and the window is > 801
    if (blurredRates && blurredRates == '1' && $(window).width() >= 801) {
      $('.v-container').css('background', '#ededed url(img/blurred-rates.png) 50% 120px/1170px no-repeat fixed')
    }
    // This adds a class to the body so that you can style the final frame based on that class
    $('body').addClass('final-frame-body')
    $('.v-container').addClass('blurredRates')
  }

  if (current_fs.fs.prop('id').indexOf('credit') !== -1) {
    var creditRating = radioOrSelectValue('credit_rating', true),
      loanPurpose = current_form.form_id.split('-')[1],
      lbwPrefix

    // ga tracking for the credit step
    gaEventTracking('credit', creditRating, 'credit_rating')

    // various credit redirects based on param or screen width
    if (getParameterByName('bcrlb') !== '0') {
      if (getParameterByName('bcrlb') === '1' && current_form.form_id === 'msform-refinance') {
        if (creditRating === 'poor' || creditRating === 'fair') {
          $('#loading-gif').show()
          offerRedirect(creditRating, '-bcrlb')
        }
      } else if (getParameterByName('bcrlb') === '2' && current_form.form_id === 'msform-refinance') {
        if (creditRating === 'poor') {
          $('#loading-gif').show()
          offerRedirect(creditRating, '-bcrlb')
        }
      }
    }

    if (current_form.form_id === 'msform-purchase' || current_form.form_id === 'msform-refinance') {
      if (getParameterByName('lbw') !== '1' && getParameterByName('cff') === '1') {
        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
          // do nothing for IE11
        } else {
          if (creditRating === 'poor' || creditRating === 'fair') {
            const locSplit = window.location.href.split('#')[0]
            switch (loanPurpose) {
              case 'refinance':
                lbwPrefix = 'BCR'
                break
              case 'purchase':
                lbwPrefix = 'BCP'
                break
              case 'sell':
                lbwPrefix = 'BCS'
                break
              default:
                lbwPrefix = 'BCR'
                break
            }

            if (location.search) {
              openTabUnder(locSplit + '&lbw=1')
            } else {
              openTabUnder(locSplit + '?lbw=1')
            }

            setTimeout(function () {
              window.location.href = `https://mortgage.connectedrates.com/ty${lbwPrefix}.html?loan_purpose=${loanPurpose}&credit_rating=${creditRating}${trafficSource()}-BCL`
            }, 500)
          }
        }
      }
    }

    // if param rlt=1, is a refi lead, and is good or excellent credit redirect the user
    if (getParameterByName('rlt') == '1' && current_form.form_id === 'msform-refinance') {
      if (creditRating === 'excellent' || creditRating === 'good') {
        $('#loading-gif').show()
        setTimeout(function () {
          window.location.href = 'http://suited45trk.com/?E=mohKKZ10Jn06kEt%2f381UWOcV2pp1jy6g'
        }, 500)
      }
    }
  }

  // runs vetsu on employment step if criteria is met
  if (current_fs.fs.prop('id').indexOf('employment') !== -1) {
    var vetsParam = getParameterByName('rvup'),
      employmentStatus = radioOrSelectValue('employer', true)
    if (current_form.form_id === 'msform-purchase' || current_form.form_id === 'msform-refinance') {
      if (vetsParam == 1 && employmentStatus !== 'unemployed') {
        doVetsU()
      }
    }
  }

  // runs refinance doRateZip after employment step if criteria is met
  if (
    current_fs.fs.prop('id').indexOf('employment-step-refinance') !== -1 &&
    current_form.form_id === 'msform-refinance' &&
    getParameterByName('rzb') === '1'
  ) {
    if (rateZipRedirectRefinanceCheck() === true) {
      console.log('rateZipRedirectRefinanceCheck was successful')
      doRateZip()
    }
  }

  // runs purchase doRateZip after employment step if criteria is met
  if (
    current_fs.fs.prop('id').indexOf('employment-step-purchase') !== -1 &&
    current_form.form_id === 'msform-purchase' &&
    getParameterByName('rzbp') === '1'
  ) {
    if (rateZipRedirectPurchaseCheck() === true) {
      console.log('rateZipRedirectPurchaseCheck was successful')
      doRateZip()
    }
  }

  // ga tracking for property_type question
  if (current_fs.fs.prop('id').indexOf('property-step-') !== -1) {
    const propType = radioOrSelectValue('property_type', true)
    gaEventTracking('property', propType, 'property_type')
  }

  // ga tracking for current_lender question
  if (current_fs.fs.prop('id').indexOf('mortgage-payment-') !== -1) {
    const currentLender = radioOrSelectValue('current_lender', true)
    gaEventTracking('lender', currentLender, 'current_lender')
    storage('session', 'set', 'cl', currentLender) // stores current lender for use with ileads
  }

  if ($('.center_progress').length == 1) {
    changeProgressBar()
  }

  if ($('.progress-circle').length == 1) {
    if ($('.final-frame').is(':visible') == true) {
      progressBarUpdate(97, 100)
    } else {
      currentFrame = parseInt($('fieldset:visible').data('pbWidth') + 1)
      progressBarUpdate(currentFrame, numOfFields)
    }
  }
  if (sideBarPanel === true) {
    sidebar()
  }
  if (homeRates === true) {
    stepsAway()
  }

  if (current_fs.fs.prop('id').indexOf('age-verification-reverse') !== -1) {
    var propStepValue = radioOrSelectValue('property_type', true),
      ageVerStepValue = radioOrSelectValue('age', true),
      propWorth = radioOrSelectValue('est_property_value', true),
      mortAmount = radioOrSelectValue('mortgage_amount', true),
      mortLTV = Math.floor((parseInt(mortAmount) / parseInt(propWorth)) * 100)
    if (ageVerStepValue !== '61 or under') {
      if (propStepValue === 'Mobile Home') {
        $('[name=ReverseMortgage]').val(0)
      } else if (mortLTV >= 50) {
        $('[name=ReverseMortgage]').val(0)
      } else {
        $('[name=ReverseMortgage]').val(1)
      }
    }
  }

  if (current_fs.fs.prop('id').indexOf('vehicle-year') !== -1) {
    const year = $('[name=VehicleYear]:checked').val()
    findMakeAndModelMobile(false, 'GetMakesByYear', year)
  }

  if (current_fs.fs.prop('id').indexOf('vehicle-make') !== -1) {
    const year = $('[name=VehicleYear]:checked').val(),
      vehiclemake = $('#VehicleMakeMobile').val()
    findMakeAndModelMobile(false, 'GetModelsByYearAndMake', year, vehiclemake)
  }

  if (current_fs.fs.prop('id').indexOf('vehicle2-year') !== -1) {
    const year = $('[name=VehicleYear2]:checked').val()
    findMakeAndModelMobile(true, 'GetMakesByYear', year)
  }

  if (current_fs.fs.prop('id').indexOf('vehicle2-make') !== -1) {
    const year = $('[name=VehicleYear2]:checked').val(),
      vehiclemake = $('#VehicleMakeMobile2').val()
    findMakeAndModelMobile(true, 'GetModelsByYearAndMake', year, vehiclemake)
  }
  //med2.insurancespecialists.com from first frame styles to the rest of the site styles.
  if ($('.med2-intro-frame').length == 1) {
    if (document.URL.indexOf('med2.insurancespecialists.com') >= 0) {
      $('body').css('background', '#fff')
      $('.headline').html('Find And Compare Medicare Supplement Plans')
      $('body').addClass('secondFrame')
    }
  }
  //autogo2.insurancespecialists.com change first frame styles to the rest of the form styles.
  if ($('#intro-frame-mobile').length == 1) {
    if (
      document.URL.indexOf('autogo2.insurancespecialists.com') >= 0 ||
      document.URL.indexOf('autoratequiz.com') >= 0 ||
      document.URL.indexOf('brainypennyauto.com') >= 0 ||
      document.URL.indexOf('autogorates.com') >= 0 ||
      document.URL.indexOf('costcuttingauto.com') >= 0 ||
      document.URL.indexOf('autogosavings.com') >= 0 ||
      document.URL.indexOf('autogoinsurance.com') >= 0 ||
      document.URL.indexOf('autosavingssearch.com') >= 0 ||
      document.URL.indexOf('autosavingssurvey.com') >= 0 ||
      document.URL.indexOf('freeautosavings.com') >= 0 ||
      document.URL.indexOf('discountfriendauto.com') >= 0 ||
      document.URL.indexOf('localhost') >= 0
    ) {
      $('body').css('background', '#FAFAFA')
      $('.headline').css('display', 'none')
      $('.headline-container').css('padding', '10px 0 80px')
      $('.headline').css('font-size', '32px')
      $('.v-container').css('background', '#FAFAFA').css('min-height', 'calc(100vh - 50px)')
      $('.progressBar_control').show()
      $('.insLogos').hide()
      $('.emptyDiv').hide()
    }
  }
  // redirects user on auto sites if they are uninsured

  // Commenting out for now.  We may use this in the future
  /*   if (current_fs.fs.prop('id').indexOf('currently-insured-step') !== -1) {
    const isInsured = radioOrSelectValue('CurrentlyInsured', true)
    if (isInsured === '0') {
      stageLog('Uninsured Redirect')
      $('#loading-gif').show()
      setTimeout(function() {
        window.location.href = `/tyGCR.html?r=${trafficSource()}-nirt`
      }, 500)
    }
  } */
})

window.addEventListener('stepBack', function (e) {
  if ($('.center_progress').length == 1) {
    changeProgressBar()
  }

  if ($('.progress-circle').length == 1) {
    currentFrame = parseInt($('fieldset:visible').data('pbWidth') + 1)
    progressBarUpdate(currentFrame, numOfFields)
  }
  if (sideBarPanel === true) {
    sidebar()
  }
  if (homeRates === true) {
    stepsAway()
  }
})

function changeProgressBar() {
  var progressRemaining = 97 - progressStartPosition
  pbData = $('fieldset:visible').data('pbWidth')
  progressBar = (progressRemaining / numOfFields) * parseInt(pbData) + progressStartPosition
  var percentComplete = parseInt(progressBar)
  if ($('.percent_complete')) {
    $('.percent_complete').text(percentComplete + '% Complete')
  }
  if ($('#progress-amount')) {
    $('#progress-amount').text(percentComplete)
  }
  $('.progress-bar').attr('style', 'width: ' + progressBar + '%')
}

function rotate(element, degree) {
  element.css({
    '-webkit-transform': 'rotate(' + degree + 'deg)',
    '-moz-transform': 'rotate(' + degree + 'deg)',
    '-ms-transform': 'rotate(' + degree + 'deg)',
    '-o-transform': 'rotate(' + degree + 'deg)',
    transform: 'rotate(' + degree + 'deg)',
    zoom: 1,
  })
}

function progressBarUpdate(x, outOf) {
  var firstHalfAngle = 180
  var secondHalfAngle = 0
  var percentage

  // caluclate the angle
  var drawAngle = (x / outOf) * 360

  // calculate the angle to be displayed if each half
  if (drawAngle <= 180) {
    firstHalfAngle = drawAngle
  } else {
    secondHalfAngle = drawAngle - 180
  }

  // set the transition
  rotate($('.slice1'), firstHalfAngle)
  rotate($('.slice2'), secondHalfAngle)

  // set the values on the text
  percentage = parseInt((x / outOf) * 100)
  $('.status').html(percentage + '%')
}

const sidebar = () => {
  const getSb = $('fieldset:visible').data('card')
  const sbContent = $('.sidebar-content')
  sbContent.each(function () {
    if (getSb == $(this).data('sb')) {
      const sbHeight = $(this).height()
      $(this).addClass('active')
      $('.sidebar-container').height(sbHeight + 10)
    } else {
      $(this).removeClass('active')
    }
  })
}

const stepsAway = () => {
  if ($('fieldset:visible').attr('class').indexOf('sa1') !== -1) {
    $('.headline').text('1 Step Away')
  } else if ($('fieldset:visible').attr('class').indexOf('sa2') !== -1) {
    $('.headline').text('2 Steps Away')
  } else if ($('fieldset:visible').attr('class').indexOf('final-frame') !== -1) {
    $('.headline').text('Last Step!')
  }
}

/**
 * This module is the main form object, it includes local methods to reset, and post the form
 * in addition to a couple local helper methods
 */

//this is the base form class
//this document manipulation on lines 38-42 should be removed from this class and put into event listener at the site custom level --erik
function FormObj(form) {
  this.form = form
  this.form_id = this.form.attr('id')
  try {
    this.siteName = 'https://' + scData[0].siteName
  } catch (error) {
    this.siteName = window.location.href
  }
  this.thankyouPage = null
  this.posting = false
  var self = this
  var tyParam = getParameterByName('ty')

  // this if statement checks forms that have only one path and bases the thank you page on the own/rent question instead of the forms ID
  if ($('form').hasClass('singleForm')) {
    this.loanType = function () {
      var own = $('input[name="own_rent"]:checked').val()

      // if ty param equals 2 then return the loantype as R2 instead of R or P
      if (tyParam === '2') {
        return 'R2'
      } else if (own == 'Rent') {
        return 'P'
      } else {
        return 'R'
      }
    }
  } else {
    //returns loan type
    this.loanType = function () {
      // if ty param equals 2 then return the loantype as R2 instead of R or P
      if (tyParam === '2') {
        return 'R2'
      } else {
        return this.form_id.substr('msform-'.length, 1).toUpperCase()
      }
    }
  }

  this.fullLoanType = function () {
    return this.form_id.substr('msform-'.length)
  }

  //resets the object and active form element while hiding the intro questions
  this.reset = function () {
    var that = this.form

    that.posting = false

    that.show()

    $('#intro-frame').hide()
    $('#path_choice').hide()
    $('#path').hide()

    current_fs = new FieldSet(that.children('.card').first())

    // fires ga tracking for pageview reporting on first step. stepChange.js will do the other steps
    try {
      var gtmFrameId = current_fs.fs.prop('id')
      doGAtrack(gtmFrameId)
    } catch (error) {
      stageLog('no first card avail for ga-pageview reporting')
    }

    // remove header after form instantiation
    $('#header, .header_line, .header_content, .title_container, #dc-header').remove()

    var event = new CustomEvent('new form')
    window.dispatchEvent(event)

    try {
      doPushnamiLoanPurpose()
    } catch (error) {
      console.log(error)
    }

    /**
     * Use the global progressWidths function to calculate the progress bar widths dynamically
     */
    progressWidths()

    return this
  }

  /**
   * Post the lead to suited connector
   * and display the correct thank you page
   * @param {*} formJson //if null this function will serialized the form itself
   * @param {*} translationRequired //not required, pass if the form needs values translated to cake value
   */
  this.postLead = function (formJson, translationRequired) {
    $('#finalOverlay').show()

    var tyData = $('form:visible').serializeArray(),
      tyObj = {}

    $(tyData).each(function (i, field) {
      tyObj[field.name] = field.value
    })

    var creditRating = tyObj.credit_rating,
      military = tyObj.opt_served_military,
      loanType = tyObj.loan_purpose,
      propType = tyObj.property_type

    // sets the initials from the credit rating and the loan purpose
    var pathAcronym = getCreditLoanPurpose(creditRating, this.loanType())
    var fullTyPath = '/thankyou' + pathAcronym

    // set the pathAcronym to storage to pass to cake if tyPageContent is undefined
    storage('session', 'set', 'crlp', pathAcronym)

    var getFirstName = $('#' + current_form.form_id + ' [name=first_name]').val()
    getFirstName = getFirstName.toLowerCase()

    // creates object to be stringified in a landerVisit cookie
    var ckData = {
      ckprefix: pathAcronym,
      loanPurpose: loanType,
      creditRating: creditRating,
    }
    pushnamiSubmit()

    timeTracker.stop()

    var formValues

    if (translationRequired !== true || !formJson) {
      formValues = this.form.serialize()
    } else {
      formValues = $.param(formJson)
    }

    //here is where you add params to be passed into CAKE and into the database
    var qs = formValues + '&' + $('#disclosure-form').serialize() + jobTitle(),
      defaultTyParams =
        '?loan_purpose=' +
        loanType +
        '&credit_rating=' +
        creditRating +
        '&opt_served_military=' +
        military +
        '&property_type=' +
        propType +
        '&a=' +
        affiliateId() +
        s1() +
        jobTitle() +
        highPrice() +
        ageParam() +
        crt() +
        noPush() +
        affiliateGTM() +
        stageParam(),
      insuranceTyParams = '?credit_rating=' + creditRating + '&a=' + affiliateId() + s1() + stageParam(),
      mcrUrl =
        'https://mortgage.connectedrates.com/ty' +
        ckData.ckprefix +
        '.html?loan_purpose=' +
        ckData.loanPurpose +
        '&credit_rating=' +
        ckData.creditRating +
        '&cpid=' +
        getCampaignId() +
        '&a=' +
        affiliateId() +
        ageParam(),
      thankyouPage,
      tyPageUrl,
      tyOptions = {
        newTab: false,
        showInterstitial: false,
        showMCR: true,
        tsValue: trafficSource() + '-ty',
        plp: false,
      },
      standardTYPage = fullTyPath + '.html'

    var tyPageStorage = storage('session', 'get', 'splitBuyerPayload')
    if (tyPageStorage) {
      tyPageStorage = JSON.parse(tyPageStorage)
      if (tyPageStorage.tyPageContent) {
        tyPageUrl = tyPageStorage.tyPageContent
      }
    } else {
      tyPageUrl = null
    }

    // have to check if it's not null so that sites that don't use this will still function

    // handles the ty page redirect logic for which ty page to show
    if (specialtyTY === true) {
      thankyouPage = fullTyPath + '.html'
    } else if (storage('local', 'get', 'plp')) {
      tyOptions = {
        newTab: true,
        showInterstitial: false,
        showMCR: false,
        tsValue: trafficSource() + '-plty',
        plp: true,
      }

      // checks if it's an exclusive TY page and sets isExclusive to true and won't show popUnder

      if (
        (tyObj && tyObj.tcpa === 'LMB') ||
        tyObj.tcpa === 'LMB_x' ||
        tyObj.tcpa === 'LMB_d' ||
        tyObj.tcpa === 'granthood_lmb' ||
        tyObj.tcpa === 'LMB_quicken' ||
        tyObj.tcpa === 'RMP_caliber'
      ) {
        tyOptions.isExclusive = true
        if (tyPageStorage.tyPageContent === null) {
          tyOptions.exTYPage = mcrUrl
        } else {
          tyOptions.exTYPage = tyPageStorage.tyPageContent + '.html'
        }
      } else {
        tyOptions.isExclusive = false
      }

      thankyouPage = 'pl-thankyou.html'
    } else {
      // temp: once we move away from full url's in the thankyoupage payload remove this first IF block
      if (tyPageUrl && tyPageUrl.length > 20) {
        thankyouPage = tyPageUrl
      } else if (tyPageUrl) {
        thankyouPage = tyPageUrl + '.html'
      } else {
        tyOptions = {
          newTab: true,
          showInterstitial: false,
          showMCR: true,
          tsValue: trafficSource() + '-ty',
          plp: false,
        }
        thankyouPage = standardTYPage
      }
    }

    thankyou = function () {
      // won't set landerVisit if the lead is a test lead
      if (getFirstName && getFirstName !== 'ckmtest' && getFirstName !== 'ckmtestpixel') {
        // sets visitor cookie after form submission in TY callback
        setCookie('landerVisit', JSON.stringify(ckData), 1)
      }
      processTYRedirect(thankyouPage, tyOptions, standardTYPage, defaultTyParams, mcrUrl, ckData, insuranceTyParams)
    }

    var leadData = buildLead(qs, true)

    // if LMB then show build profile UX else perform normal submission
    if (
      (tyObj && tyObj.tcpa === 'LMB') ||
      tyObj.tcpa === 'LMB_x' ||
      tyObj.tcpa === 'LMB_d' ||
      tyObj.tcpa === 'LMB_quicken' ||
      tyObj.tcpa === 'granthood_lmb'
    ) {
      buildProfile(leadData, thankyou)
    } else {
      $('#finalOverlay').show()
      submitFormData(leadData, thankyou)
    }
  }
}

/**
 * Prepop JS Module
 * Prepop's name values into the form based on url parameters
 * it is instantiated from the main javascript wrapper
 **/

// utility function to find the closes value in an array.
var findClosest = function (x, arr) {
  var indexArr = arr.map(function (k) {
    return Math.abs(k - x)
  })
  var min = Math.min.apply(Math, indexArr)
  return arr[indexArr.indexOf(min)]
}

// Updates the estimated down payment to a value in the array that is closest to the value in the array
function closestDownPayment(edp) {
  var arg = edp.toString(),
    possibleValues = ['5.00', '10.00', '15.00', '20.00', '25.00'],
    edpValue = findClosest(arg, possibleValues)

  return edpValue
}

// tests to ensure it's not a number.
function notaNumTest(arg) {
  return /^\d+$/.test(arg)
}

// translates prepop values that have to be a 1 or a 0
function translateYesNoData(property, value) {
  if (['Yes', 'yes', 'True', 'true', true].includes(value)) {
    $('input[name=' + property + '][value="1"]').prop('checked', true)
    $('select[name=' + property + ']').val('1')
  }
  if (['No', 'no', 'False', 'false', false].includes(value)) {
    $('input[name=' + property + '][value="0"]').prop('checked', true)
    $('select[name=' + property + ']').val('0')
  }
}

function prePopActions(prepopData, cb) {
  const doNotPrepopNames = ['InsurancePurpose']
  $.each(prepopData, function (property, value) {
    try {
      // if any prepopped values are blank or null then just keep going and don't try to prepop those.
      if (value === '' || value === 'null' || value === 'undefined') {
        // works similar to continue and will skip the iteration if the propery is empty or the value is null or undefined.
        return true
      } else if (callDotRMP && property === 'loan_purpose') {
        // prevents call.ratemarketplace.com from prepopping loan_purpose
        stageLog('Is call.rmp... not prepopping loan purpose')
        return true
      } else if (property.includes(doNotPrepopNames)) {
        // don't prepop any items in the doNotPrepopNames array above
        return true
      } else {
        var inputKey = $('input[name="' + property + '"]')

        // handle radio and checkboxes or just plain inputs
        if (inputKey.is(':radio') || inputKey.is(':checkbox')) {
          $('input[name="' + property + '"][value="' + decodeURIComponent(value) + '"]').prop('checked', true)
        } else {
          if (property === 'email') {
            inputKey.val(decodeURIComponent(value))
          } else {
            inputKey.val(decodeURIComponent(value).replace(/\+/g, ' '))
          }
        }

        // handle select dropdowns
        $('select[name="' + property + '"]')
          .val(decodeURIComponent(value))
          .change()

        // capitalize current loan type if it's not ** must run after dropdown handler **
        if (property === 'current_loan_type') {
          if (value === 'fha' || value === 'va') {
            $('input[name="' + property + '"][value="' + value.toUpperCase() + '"]').prop('checked', true)
            $('select[name="current_loan_type"]').val(value.toUpperCase()).change()
          } else {
            $('input[name="' + property + '"][value="' + decodeURIComponent(value) + '"]').prop('checked', true)
            $('select[name="current_loan_type"]').val(value).change()
          }
        }
      }
    } catch (error) {
      // do nothing
    }
  })

  // run zip and prop zip operations if they exist

  if (prepopData.property_zip) {
    doZipCodeOperations(prepopData.property_zip, true, true, false)
  }
  if (prepopData.PropertyZip) {
    doZipCodeOperations(prepopData.PropertyZip, true, true, false)
  }

  if (prepopData.zipcode || prepopData.zip_code) {
    doZipCodeOperations(prepopData.zipcode, false, true, false)

    // checks if site has fake zipcode-initial field and prepops it
    if ($('#zipcode-initial').val() === '') {
      $('#zipcode-initial').val(prepopData.zipcode || prepopData.zip_code)
    }
  }

  if (prepopData.address) {
    var cleanAddress = prepopData.address.replace(/[+.]/g, ' ').replace(/[^0-9a-z ,#'-]/i, '')
    $('[name=address], .address').val(cleanAddress)
  }

  // need to have all four in the payload to not show the google address step.
  if (document.URL.indexOf('qualifiedaddresssurvey') !== -1 || document.URL.indexOf('cashvalueformyhouse') !== -1) {
    if (
      prepopData.address !== undefined &&
      prepopData.zipcode !== undefined &&
      prepopData.city !== undefined &&
      prepopData.state !== undefined
    ) {
      // if the site uses google address autocomplete then hide this step and move to the next step
      if ($('.address-autocomplete').is(':visible')) {
        var eleTagName = $('.address-autocomplete').next()[0].tagName
        $('.address-autocomplete').hide()
        $('.address-autocomplete').next(eleTagName).show()
      }
    }
  }
  // strips .comm from email if in prepop
  if (prepopData.email) {
    var paramsEmail = prepopData.email
    if (paramsEmail.indexOf('.comm') > -1) {
      paramsEmail = paramsEmail.replace(/.comm/g, '.com')
      $('input[name="email"]').val(paramsEmail)
    }
  }

  // strips 0 or 1 from first char in phone number and applies the mask
  if (prepopData.phone_primary) {
    let paramsPhone = prepopData.phone_primary
    if (paramsPhone.charAt(0) === '0' || paramsPhone.charAt(0) === '1') {
      paramsPhone = paramsPhone.slice(1)
    }
    let x = paramsPhone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
    x = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
    $('input[name="phone_primary"]').val(x)
  }

  /*** SLIDER or DROPDOWN LTV Prepop Logic ***/

  // sets initial slider array values based on type of slider logic being used
  let epv = estPropValuesDBA
  let emv = estMortgageValuesDBA
  let epurv = estPurchaseValuesDBA
  if (slidersType === 'initiateSliders') {
    epv = estPropValues
    emv = estMortgageValues
    epurv = estPurchaseValues
  } else if (slidersType === 'estMortgageValuesDRM') {
    emv = estMortgageValuesDRM
  }
  // run either dropdown LTV or initiate sliders
  // Slider UI update doesn't function properly, will need to fix in another release
  if (prepopData.est_property_value !== undefined) {
    if (
      prepopData.est_property_value == '' ||
      prepopData.est_property_value == '0' ||
      !notaNumTest(prepopData.est_property_value)
    ) {
      setTimeout(function () {
        $('[name="est_property_value"]').val('350000')
      }, 100)
    } else {
      var pv = prepopData.est_property_value,
        propValueArrayValue = findClosest(pv, removeCommaFromArray(epv)),
        propValueArrayPosition = epv.indexOf(propValueArrayValue.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      if ($('input[name="est_property_value"]').attr('type') == 'hidden') {
        setTimeout(function () {
          $('#propValues').slider({
            value: propValueArrayPosition,
          })
          setPriceDisplay(epv, propValueArrayPosition - 1, 'prop')
        }, 100)
      } else {
        // this is a dropdown

        // gets static dropdown values from the html directly
        let getStaticValues = []
        $('[name=est_property_value] option').each(function () {
          getStaticValues.push($(this).attr('value'))
        })

        // findthe closes value from prepopped value and array of static values
        let dropDownArrayValue = findClosest(pv, removeCommaFromArray(getStaticValues))

        if (parseInt(dropDownArrayValue) < 95000) {
          dropDownArrayValue = '95000'
        } else if (parseInt(dropDownArrayValue) > 2000000) {
          dropDownArrayValue = '2000000'
        }

        $('select[name="est_property_value"], select[name="PropertyValue"]').val(dropDownArrayValue)
        // if (!callDotRMP) {
        //   if (reverseLTV) {
        //     reverseDropDownLTV()
        //     $('select[name="mortgage_amount"], select[name="MortgageAmount"]').on('change', reverseDropDownLTV)
        //   } else {
        //     // don't run dropdownLTV if mortgage_amount is in prepop and isVerify is false
        //     if (
        //       (!isVerify && prepopData.mortgage_amount === undefined) ||
        //       prepopData.mortgage_amount === '' ||
        //       prepopData.mortgage_amount === null
        //     ) {
        //       dropDownLTV()
        //       $('select[name="est_property_value"], select[name="PropertyValue"]').on('change', dropDownLTV)
        //     }
        //   }
        // }
      }
    }
  }

  if (prepopData.mortgage_amount !== undefined) {
    if (
      prepopData.mortgage_amount == '' ||
      prepopData.mortgage_amount == '0' ||
      !notaNumTest(prepopData.mortgage_amount)
    ) {
      // we don't want to default mortgage_amount to 175k if there's prepop data for est_property_value
      if (
        prepopData.est_property_value == '' ||
        prepopData.est_property_value == '0' ||
        !notaNumTest(prepopData.est_property_value)
      ) {
        $('[name="mortgage_amount"]').val('175000')
      }
    } else {
      var ma = prepopData.mortgage_amount,
        mortValueArrayValue = findClosest(ma, removeCommaFromArray(emv)),
        mortValueArrayPosition = emv.indexOf(mortValueArrayValue.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      if ($('input[name="mortgage_amount"]').attr('type') == 'hidden') {
        setTimeout(function () {
          $('#mortgageValues').slider({
            value: mortValueArrayPosition,
          })
          setPriceDisplay(emv, mortValueArrayPosition - 1, 'mortgage')
        }, 100)
      } else {
        // this is a dropdown
        setTimeout(function () {
          $('[name=mortgage_amount]').val(mortValueArrayValue)
        }, 100)
      }
    }
  }

  if (prepopData.est_purchase_price !== undefined) {
    if (
      prepopData.est_purchase_price == '' ||
      prepopData.est_purchase_price == '0' ||
      !notaNumTest(prepopData.est_purchase_price)
    ) {
      setTimeout(function () {
        $('[name="est_purchase_price"]').val('260000')
      }, 100)
    } else {
      var pp = prepopData.est_purchase_price,
        estPurArrayValue = findClosest(pp, removeCommaFromArray(epurv)),
        estPurArrayPosition = emv.indexOf(estPurArrayValue.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      if ($('input[name="est_purchase_price"]').attr('type') == 'hidden') {
        setTimeout(function () {
          $('#purchaseValues').slider({
            value: estPurArrayPosition,
          })
          if (estPurArrayPosition <= 0) {
            setPriceDisplay(epurv, estPurArrayPosition, 'purchase')
          } else {
            setPriceDisplay(epurv, estPurArrayPosition - 2, 'purchase')
          }
        }, 100)
      } else {
        // this is a dropdown
        setTimeout(function () {
          $('[name="est_purchase_price"]').val(estPurArrayValue)
        }, 100)
      }
    }
  }

  if (prepopData.loan_purpose == 'Refinance') {
    $('[name=path-choice]').val(1).change()
  } else if (prepopData.loan_purpose == 'Purchase') {
    $('[name=path-choice]').val(0).change()
  }

  if (prepopData.estimated_down_payment) {
    var newEstDownPayment = closestDownPayment(prepopData.estimated_down_payment)

    $('input[name=estimated_down_payment][value="' + newEstDownPayment + '"]').prop('checked', true)
    $('select[name=estimated_down_payment]').val(newEstDownPayment).change()
  }

  if (prepopData.down_pmt) {
    var newDownPayment = closestDownPayment(prepopData.down_pmt)
    $('[name=estimated_down_payment]').val(newDownPayment)
  }

  // cleans up bad credit rating prepop
  if (prepopData.credit_rating) {
    if (!['excellent', 'good', 'average', 'fair', 'poor'].includes(prepopData.credit_rating)) {
      $('[name=credit_rating]:checked').val('good')
    }
    // use credit_rating to prepop in the values for credit on thecurrentlenderquiz.com
    $('input[name="credit"][value="' + $('[name=credit_rating]').val() + '"]').prop('checked', true)
  }

  /**** TRANSLATIONS ****/

  // parseFloats if prepop has a trailing zero
  if (prepopData.mortgage_rate) {
    const parseFloatMortgageRate = parseFloat(prepopData.mortgage_rate)
    $('input[name=mortgage_rate][value="' + parseFloatMortgageRate + '"]').prop('checked', true)
    $('select[name=mortgage_rate]').val(parseFloatMortgageRate)
  }
  // mc zip or gf zip param
  if (prepopData.zip_code) {
    prepopData.zipcode = prepopData.zip_code
    $('input[name="zipcode"]').val(prepopData.zipcode)
  }

  // translates various military values to either checked or selected elements
  if (prepopData.hasOwnProperty('opt_served_military')) {
    translateYesNoData('opt_served_military', prepopData.opt_served_military)
  }

  // translates property type based on popped value
  if (prepopData.hasOwnProperty('property_type')) {
    if (['Single Family Home'].includes(prepopData.property_type)) {
      $('input[name=property_type][value="Single Family"]').prop('checked', true)
      $('select[name=property_type]').val('Single Family')
    }
  }

  // translates real estate question based on popped value
  if (prepopData.hasOwnProperty('agent_found')) {
    translateYesNoData('agent_found', prepopData.agent_found)
  }

  // translates own rent question based on popped value
  if (prepopData.hasOwnProperty('home_found')) {
    translateYesNoData('home_found', prepopData.home_found)
  }

  // translates current loan type question based on popped value
  if (prepopData.hasOwnProperty('current_loan_type')) {
    if (["Other - I don't know"].includes(prepopData.current_loan_type)) {
      $('input[name=current_loan_type][value="Other"]').prop('checked', true)
      $('select[name=current_loan_type]').val('Other')
    }
  }
  // translates current loan type question based on popped value
  if (prepopData.hasOwnProperty('own_rent')) {
    if (['Rent'].includes(prepopData.own_rent)) {
      $('input[name=own_rent][value="rent"]').prop('checked', true)
      $('select[name=own_rent]').val('rent')
    }
  }

  if ($('body').hasClass('verify')) {
    isVerifyTCPA()
  }
  if (typeof cb === 'function') {
    cb()
  }
}

/* function is called on doc.ready and if the URL contains an SIH param, an ajax call is made to retreive pii data and prepops form data.
 * If not then use the URL params if they exist to prepop form data
 */
function prepopulateValues() {
  if (
    storage('local', 'get', 'formData') !== null &&
    getParameterByName('cff') === '1' &&
    getParameterByName('lbw') === '1'
  ) {
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
      // don't fast forward if IE11
    } else {
      fastForward()
    }
  } else if (storage('local', 'get', 'formData') && !noStoragePrepop) {
    // we don't prepop from localstorage on sites with noStoragePrepop as true
    // prepops data based on local storage
    const formData = JSON.parse(storage('local', 'get', 'formData'))
    const cleanData = dataCleanUp(formData)

    prePopActions(cleanData)
  } else if (location.search) {
    var sih = getParameterByName('sih'),
      prepopData = getParams(window.location.href)

    if (sih) {
      // make ajax call to get the pii data then run prePopActions in success callback
      prePopAPI(sih)
    } else {
      // prepop form based on url params and not uuid
      prePopActions(prepopData, doQueryStringSave(window.location.href))
    }
  } else {
    if ($('body').hasClass('verify')) {
      isVerifyTCPA()
    }
  }

  // fire dropDownLTV on sites with a select html tag for est_property_value, will just return if no dropdown for est_property_value
  if (getParameterByName('dltv') !== '1' && !getParameterByName('sih') && noDltv === false) {
    if (reverseLTV) {
      if (!callDotRMP) {
        reverseDropDownLTV('default')
      }
      $('select[name="mortgage_amount"], select[name="MortgageAmount"]').on('change', reverseDropDownLTV)
    } else {
      if (!callDotRMP) {
        if (!isVerify) {
          dropDownLTV('default')
        }
      }
      $('select[name="est_property_value"], select[name="PropertyValue"]').on('change', dropDownLTV)
    }
  }
}
/**
 * Cleans localStorage formData before it prepops
 * @param  {object} data
 */
function dataCleanUp(data) {
  const clean = data
  delete clean.offer_id
  delete clean.xxTrustedFormToken
  delete clean.xxTrustedFormCertUrl
  delete clean.request_id
  delete clean.uuid
  delete clean.site_name
  delete clean.site_url
  delete clean.tcpa
  delete clean.universal_leadid
  delete clean.SplitScenarioId
  delete clean.SplitScenarioName
  delete clean.BuyerGroupId
  delete clean.BuyerGroupName
  delete clean.Scenario
  delete clean.TierLevel
  delete clean.disclosure_name
  delete clean.time_on_form
  delete clean.affiliate_id

  // TODO: Fast Forward will need this but it breaks TCPA on Sell Path
  delete clean.loan_purpose

  return clean
}

/**
 * Utility function to set the slider value/display for prop/mortgage values
 * This is the worst module in the repository and should be reviewed for a rewrite --erik
 */

/**
 * creates array of values by 10,000s
 * @param  {integer} indexes
 * @param  {integer} amount
 */
function byTens(indexes, amount) {
  const arr = []
  for (let i = amount; i <= indexes; i++) {
    let temp = i * 10000
    temp = temp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    arr.push(temp)
  }
  return arr
}

/**
 * creates array of values by 20,000s
 * @param  {integer} indexes
 * @param  {integer} amount
 */
function byTwenties(indexes, amount) {
  const arr = []
  for (let i = amount; i <= indexes; i++) {
    let temp = i * 20000
    temp = temp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    arr.push(temp)
  }
  return arr
}

var attachedSliders = true,
  // prettier-ignore
  estPropValues = ['0', '90,000', '95,000', '100,000', '105,000', '110,000', '115,000', '120,000', '125,000', '130,000', '135,000', '140,000', '145,000', '150,000', '155,000', '160,000', '165,000', '170,000', '175,000', '180,000', '185,000', '190,000', '195,000', '200,000', '210,000', '220,000', '230,000', '240,000', '250,000', '260,000', '270,000', '280,000', '290,000', '300,000', '310,000', '320,000', '330,000', '340,000', '350,000', '360,000', '370,000', '380,000', '390,000', '400,000', '420,000', '440,000', '460,000', '480,000', '500,000', '520,000', '540,000', '560,000', '580,000', '600,000', '620,000', '640,000', '660,000', '680,000', '700,000', '720,000', '740,000', '760,000', '780,000', '800,000', '820,000', '840,000', '860,000', '880,000', '900,000', '920,000', '940,000', '960,000', '980,000', '1,000,000', '1,000,001'],
  // prettier-ignore
  estMortgageValues = ['80,000', '85,000', '90,000', '95,000', '100,000', '105,000', '110,000', '115,000', '120,000', '125,000', '130,000', '135,000', '140,000', '145,000', '150,000', '155,000', '160,000', '165,000', '170,000', '175,000', '180,000', '185,000', '190,000', '195,000', '200,000', '210,000', '220,000', '230,000', '240,000', '250,000', '260,000', '270,000', '280,000', '290,000', '300,000', '310,000', '320,000', '330,000', '340,000', '350,000', '360,000', '370,000', '380,000', '390,000', '400,000', '420,000', '440,000', '460,000', '480,000', '500,000', '520,000', '540,000', '560,000', '580,000', '600,000', '620,000', '640,000', '660,000', '680,000', '700,000', '720,000', '740,000', '760,000', '780,000', '800,000', '820,000', '840,000', '860,000', '880,000', '900,000', '920,000', '940,000', '960,000', '980,000', '1,000,000', '1,000,001'],
  // prettier-ignore
  interestValues = [2.75, 3.0, 3.25, 3.5, 3.75, 4.0, 4.25, 4.5, 4.75, 5.0, 5.25, 5.5, 5.75, 6.0, 6.25, 6.5, 6.75, 7.0, 7.25, 7.5, 7.75, 8.0],
  // prettier-ignore
  downpaymentValues = [5.0, 10.0, 15.0, 20.0, 25.0],
  // prettier-ignore
  estPurchaseValues = ['85,000', '90,000', '95,000', '100,000', '105,000', '110,000', '115,000', '120,000', '125,000', '130,000', '135,000', '140,000', '145,000', '150,000', '155,000', '160,000', '165,000', '170,000', '175,000', '180,000', '185,000', '190,000', '195,000', '200,000', '210,000', '220,000', '230,000', '240,000', '250,000', '260,000', '270,000', '280,000', '290,000', '300,000', '310,000', '320,000', '330,000', '340,000', '350,000', '360,000', '370,000', '380,000', '390,000', '400,000', '420,000', '440,000', '460,000', '480,000', '500,000', '520,000', '540,000', '560,000', '580,000', '600,000', '620,000', '640,000', '660,000', '680,000', '700,000', '720,000', '740,000', '760,000', '780,000', '800,000', '820,000', '840,000', '860,000', '880,000', '900,000', '920,000', '940,000', '960,000', '980,000', '1,000,000', '1,000,001'],
  // prettier-ignore
  cashOutValuesStatic = ['0', '5,000', '10,000', '15,000', '20,000', '25,000', '30,000', '35,000', '40,000', '45,000', '50,000+'],
  // prettier-ignore
  estPropValuesDBA = ['0', '90,000', '95,000', '100,000', '105,000', '110,000', '115,000', '120,000', '125,000', '130,000', '135,000', '140,000', '145,000', '150,000', '155,000', '160,000', '165,000', '170,000', '175,000', '180,000', '185,000', '190,000', '195,000', '200,000', '210,000', '220,000', '230,000', '240,000', '250,000', '260,000', '270,000', '280,000', '290,000', '300,000', '310,000', '320,000', '330,000', '340,000', '350,000', '360,000', '370,000', '380,000', '390,000', '400,000', '420,000', '440,000', '460,000', '480,000', '500,000', '520,000', '540,000', '560,000', '580,000', '600,000', '620,000', '640,000', '660,000', '680,000', '700,000', '720,000', '740,000', '760,000', '780,000', '800,000', '820,000', '840,000', '860,000', '880,000', '900,000', '920,000', '940,000', '960,000', '980,000', '1,000,000', '1,500,000', '2,000,000', '2,000,001'],
  // prettier-ignore
  estMortgageValuesDBA = ['80,000', '85,000', '90,000', '95,000', '100,000', '105,000', '110,000', '115,000', '120,000', '125,000', '130,000', '135,000', '140,000', '145,000', '150,000', '155,000', '160,000', '165,000', '170,000', '175,000', '180,000', '185,000', '190,000', '195,000', '200,000', '210,000', '220,000', '230,000', '240,000', '250,000', '260,000', '270,000', '280,000', '290,000', '300,000', '310,000', '320,000', '330,000', '340,000', '350,000', '360,000', '370,000', '380,000', '390,000', '400,000', '420,000', '440,000', '460,000', '480,000', '500,000', '520,000', '540,000', '560,000', '580,000', '600,000', '620,000', '640,000', '660,000', '680,000', '700,000', '720,000', '740,000', '760,000', '780,000', '800,000', '820,000', '840,000', '860,000', '880,000', '900,000', '920,000', '940,000', '960,000', '980,000', '1,000,000', '1,500,000', '2,000,000', '2,000,001'],
  // prettier-ignore
  estPurchaseValuesDBA = ['85,000', '90,000', '95,000', '100,000', '105,000', '110,000', '115,000', '120,000', '125,000', '130,000', '135,000', '140,000', '145,000', '150,000', '155,000', '160,000', '165,000', '170,000', '175,000', '180,000', '185,000', '190,000', '195,000', '200,000', '210,000', '220,000', '230,000', '240,000', '250,000', '260,000', '270,000', '280,000', '290,000', '300,000', '310,000', '320,000', '330,000', '340,000', '350,000', '360,000', '370,000', '380,000', '390,000', '400,000', '420,000', '440,000', '460,000', '480,000', '500,000', '520,000', '540,000', '560,000', '580,000', '600,000', '620,000', '640,000', '660,000', '680,000', '700,000', '720,000', '740,000', '760,000', '780,000', '800,000', '820,000', '840,000', '860,000', '880,000', '900,000', '920,000', '940,000', '960,000', '980,000', '1,000,000', '1,500,000', '2,000,000', '2,000,001'],
  // prettier-ignore
  annualMileageValues = ['1000', '2000', '3000', '4000', '5000', '6000', '7000', '8000', '9000', '10000', '11000', '12000', '13000', '14000', '15000', '16000', '17000', '18000', '19000', '20000', '21000', '22000', '23000', '24000', '25000', '26000', '27000', '28000', '29000', '30000', '31000', '32000', '33000', '34000', '35000', '36000', '37000', '38000', '39000', '40000', '41000', '42000','43000', '44000', '45000', '46000', '47000', '48000', '49000', '50000', '51000', '52000', '53000', '54000', '55000', '56000', '5,000', '58000', '59000', '60000', '61000', '62000', '63000', '64000', '65000', '66000', '67000', '68000', '69000', '70000', '71000', '72000', '73000', '74000', '75000', '76000', '77000', '78000', '79000', '80000', '81000', '82000', '83000', '84000', '85000', '8,000', '87000', '88000', '89000', '90000', '91000', '92000', '93000', '94000', '95000', '96000', '97000', '98000', '99000'],
  // prettier-ignore
  licenseAgeValues = ['16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50'],
  // prettier-ignore
  estMortgageValuesDRM = [...byTens(49, 0), ...byTwenties(50, 25), '1,500,000', '2,000,000', '2,000,001'],
  // prettier-ignore
  estPurchaseValuesDRM = ['85,000', '90,000', '95,000', '100,000', '105,000', '110,000', '115,000', '120,000', '125,000', '130,000', '135,000', '140,000', '145,000', '150,000', '155,000', '160,000', '165,000', '170,000', '175,000', '180,000', '185,000', '190,000', '195,000', '200,000', '210,000', '220,000', '230,000', '240,000', '250,000', '260,000', '270,000', '280,000', '290,000', '300,000', '310,000', '320,000', '330,000', '340,000', '350,000', '360,000', '370,000', '380,000', '390,000', '400,000', '420,000', '440,000', '460,000', '480,000', '500,000', '520,000', '540,000', '560,000', '580,000', '600,000', '620,000', '640,000', '660,000', '680,000', '700,000', '720,000', '740,000', '760,000', '780,000', '800,000', '820,000', '840,000', '860,000', '880,000', '900,000', '920,000', '940,000', '960,000', '980,000', '1,000,000', '1,500,000', '2,000,000', '2,000,001']

// global boolean to not run cashoutltv unless this var is true.
var runCashOutLTV = false

//define interest value slider
$('#interestValues').slider({
  max: interestValues.length - 1,
  range: 'min',
  value: 7,
  slide: function (event, ui) {
    $('#interestValueDisplay').text(interestValues[ui.value] + '%')
    $('#interestValuePost').val(interestValues[ui.value])
  },
})
$('#annualMileageValues').slider({
  max: annualMileageValues.length - 1,
  range: 'min',
  value: 12,
  slide: function (event, ui) {
    $('#annualMileage').text(annualMileageValues[ui.value])
    $('#annualMileagePost').val(annualMileageValues[ui.value])
  },
})
$('#licenseAgeValues').slider({
  max: licenseAgeValues.length - 1,
  range: 'min',
  value: 0,
  slide: function (event, ui) {
    $('#licenseAge').text(licenseAgeValues[ui.value])
    $('#ageFirstLicensedPost').val(licenseAgeValues[ui.value])
  },
})

//define downpayment value slider
$('#downpaymentValues').slider({
  max: downpaymentValues.length - 1,
  range: 'min',
  value: 0,
  slide: function (event, ui) {
    if (downpaymentValues[ui.value] == '5.00') {
      $('#downpaymentValueDisplay').text('0-5%')
    } else if (downpaymentValues[ui.value] == '25.00') {
      $('#downpaymentValueDisplay').text('25% or more')
    } else {
      $('#downpaymentValueDisplay').text(downpaymentValues[ui.value] + '%')
    }
    $('#downpaymentValuePost').val(downpaymentValues[ui.value])
  },
})

// this function creates a new cash out array based on your homes equity and reinitializes the sliders function
function createCashOutArray() {
  // start with an empty array
  var cashOutArray = [],
    equity85LTV = equity(),
    // this var rounds the 85% LTV to the closest 5000 in the array.
    cashOutEquity = Math.round(equity85LTV / 5000) * 5000

  // reset cashout value to max val when the stepChange function fires.
  $('#cashOutValuePost').val(cashOutEquity)

  if (cashOutEquity <= 5000) {
    if ($('#additional-cash-refinance').find('select').length !== -1) {
      cashOutArray = [0, 5000]
      $('#cashOutSelect').find('option').remove()

      for (var j = 0; j < 2; j++) {
        $('#cashOutSelect').append(
          $('<option></option>')
            .attr('value', cashOutArray[j])
            .text('$' + cashOutArray[j].toLocaleString())
        )
      }
      $('#cashOutSelect').val('5000')
    } else {
      return cashOutValuesStatic
    }
  } else if (!runCashOutLTV) {
    return cashOutValuesStatic
  } else {
    // creates the array based on 85% of your equity
    var cashOutArrayLength = cashOutEquity / 5000 + 1
    for (var i = 0; i < cashOutArrayLength; i++) {
      cashOutArray.push(i * 5000)
    }

    // resets display value to $5000
    $('#cashOutValueDisplay').text('$' + cashOutEquity.toLocaleString())
    $('#additional-cash-refinance .label2').text('$' + cashOutEquity.toLocaleString())

    // This block will input the cashout values created based on the equity into a dropdown by replacing the existing dropdowns with these values.
    if ($('#additional-cash-refinance').find('select').length !== -1) {
      $('#cashOutSelect').find('option').remove()

      for (var k = 0; k < cashOutArray.length; k++) {
        $('#cashOutSelect').append(
          $('<option></option>')
            .attr('value', cashOutArray[k])
            .text('$' + cashOutArray[k].toLocaleString())
        )
      }
      $('#cashOutSelect').val('5000')
    }

    // reset the slider to handle updated cashOutArray values
    $('#cashOutValues').slider({
      max: cashOutArray.length - 1,
      range: 'min',
      value: cashOutArray.length - 1,
      slide: function (event, ui) {
        var cashOutVal = cashOutArray[ui.value]
        $('#cashOutValueDisplay').text('$' + cashOutVal.toLocaleString())
        $('#cashOutValuePost').val(cashOutVal).trigger('change')
      },
    })

    return cashOutArray
  }
}

// initial onload cashout slider settings
$('#cashOutValues').slider({
  max: cashOutValuesStatic.length - 1,
  range: 'min',
  value: 1,
  slide: function (event, ui) {
    var cashOutVal = cashOutValuesStatic[ui.value]
    $('#cashOutValueDisplay').text('$' + cashOutVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
    $('#cashOutValuePost').val(cashOutVal.replace(/,/g, '')).trigger('change')
  },
})

/**
 * Sets the price display to the UI
 * @param  {} values
 * @param  {} key
 * @param  {} type
 */
function setPriceDisplay(values, key, type) {
  var amount

  if (values[key] === undefined) {
    amount = values[key + 1] + ' - $' + values[key + 2]
  } else {
    amount = values[key] + ' - $' + values[key + 1]
  }

  // parse the comma out from the value we display on ui
  parsedValue = function () {
    if (values[key + 1] == undefined) {
      return values[key].replace(/,/g, '')
    }
    return values[key + 1].replace(/,/g, '')
  }

  // define a value and a message for end of the slider
  var display = parsedValue() > 1000000 ? '1,000,000 +' : amount

  // output we show them
  $('#' + type + 'ValueDisplay').text('$' + display)

  // what we send on the post
  if (parsedValue() !== 0) {
    $('#' + type + 'ValuePost').val(parsedValue())
  } else {
    $('#' + type + 'ValuePost').val(50000)
  }
}

/**
 * Based the type of slider and the array of values, dynamically set the xxValueDisplay and xxValuePost
 * page elements when moving the slider
 * @param values    The array of values of the slider
 * @param key       The selected key of the slider which corresponds to the index of the array that is passed in
 * @param prefix    The prefix of the page elements associate with the slider
 */
function setPriceDisplayDBA(values, key, prefix) {
  var amount = values[key] + ' - $' + values[key + 1]

  // parse the comma out from the value we display on ui
  parsedValue = function () {
    if (values[key + 1] == undefined) {
      return values[key].replace(/,/g, '')
    }
    return values[key + 1].replace(/,/g, '')
  }

  // define a value and a message for end of the slider
  var display = parsedValue() > 2000000 ? 'Over $2,000,000' : '$' + amount

  // output we show them
  $('#' + prefix + 'ValueDisplay').text(display)

  // what we send on the post
  if (parsedValue() !== 0) {
    $('#' + prefix + 'ValuePost').val(parsedValue())
  } else {
    $('#' + prefix + 'ValuePost').val(60000)
  }
}

/**
 * Based the type of slider and the array of values, dynamically set the xxValueDisplay and xxValuePost
 * page elements when moving the slider
 * @param values    The array of values of the slider
 * @param key       The selected key of the slider which corresponds to the index of the array that is passed in
 * @param prefix    The prefix of the page elements associate with the slider
 */
function setPriceDisplayDRM(values, key, prefix) {
  var amount = values[key] + ' - $' + values[key + 1]

  // parse the comma out from the value we display on ui
  parsedValue = function () {
    if (values[key + 1] == undefined) {
      return values[key].replace(/,/g, '')
    }
    return values[key + 1].replace(/,/g, '')
  }

  // define a value and a message for end of the slider
  var display = parsedValue() > 2000000 ? 'Over $2,000,000' : '$' + amount

  // output we show them
  $('#' + prefix + 'ValueDisplay').text(display)

  // what we send on the post
  if (parsedValue() !== 0) {
    $('#' + prefix + 'ValuePost').val(parsedValue())
  } else {
    $('#' + prefix + 'ValuePost').val(60000)
  }
}

function attachPropertySliders(event, ui) {
  /**
   * If the current mortgage slider index is within 3 positions of the property slider index
   * If the propterty slider index is higher than 6 (100,000)
   * Set the mortgage slider index to 6 positions lower than the property slider index
   * IE. If property slider index is at position 10 (120,000) and the mortgage slider is 7 (105,000) and above
   * Set the mortgage slider index to position 10 - 6 =  4 (95,000)
   * OR: When the propterty slider is greater than $100,000, don't let the delta be less than $25,000
   */
  if (
    $('#mortgageValues').slider('option', 'value') > $('#propValues').slider('option', 'value') - 4 &&
    $('#propValues').slider('option', 'value') > 6
  ) {
    $('#mortgageValues').slider({
      value: $('#propValues').slider('option', 'value') - 6,
    })
    setPriceDisplay(estMortgageValues, $('#mortgageValues').slider('option', 'value'), 'mortgage')
  } else if (
    /**
     * If the mortgage slider index is 1 position less than the property slider index
     * Set the mortgage slider back 2 positions from the property slider index.
     * But this would only happen if property slider was in positions 0-6 because of the above conditional
     * IE.  If property slider is 100,000 or less, set the mortgage to 2 positions lower to keep the delta at $10,000
     */
    $('#mortgageValues').slider('option', 'value') >
    $('#propValues').slider('option', 'value') - 2
  ) {
    $('#mortgageValues').slider({
      value: $('#propValues').slider('option', 'value') - 2,
    })
  }

  /**
   * Don't let the mortgage slider be more than 7 positions lower than the property slider
   * This seems to be: don't let the delta be greater than $30,000
   */
  if ($('#mortgageValues').slider('option', 'value') < $('#propValues').slider('option', 'value') - 7) {
    $('#mortgageValues').slider({
      value: $('#propValues').slider('option', 'value') - 7,
    })
    setPriceDisplay(estMortgageValues, $('#mortgageValues').slider('option', 'value'), 'mortgage')
  }
}

function attachMortgageSliders(event, ui) {
  if ($('#mortgageValues').slider('option', 'value') > $('#propValues').slider('option', 'value') - 4) {
    return false
  }
}

function normalizeStoppedMortgageSliders() {
  if ($('#propValues').slider('option', 'value') === 2) {
    $('#mortgageValues').slider({
      value: $('#propValues').slider('option', 'value') - 2,
    })
    setPriceDisplay(estMortgageValues, $('#mortgageValues').slider('option', 'value'), 'mortgage')
  } else if (
    $('#mortgageValues').slider('option', 'value') > $('#propValues').slider('option', 'value') - 4 &&
    $('#mortgageValues').slider('option', 'value') > 4
  ) {
    $('#mortgageValues').slider({
      value: $('#propValues').slider('option', 'value') - 3,
    })
    setPriceDisplay(estMortgageValues, $('#mortgageValues').slider('option', 'value'), 'mortgage')
  }
}

function normalizeStoppedPropertySliders() {
  if (
    $('#mortgageValues').slider('option', 'value') > $('#propValues').slider('option', 'value') - 2 ||
    $('#mortgageValues').slider('option', 'value') >= $('#propValues').slider('option', 'value')
  ) {
    $('#mortgageValues').slider({
      value: $('#propValues').slider('option', 'value') - 2,
    })
    setPriceDisplay(estMortgageValues, $('#mortgageValues').slider('option', 'value'), 'mortgage')
  }
}

/**
 * Checks if the passed in slider value (index) is within acceptable ranges
 * @param value
 * @returns {boolean}
 */
function attachPropertySlidersDBA(sliderValue) {
  /**
   * Prevent the property slider value from going lower than 1 index greater
   * than current mortgage slider index (dbaMinDelta).
   * Prevent the property slider value from ever being less than the second position (dbaPropIndex).
   */
  if (sliderValue <= $('#mortgageValues').slider('option', 'value') + dbaMinDelta || sliderValue < 1) {
    return false
  }

  return true
}

/**
 * Sets the default page elements for the property slider based on passed in
 * mortgage slider index
 * @param sliderValue
 */
function normalizeStoppedMortgageSlidersDBA(sliderValue) {
  /**
   * If the passed in sliderValue is within the last 4
   * set the property slider default value to the last element
   */
  if (sliderValue > estMortgageValuesDBA.length - dbaDefaultDelta) {
    $('#propValues').slider({
      value: estPropValuesDBA.length - 1,
    })
  }

  // /**
  //  * If the passed in slider value is greater than or equal to the property slider's
  //  * set value and lower than the last 4 then set the default to 5 tiers ahead
  //  */
  // else if(sliderValue >= $("#propValues").slider("option", "value") - dbaMinDelta) {
  //     $("#propValues").slider({
  //         value: sliderValue + dbaDefaultDelta
  //     });
  //
  // }

  /**
   * Set the default to 5 positions ahead
   */
  else {
    $('#propValues').slider({
      value: sliderValue + dbaDefaultDelta,
    })
  }

  setPriceDisplayDBA(estPropValuesDBA, $('#propValues').slider('option', 'value'), 'prop')
}

/**
 * Normalizes the property slider values/displays based on the sliderValue that is passed in
 * @param sliderValue The passed in slider value when the slider.stop is called
 */
function normalizeStoppedPropertySlidersDBA(sliderValue) {
  /**
   * If the sliderValue isn't within a good range, set the slider value to 1 position higher than
   * the current mortgage slider value
   */
  if (attachPropertySlidersDBA(sliderValue) === false) {
    $('#propValues').slider({
      value: $('#mortgageValues').slider('option', 'value') + dbaMinDelta + 1,
    })
  }

  /**
   * Update the page elements now that the property slider value is normalized
   */
  setPriceDisplayDBA(estPropValuesDBA, $('#propValues').slider('option', 'value'), 'prop')
}

/**
 * Prepare the sliders
 */
function initiateSliders() {
  slidersType = 'initiateSliders'
  //define property value slider
  $('#propValues').slider({
    max: estPropValues.length - 1,
    min: 2,
    range: 'min',
    value: 30,
    slide: function (event, ui) {
      setPriceDisplay(estPropValues, ui.value, 'prop')
      if (attachedSliders == true) {
        attachPropertySliders(event, ui, estPropValues)
      }
    },
    stop: function (event, ui) {
      setPriceDisplay(estPropValues, ui.value, 'prop')
      if (attachedSliders == true) {
        normalizeStoppedPropertySliders()
      }
    },
  })

  //define mortgage value slider
  $('#mortgageValues').slider({
    max: estMortgageValues.length - 1,
    range: 'min',
    min: 1,
    value: 19,
    slide: function (event, ui) {
      setPriceDisplay(estMortgageValues, ui.value, 'mortgage')
      if (attachedSliders == true) {
        attachMortgageSliders(event, ui)
      }
    },
    stop: function (event, ui) {
      setPriceDisplay(estMortgageValues, ui.value, 'mortgage')
      if (attachedSliders == true) {
        normalizeStoppedMortgageSliders(event, ui)
      }
    },
  })

  //define purchase price value slider
  $('#purchaseValues').slider({
    max: estPurchaseValues.length - 1,
    range: 'min',
    value: 18,
    slide: function (event, ui) {
      setPriceDisplay(estPurchaseValues, ui.value, 'purchase')
    },
  })
}

function dbaSliders() {
  slidersType = 'dbaSliders'
  $('#propValues').slider({
    max: estPropValuesDBA.length - 1,
    // min: 2,
    range: 'min',
    value: 31,
    slide: function (event, ui) {
      if (estPropValuesDBA[ui.value] == '75,000') {
        $('#propValueDisplay').text('Under $75,000')
        $('#propValuePost').val(estPropValuesDBA[ui.value + 1].replace(/,/g, ''))
      } else if (estPropValuesDBA[ui.value] == '2,000,001') {
        $('#propValueDisplay').text('Over $2,000,000')
        $('#propValuePost').val(estPropValuesDBA[ui.value - 1].replace(/,/g, ''))
      } else {
        $('#propValueDisplay').text('$' + estPropValuesDBA[ui.value] + ' - $' + estPropValuesDBA[ui.value + 1])
        $('#propValuePost').val(estPropValuesDBA[ui.value + 1].replace(/,/g, ''))
      }
    },
  })

  $('#mortgageValues').slider({
    max: estMortgageValuesDBA.length - 1,
    // min: 2,
    range: 'min',
    value: 18,
    slide: function (event, ui) {
      if (estMortgageValuesDBA[ui.value] == '60,000') {
        $('#mortgageValueDisplay').text('$0 - $60,000')
        $('#mortgageValuePost').val(estMortgageValuesDBA[ui.value + 1].replace(/,/g, ''))
      } else if (estMortgageValuesDBA[ui.value] == '2,000,001') {
        $('#mortgageValueDisplay').text('Over $2,000,000')
        $('#mortgageValuePost').val(estMortgageValuesDBA[ui.value - 1].replace(/,/g, ''))
      } else {
        $('#mortgageValueDisplay').text(
          '$' + estMortgageValuesDBA[ui.value] + ' - $' + estMortgageValuesDBA[ui.value + 1]
        )
        $('#mortgageValuePost').val(estMortgageValuesDBA[ui.value + 1].replace(/,/g, ''))
      }
    },
  })

  $('#purchaseValues').slider({
    max: estPurchaseValuesDBA.length - 1,
    // min: 2,
    range: 'min',
    value: 29,
    slide: function (event, ui) {
      if (estPurchaseValuesDBA[ui.value] == '85,000') {
        $('#purchaseValueDisplay').text('$85,000 - $90,000')
        $('#purchaseValuePost').val(estPurchaseValuesDBA[ui.value + 1].replace(/,/g, ''))
      } else if (estPurchaseValuesDBA[ui.value] == '2,000,001') {
        $('#purchaseValueDisplay').text('Over $2,000,000')
        $('#purchaseValuePost').val(estPurchaseValuesDBA[ui.value - 1].replace(/,/g, ''))
      } else {
        $('#purchaseValueDisplay').text(
          '$' + estPurchaseValuesDBA[ui.value - 1] + ' - $' + estPurchaseValuesDBA[ui.value]
        )
        $('#purchaseValuePost').val(estPurchaseValuesDBA[ui.value].replace(/,/g, ''))
      }
    },
  })
}

var dbaMinDelta = 0
var dbaDefaultDelta = 7
var dbaMortgageIndex = estMortgageValuesDBA.indexOf('260,000')
var dbaPropIndex = dbaMortgageIndex + dbaDefaultDelta

function reverseLTVSliders() {
  slidersType = 'reverseLTVSliders'
  //define mortgage value slider
  $('#mortgageValues').slider({
    max: estMortgageValuesDBA.length - 1,
    range: 'min',
    min: 0,
    value: dbaMortgageIndex,
    slide: function (event, ui) {
      setPriceDisplayDBA(estMortgageValuesDBA, ui.value, 'mortgage')
    },
    stop: function (event, ui) {
      setPriceDisplayDBA(estMortgageValuesDBA, ui.value, 'mortgage')
      if (attachedSliders == true) {
        normalizeStoppedMortgageSlidersDBA(ui.value)
      }
    },
  })
  setPriceDisplayDBA(estMortgageValuesDBA, dbaMortgageIndex, 'mortgage')

  //define property value slider
  $('#propValues').slider({
    max: estPropValuesDBA.length - 1,
    min: 1,
    range: 'min',
    value: dbaPropIndex,
    slide: function (event, ui) {
      if (attachPropertySlidersDBA(ui.value) === true) {
        setPriceDisplayDBA(estPropValuesDBA, ui.value, 'prop')
      }
    },
    stop: function (event, ui) {
      normalizeStoppedPropertySlidersDBA(ui.value)
    },
  })
  setPriceDisplayDBA(estPropValuesDBA, dbaPropIndex, 'prop')

  //define purchase price value slider
  $('#purchaseValues').slider({
    max: estPurchaseValuesDBA.length - 1,
    range: 'min',
    value: 29,
    slide: function (event, ui) {
      setPriceDisplayDBA(estPurchaseValuesDBA, ui.value, 'purchase')
    },
  })
  // don't initialize the setPriceDisplayDBA for #purchaseValues since we need it to default to "155000"
}

const drmMinDelta = 0
const drmDefaultDelta = 6
const drmMortgageIndex = estMortgageValuesDRM.indexOf('260,000')
const drmPropIndex = drmMortgageIndex + drmDefaultDelta

function drmLTVSliders() {
  slidersType = 'drmLTVSliders'
  //define mortgage value slider
  $('#mortgageValues').slider({
    max: estMortgageValuesDRM.length - 1,
    range: 'min',
    min: 0,
    value: drmMortgageIndex,
    slide: function (event, ui) {
      setPriceDisplayDRM(estMortgageValuesDRM, ui.value, 'mortgage')
    },
    stop: function (event, ui) {
      setPriceDisplayDRM(estMortgageValuesDRM, ui.value, 'mortgage')
      if (attachedSliders == true) {
        normalizeStoppedMortgageSlidersDBA(ui.value)
      }
    },
  })
  setPriceDisplayDRM(estMortgageValuesDRM, dbaMortgageIndex, 'mortgage')

  //define property value slider
  $('#propValues').slider({
    max: estPropValuesDBA.length - 1,
    min: 1,
    range: 'min',
    value: drmPropIndex,
    slide: function (event, ui) {
      if (attachPropertySlidersDBA(ui.value) === true) {
        setPriceDisplayDRM(estPropValuesDBA, ui.value, 'prop')
      }
    },
    stop: function (event, ui) {
      normalizeStoppedPropertySlidersDBA(ui.value)
    },
  })
  setPriceDisplayDRM(estPropValuesDBA, dbaPropIndex, 'prop')

  //define purchase price value slider
  $('#purchaseValues').slider({
    max: estPurchaseValuesDRM.length - 1,
    range: 'min',
    value: 29,
    slide: function (event, ui) {
      setPriceDisplayDRM(estPurchaseValuesDRM, ui.value, 'purchase')
    },
  })
  // don't initialize the setPriceDisplayDRM for #purchaseValues since we need it to default to "155000"
}

/**
 * checks to see if s1 qs param exists, if so update DOM with dynamic content static non-api version
 */

var zetaTrigger = getParameterByName('sced')

/******** For non-ratemarketplace sites remove zeta if not organic, for RMP only remove if sced=0 *******/
function zetaRemove() {
  if (document.URL.indexOf('ratemarketplace') === -1) {
    if (zetaTrigger == 0 || affiliateId() !== '52') {
      $('.zeta').remove()
    }
  } else if (zetaTrigger == 0) {
    $('.zeta').remove()
  }
}

function addDisclosureButton() {
  $('.card, #milt_question').append(
    '<p class="pre-disclosure">*We do not own any of the trademarks or rights associated with any of the products which are the property of their respective owner(s). This product does not claim to be endorsed by, or represent any of the trademarks.</p>'
  )
  $('.pre-disclosure').on(
    'click touchend touchcancel',
    $.debounce(300, function (e) {
      e.preventDefault()
      $('html, body').animate(
        {
          scrollTop: $('.disclosure-container').offset().top,
        },
        500
      )
    })
  )
}

/**
 * updates 100k sites headline 100k value if param exists
 * @param  {} paramVal
 */
function hundredKHeadline(paramVal) {
  // timeout is so it doesn't create a race condtion if there is a URL param of ea= in the URL
  setTimeout(function () {
    $('.loan_val').text(parseInt(paramVal).toLocaleString())
    $('#you-do-step-refinance .headline').css('visibility', 'visible')
  }, 100)
}
/**
 * FEDP-1159: Dynamically update the property value and mortage amount defaults if the site is NOT a 100k site
 * @param  {} loanAmountLower
 * @param  {} loanAmountUpper
 * @param  {} homeValueLower
 * @param  {} homeValueUpper
 */
/* function setLoanAmountandHomeValueDefaults(loanAmountLower, loanAmountUpper, homeValueLower, homeValueUpper) {
    if ($('input[name="est_property_value"]').attr('type') == 'hidden') {
        $('#propValueDisplay').text(
            '$' + homeValueLower.toLocaleString() + ' - ' + '$' + homeValueUpper.toLocaleString()
        )
        $('#propValuePost')
            .val(homeValueUpper)
            .trigger('change')
        $('#propValues').slider({
            value: 38,
        })
    } else {
        // this is a dropdown
        setTimeout(function() {
            $('[name="est_property_value"]').val(homeValueUpper)
        }, 500)
    }

    if ($('input[name="mortgage_amount"]').attr('type') == 'hidden') {
        $('#mortgageValueDisplay').text(
            '$' + loanAmountLower.toLocaleString() + ' - ' + '$' + loanAmountUpper.toLocaleString()
        )
        $('#mortgageValuePost')
            .val(loanAmountUpper)
            .trigger('change')
        $('#mortgageValues').slider({
            value: 30,
        })
    }

    if (noDltv === true) {
        $('[name="mortgage_amount"]').val(loanAmountUpper)
    }
} */

/**
 * Param based headline update for only 100k sites
 * @param  {} equityAgeParam
 */
function equityAgeUpdate(equityAgeParam) {
  var ageParam = parseInt(equityAgeParam),
    equityAmount = '',
    equityAge = ''

  // Schema of ages and default values
  if (0 <= ageParam && ageParam <= 34) {
    equityAmount = '97,000'
    equityAge = '55-64'
  } else if (35 <= ageParam && ageParam <= 44) {
    equityAmount = '40,000'
    equityAge = '35-44'
  } else if (45 <= ageParam && ageParam <= 54) {
    equityAmount = '70,000'
    equityAge = '45-54'
  } else if (55 <= ageParam && ageParam <= 64) {
    equityAmount = '97,000'
    equityAge = '55-64'
  } else if (65 <= ageParam) {
    equityAmount = '130,000'
    equityAge = '65+'
  } else {
    equityAmount = '97,000'
    equityAge = '55-64'
  }

  $('.headline').html(
    'On average, people ages <span class="avg_age">' +
      equityAge +
      '</span> have $<span class="avg_equity loan_val">' +
      equityAmount +
      '</span> of equity in their home.'
  )
  $('.subhead').remove()
  $('.headline').after('<p class="subhead">What would you do with the equity in your home?</p>')
  $('#you-do-step-refinance .subhead').css('visibility', 'visible')
  $('input[name=age]').val(equityAge)
}

// FEDP-1197 Adds dynamic headline based on "kw" URL Param above standard headline on va.hbs layout only
function addGetKWHeadline(kw) {
  $('.dynamicHeadline').text(kw)
}

// FEDP-1275 - Add dynamic headline on 100k sites based on a hd URL Param
function dynamicHeadlines(headline) {
  var h

  switch (headline) {
    case '1':
      h = 'Cash May Be Available to Remodel Your Home'
      break
    case '2':
      h = "Gov't Programs Allow Qualified Homeowners to Get Cash-Outs for Home Improvements"
      break
    case '3':
      h = 'Qualified Homeowners Eligible to Receive Cash for Home Improvements. Check If You Qualify...'
      break
    case '4':
      h = 'Qualified Homeowners Accessing Cash for Home Improvements'
      break
    default:
      break
  }

  if (headline !== '') {
    $('.headline').text(h)
    $('#you-do-step-refinance .headline').css('visibility', 'visible')
  }
}

// FEDP-1275 - Add dynamic subheadline on 100k sites based on a shd URL Param.  Requires the da URL Param in order to render from switch case.
function dynamicSubheadlines(subheadline, hundredk) {
  var s,
    a,
    amount = hundredk

  if (amount) {
    a = parseInt(amount).toLocaleString()
  } else {
    a = '100,000'
  }

  switch (subheadline) {
    case '1':
      s = 'If you had $' + a + ' where would you start?'
      break
    case '2':
      s = 'If you had $' + a + ' what would you improve?'
      break
    case '3':
      s = '$' + a + ' may be available. Check if you qualify.'
      break
    case '4':
      s = 'If you had $' + a + ' what would you use it for?'
      break
    default:
      break
  }

  if (subheadline !== '') {
    $('.subhead').text(s)
    $('#you-do-step-refinance .subhead').css('visibility', 'visible')
  }
}

$(document).ready(function () {
  try {
    if (getParameterByName('adv') === '1') {
      var advertorialHTML = $('.headline-container').html(),
        advertorialDisclosures = ''

      if (document.URL.indexOf('lowrateshopper.com') >= 0) {
        // eslint-disable-next-line
        advertorialHTML = `<div class="advIntro"> <h1 onClick="animateFunction('#intro-frame', 0)">This Girl Just Put $28,100 In Her Pocket In A Matter Of Minutes. Find Out How Below.</h1> <img src="./img/kristin-check.jpg"  onClick="animateFunction('#intro-frame', 0)" alt="Girl holding check" /> <p class="bold"> I know it sounds too good to be true...but the girl in the picture above just put $28,100 back into her pocket in a matter of minutes, and millions of American Homeowners could do the same by taking advantage of new Government Programs designed to help the middle-class. </p><p> When Kris T. first heard the number, she was absolutely stunned. She went into this situation hoping to save a few bucks, but <span class="bold">$28,100</span> was more than she ever imagined. </p><p>"I honestly couldn't believe it." she said. "I never thought I'd be able to cut THAT much off my mortgage".</p><p class="heading">The "Perfect Storm" Of Mortgage Reduction</p><p>The reason for her windfall is simple.</p><p> For starters, interest rates are lower than they've been in years. This means that banks make less money and middle-class Americans get to keep more of their hard earned cash. </p><p> In addition to that, there are a number of amazing new Government Programs that were created specifically to provide a stimulus benefit to middle class homeowners. </p><p>Combining those two factors means creating one of the most lucrative mortgage reduction packages in years. <span onClick="animateFunction('#intro-frame', 0)" class="cta-blue">Visit this site to see if you qualify &gt;&gt;</span></p><p class="heading">Breaking Down The Numbers.</p><p>There are a few little-known benefits that occur when you take advantage of these programs.</p><p> For starters, you immediately get an escrow check. In Kristin's case, she immediately got handed <span class="bold">$800 free and clear.</span> That money went right into her pocket to be used for whatever she wanted. </p><p> The next thing that happened was that she was given a mortgage deferment, meaning she didn't have to pay a mortgage bill that month. That's an <span class="bold">extra $2,100 in her bank account</span> that otherwise wouldn't have been there. </p><p> Finally, her new interest rate meant that she lowered her monthly mortgage payment by <span class="bold">$300 a month, every month,</span> for as long as she has the loan. The average homeowner keeps their mortgage for 7 years, meaning that <span class="bold">she will end up pocketing an extra $25,200</span> over the life of her loan, simply for taking a few minutes to answer a few questions online. </p><p class="heading bigger">Calculate Your Cash</p><p class="bold">It's easy and takes 60 seconds or less</p><p><span class="bold">Important:</span> It's completely free to check your eligibility and only takes approximately 60 seconds.</p></div>`

        // eslint-disable-next-line
        advertorialDisclosures = `<div class="adv-disclosures"> <p> THIS IS AN ADVERTISEMENT AND NOT AN ACTUAL NEWS ARTICLE, BLOG OR CONSUMER PROTECTION UPDATE. The authors of this website are dedicated to bringing readers valuable information which can help them accomplish their financial goals. This site does receive compensation for product reviews and referrals or purchases made through our links. This page is an advertisement/advertorial. Any story that may appear on this site is for demonstration purposes only and everyone's results may vary. We hope you find our online resource informative and helpful. </p><p> *Kris T recently refinanced her conventional mortgage loan. Testimonial was provided by employee of advertiser and may have been compensated for such testimonial. </p></div>`

        $('.source').append(
          '<br><span class="adv-link">*http://www.freddiemac.com/blog/homeownership/20190321_keep_calm_and_shop_on.page</span>'
        )
      } else if (
        document.URL.indexOf('yourvasurvey.info') >= 0 ||
        document.URL.indexOf('vahomequiz.com') >= 0 ||
        document.URL.indexOf('veteranhomequiz.com') >= 0 ||
        document.URL.indexOf('localhost') >= 0
      ) {
        // eslint-disable-next-line
        advertorialHTML = `<div class="advIntro" onClick="animateFunction('.card', 0)"><h1>Choose Your Branch of Service To Get Started:</h1><div class="military-gifs"> <img src="https://s3-us-west-1.amazonaws.com/offers.printfingertech.net/images/army-gif.gif" alt="army"/> <img src="https://s3-us-west-1.amazonaws.com/offers.printfingertech.net/images/marines-gif.gif" alt="marines"/> <img src="https://s3-us-west-1.amazonaws.com/offers.printfingertech.net/images/navy-gif.gif" alt="navy"/> <img src="https://s3-us-west-1.amazonaws.com/offers.printfingertech.net/images/airforce-gif.gif" alt="air force"/> <img src="https://s3-us-west-1.amazonaws.com/offers.printfingertech.net/images/coastguard-gif.gif" alt="coast guard"/> </div><h1 onClick="animateFunction('.card', 0)">4 VA Home Loan Myths Busted</h1> <img src="https://s3-us-west-1.amazonaws.com/offers.printfingertech.net/images/advImage1.jpg" onClick="animateFunction('.card', 0)" alt="Government Building"/> <p class="bold"> If you're a veteran, don't be fooled by these common misconceptions so you can receive the full value of your VA benefits that you're entitled to. </p><p> Millions of current and former military personnel have purchased homes with no down payment because of easier qualifying terms or have greatly reduced their current mortgage payment through refinance. </p><p>Take a look at the 4 VA loan myths that keep Veterans from seeking their hard-earned home loan benefits...</p><p class="heading">Myth 1: You need perfect credit</p><p>VA loans have more flexible and forgiving credit guidelines to help Veterans and military members who have served our country.</p><p> The VA doesn't require a certain credit score. But the private lenders will, however, different lenders require different credit scores. So if you don't meet the requirements for one lender, doesn't mean you won't be approved by another. </p><p> If you have experienced bankruptcy or foreclosure, VA loans usually have shorter waiting periods after negative credit events. If you were denied in the past, try again! </p><p class="heading">Myth 2: VA loans cost more</p><p> VA loans offer big-time benefits that have helped millions of Veterans become homeowners or refinance their homes. These $0 down loans don't actually cost more than any other loan types. </p><p> VA home loans require no down payment, which gives more buying power to a Veteran who wants to buy a home. </p><p> Conventional and FHA loans both require upfront and annual mortgage insurance charges. VA buyers will have to pay a upfront funding fee that varies depending on your service history, your down payment, and whether it’s your first use of the benefit. Veterans who receive compensation for a service-connected disability don’t have to pay this fee. </p><p class="heading">Myth 3: VA loans take forever to close</p><p> VA loans have a reputation for being slow and difficult to get. Though some reflect old conceptions, the program has improved a lot over the last 15 years. </p><p>The VA home loan program has become much faster and more efficient. On average, VA appraisals come back within 10 business days.</p><p>In comparison to conventional loans, VA loans have had higher closing success rates and have similar wait times. Want to get started now?</p><p class="headling">Myth 4: No down payment makes VA loans risky</p><p> According to the Mortgage Bankers Association, VA home loans have had the lowest foreclosure rates over the past 8+ years over any other mortgage for the most part. </p><p> The VA's discretionary income guideline helps buyers determine if they can stay current on their mortgage payment in case of a financial hiccup. Their foreclosure prevention team also does an excellent job to help avoid foreclosure and will reach out to Veterans at the first site of any financial danger. </p><p class="heading bigger">So, How Do I Find Out If I'm Eligible?</p><p class="heading"> Answer a few questions about your home, starting with the questions below. Start here to check your eligibility. </p><p>It’s 100% free to see if you're eligible, and only takes about 2 minutes to get started.</p><p>Step 1: Answer the questions below to begin our free 2 minute quiz.</p><p> Step 2: Once you go through our short quiz, you will get connected with a top lender and find out if you're eligible. Millions of Veterans have purchased or refinanced their home with the help of a VA loan, so what's stopping you? Start today! </p></div>`

        // eslint-disable-next-line
        advertorialDisclosures = `<div class="adv-disclosures"> <p> THIS IS AN ADVERTISEMENT AND NOT AN ACTUAL NEWS ARTICLE, BLOG OR CONSUMER PROTECTION UPDATE. The authors of this website are dedicated to bringing readers valuable information which can help them accomplish their financial goals. This site does receive compensation for product reviews and referrals or purchases made through our links. This page is an advertisement/advertorial. Any story that may appear on this site is for demonstration purposes only and everyone's results may vary. We hope you find our online resource informative and helpful.</p></div>`

        $('.v-container').css('padding-bottom', '75px')
      }
      $('.headline-container').html(advertorialHTML)
      $('.disclosure-container').css('margin-top', '0')
      $('.disclosures').append(advertorialDisclosures)
    }
  } catch (error) {
    console.log(error)
  }
})

function addressAndZip() {
  return `
    <fieldset class="card" id="address-step-refinance" data-card="address">
                        <div class="inner-container">
                                <p class="question-label">Question <span class="stepNum"></span> of <span class="refiFieldTotal"></span></p>
                            <h4 class="question">Where do you currently live?</h4>
                            <p class="helper-text">Property values vary per area - this helps calculate the most accurate numbers</p>
                            <div class="form-list">
                                    <p class="labels mobileLabel">Street Address*</p>
                                            <input type="hidden" name="address" id="address-r">
                                            <input type="text" id="autocomplete-r" class="form-control input address"  placeholder="Enter Street Address"  autocomplete="nope" />
                                    <div class="custom-error error-state google-address">Please fill out this field</div>
                                    <p class="labels mobileLabel">Enter Zip *</p>
                                    <input type="number" min="0" pattern="[0-9]*" class="zipcode input" name="zipcode" id="zipcode-initial-refinance" data-validation="zip" autocomplete="nope" placeholder="Enter Zip Code" >
                                    <div class="zipcode-error-state error-state">Please enter a whole number (i.e. 90210)</div>
                                    <div class="address_string address_change">
                                                        <span class="city_span"></span>, <span class="state_span"></span> <span class="zip_span"></span>
                                                        <a href="#" class="change-address">Change</a>
                                                    </div>
                                                    <div class=" city-state-second">
                                                        <p class="city-state-second labels">City*</p>
                                                        <input type="text" name="city" class="city-state-second city input city_input" id="city-refinance" autocomplete="nope"  placeholder="Enter City"  />
                                                        <div class="custom-error error-state">Please complete this field.</div>
                                                    </div>
                                                    <div class="city-state-second">
                                                        <p class="city-state-second labels">State*</p>
                                                        <select name="state" class="city-state-second state dropdown_state input" id="state-refinance" autocomplete="nope">
                                                            <option selected disabled>Select one:</option>
                                                            <option value="AL">Alabama</option>
                                                            <option value="AK">Alaska</option>
                                                            <option value="AZ">Arizona</option>
                                                            <option value="AR">Arkansas</option>
                                                            <option value="CA">California</option>
                                                            <option value="CO">Colorado</option>
                                                            <option value="CT">Connecticut</option>
                                                            <option value="DE">Delaware</option>
                                                            <option value="DC">District Of Columbia</option>
                                                            <option value="FL">Florida</option>
                                                            <option value="GA">Georgia</option>
                                                            <option value="HI">Hawaii</option>
                                                            <option value="ID">Idaho</option>
                                                            <option value="IL">Illinois</option>
                                                            <option value="IN">Indiana</option>
                                                            <option value="IA">Iowa</option>
                                                            <option value="KS">Kansas</option>
                                                            <option value="KY">Kentucky</option>
                                                            <option value="LA">Louisiana</option>
                                                            <option value="ME">Maine</option>
                                                            <option value="MD">Maryland</option>
                                                            <option value="MA">Massachusetts</option>
                                                            <option value="MI">Michigan</option>
                                                            <option value="MN">Minnesota</option>
                                                            <option value="MS">Mississippi</option>
                                                            <option value="MO">Missouri</option>
                                                            <option value="MT">Montana</option>
                                                            <option value="NE">Nebraska</option>
                                                            <option value="NV">Nevada</option>
                                                            <option value="NH">New Hampshire</option>
                                                            <option value="NJ">New Jersey</option>
                                                            <option value="NM">New Mexico</option>
                                                            <option value="NY">New York</option>
                                                            <option value="NC">North Carolina</option>
                                                            <option value="ND">North Dakota</option>
                                                            <option value="OH">Ohio</option>
                                                            <option value="OK">Oklahoma</option>
                                                            <option value="OR">Oregon</option>
                                                            <option value="PA">Pennsylvania</option>
                                                            <option value="PR">Puerto Rico</option>
                                                            <option value="RI">Rhode Island</option>
                                                            <option value="SC">South Carolina</option>
                                                            <option value="SD">South Dakota</option>
                                                            <option value="TN">Tennessee</option>
                                                            <option value="TX">Texas</option>
                                                            <option value="UT">Utah</option>
                                                            <option value="VT">Vermont</option>
                                                            <option value="VA">Virginia</option>
                                                            <option value="WA">Washington</option>
                                                            <option value="WV">West Virginia</option>
                                                            <option value="WI">Wisconsin</option>
                                                            <option value="WY">Wyoming</option>
                                                        </select>
                                                        <div class="custom-error error-state">Please complete this field.</div>
                                                    </div>
                            </div>
                            <div class="next-button-container">
                                <button type="button" class="btn-primary next-button">
                                    <p>Next</p>
                                    <div class="icon-container"><span class="icon-next-arrow"></span></div>
                                </button>
                                <br>
                                <button type="button" class="back-button">Back</button>
                            </div>
                        </div>
                    </fieldset>
    `
}

function addressOnlyStep() {
  return `
    <fieldset class="card" id="address-step-refinance">
                                    <div class="inner-container">
                                            <p class="question-label">Question <span class="stepNum"></span> of <span class="refiFieldTotal"></span></p>
                                        <h4 class="question">Where do you currently live?</h4>
                                        <div class="form-list">
                                            <p class="labels">Street Address*</p>
                                                    <input type="hidden" name="address" id="address-r">
                                                    <input type="text" id="autocomplete-r" class="form-control input address"  placeholder="Enter Street Address"  autocomplete="nope" />
                                            <div class="custom-error error-state google-address">Please fill out this field</div>
                                            <div class="address_string address_change">
                                                <span class="city_span"></span>, <span class="state_span"></span> <span class="zip_span"></span>
                                                <a href="#" class="change-address">Change</a>
                                            </div>
                                            <p class="city-state-second labels">City*</p>
                                            <input type="text" name="city" class="city-state-second city input" id="city-refinance" autocomplete="nope"  placeholder="Enter City"  />
                                            <div class="city-state-error error-state">Please fill out this field</div>
                                            <p class="city-state-second labels">State*</p>
                                            <select name="state" class="city-state-second state dropdown_state input" id="state-refinance" autocomplete="nope">
                                                <option selected disabled>Select one:</option>
                                                <option value="AL">Alabama</option>
                                                <option value="AK">Alaska</option>
                                                <option value="AZ">Arizona</option>
                                                <option value="AR">Arkansas</option>
                                                <option value="CA">California</option>
                                                <option value="CO">Colorado</option>
                                                <option value="CT">Connecticut</option>
                                                <option value="DE">Delaware</option>
                                                <option value="DC">District Of Columbia</option>
                                                <option value="FL">Florida</option>
                                                <option value="GA">Georgia</option>
                                                <option value="HI">Hawaii</option>
                                                <option value="ID">Idaho</option>
                                                <option value="IL">Illinois</option>
                                                <option value="IN">Indiana</option>
                                                <option value="IA">Iowa</option>
                                                <option value="KS">Kansas</option>
                                                <option value="KY">Kentucky</option>
                                                <option value="LA">Louisiana</option>
                                                <option value="ME">Maine</option>
                                                <option value="MD">Maryland</option>
                                                <option value="MA">Massachusetts</option>
                                                <option value="MI">Michigan</option>
                                                <option value="MN">Minnesota</option>
                                                <option value="MS">Mississippi</option>
                                                <option value="MO">Missouri</option>
                                                <option value="MT">Montana</option>
                                                <option value="NE">Nebraska</option>
                                                <option value="NV">Nevada</option>
                                                <option value="NH">New Hampshire</option>
                                                <option value="NJ">New Jersey</option>
                                                <option value="NM">New Mexico</option>
                                                <option value="NY">New York</option>
                                                <option value="NC">North Carolina</option>
                                                <option value="ND">North Dakota</option>
                                                <option value="OH">Ohio</option>
                                                <option value="OK">Oklahoma</option>
                                                <option value="OR">Oregon</option>
                                                <option value="PA">Pennsylvania</option>
                                                <option value="PR">Puerto Rico</option>
                                                <option value="RI">Rhode Island</option>
                                                <option value="SC">South Carolina</option>
                                                <option value="SD">South Dakota</option>
                                                <option value="TN">Tennessee</option>
                                                <option value="TX">Texas</option>
                                                <option value="UT">Utah</option>
                                                <option value="VT">Vermont</option>
                                                <option value="VA">Virginia</option>
                                                <option value="WA">Washington</option>
                                                <option value="WV">West Virginia</option>
                                                <option value="WI">Wisconsin</option>
                                                <option value="WY">Wyoming</option>
                                            </select>
                                            <div class="city-state-error error-state">Please fill out this field</div>
                                            <p class="city-state-second labels">Zip Code*</p>
                                            <input type="number" name="zipcode" min="0" pattern="[0-9]*" class="city-state-second zipcode-second zipcode input" data-validation="zip" autocomplete="nope"  placeholder="Enter Zip Code"  />
                                            <div class="zipcode-error-state error-state">Please enter a whole number (i.e. 90210)</div>
                                        </div>
                                        <div class="next-button-container">
                                            <button type="button" class="btn btn-primary next-button">
                                                <p>Next</p>
                                                <div class="icon-container"><span class="icon-next-arrow"></span></div>
                                            </button>
                                            <br>
                                            <button type="button" class="back-button">Back</button>
                                        </div>
                                    </div>
                                </fieldset>`
}

function emailtoFF(path) {
  return `
  <div class="form-list">
    <p class="labels">Email*:</p>
    <input type="email" class="email input" name="email" id="email-${path}" data-validation="email" autocomplete="nope" autofocus="" placeholder="Enter Email Address">
    <div class="custom-error-email error-state" style="display: none;">Please enter a valid email address.</div>
  </div>
    `
}

function addresstoFF() {
  return `
  <p class="labels">Street Address*</p>
    <input type="hidden" name="address" id="address-r">
    <input type="text" id="autocomplete-r" class="form-control input address pac-target-input" placeholder="Enter Street Address" autocomplete="off">
  <div class="custom-error error-state google-address">Please fill out this field</div>
  <div class="address_string address_change" style="display: block;">
    <span class="city_span"></span>, <span class="state_span"></span> <span class="zip_span"></span>
    <a href="#" class="change-address">Change</a>
  </div>
  <p class="city-state-second labels" style="display: none;">City*</p>
  <input type="text" name="city" class="city-state-second city input" id="city-purchase" autocomplete="nope" placeholder="Enter City" style="display: none;">
  <div class="city-state-error error-state" style="display: none;">Please fill out this field</div>
  <p class="city-state-second labels" style="display: none;">State*</p>
  <select name="state" class="city-state-second state dropdown_state input" id="state-purchase" autocomplete="nope" style="display: none;">
    <option selected="" disabled="">Select one:</option>
    <option value="AL">Alabama</option>
    <option value="AK">Alaska</option>
    <option value="AZ">Arizona</option>
    <option value="AR">Arkansas</option>
    <option value="CA">California</option>
    <option value="CO">Colorado</option>
    <option value="CT">Connecticut</option>
    <option value="DE">Delaware</option>
    <option value="DC">District Of Columbia</option>
    <option value="FL">Florida</option>
    <option value="GA">Georgia</option>
    <option value="HI">Hawaii</option>
    <option value="ID">Idaho</option>
    <option value="IL">Illinois</option>
    <option value="IN">Indiana</option>
    <option value="IA">Iowa</option>
    <option value="KS">Kansas</option>
    <option value="KY">Kentucky</option>
    <option value="LA">Louisiana</option>
    <option value="ME">Maine</option>
    <option value="MD">Maryland</option>
    <option value="MA">Massachusetts</option>
    <option value="MI">Michigan</option>
    <option value="MN">Minnesota</option>
    <option value="MS">Mississippi</option>
    <option value="MO">Missouri</option>
    <option value="MT">Montana</option>
    <option value="NE">Nebraska</option>
    <option value="NV">Nevada</option>
    <option value="NH">New Hampshire</option>
    <option value="NJ">New Jersey</option>
    <option value="NM">New Mexico</option>
    <option value="NY">New York</option>
    <option value="NC">North Carolina</option>
    <option value="ND">North Dakota</option>
    <option value="OH">Ohio</option>
    <option value="OK">Oklahoma</option>
    <option value="OR">Oregon</option>
    <option value="PA">Pennsylvania</option>
    <option value="PR">Puerto Rico</option>
    <option value="RI">Rhode Island</option>
    <option value="SC">South Carolina</option>
    <option value="SD">South Dakota</option>
    <option value="TN">Tennessee</option>
    <option value="TX">Texas</option>
    <option value="UT">Utah</option>
    <option value="VT">Vermont</option>
    <option value="VA">Virginia</option>
    <option value="WA">Washington</option>
    <option value="WV">West Virginia</option>
    <option value="WI">Wisconsin</option>
    <option value="WY">Wyoming</option>
  </select>
  <div class="city-state-error error-state" style="display: none;">Please fill out this field</div>
  <p class="city-state-second labels" style="display: none;">Zip Code*</p>
  <input type="text" name="zipcode" min="0" pattern="[0-9]*" class="city-state-second zipcode-second zipcode input" data-validation="zip" autocomplete="nope" placeholder="Enter Zip Code" style="display: none;">
  <div class="zipcode-error-state error-state" style="display: none;">Please enter a whole number (i.e. 90210)</div>`
}

/**
 * Moves address to the zipcode step
 */
function addressMove1() {
  const zipAddress = addressAndZip()

  $('#zipcode-step-refinance').before(zipAddress)
  $('#zipcode-step-refinance').remove()
  $('#final-frame-refinance [name=phone_primary]').nextAll().remove()
  $(document).ready(function () {
    initAutocomplete()
  })
  console.log('am1')
}

/**
 * Moves address before email step
 */
function addressMove2() {
  const address = addressOnlyStep()
  $('#email-step-refinance').before(address)
  $('#final-frame-refinance [name=phone_primary]').nextAll().remove()
  $(document).ready(function () {
    initAutocomplete()
  })
  console.log('am2')
}

/**
 * Moves address after email step before final frame
 */
function addressMove3() {
  const address = addressOnlyStep()
  $('#email-step-refinance').after(address)
  $('#final-frame-refinance [name=phone_primary]').nextAll().remove()
  $(document).ready(function () {
    initAutocomplete()
  })
  console.log('am3')
}

// Sets Params to fire each of the addressMove functions

/* if (getParameterByName('am') === '1') {
  addressMove1()
}
if (getParameterByName('am') === '2') {
  addressMove2()
}
if (getParameterByName('am') === '3') {
  addressMove3()
} */

/**
 * Moves email step to final frame and removes email fieldset
 */
function moveEmailtoFinalFrame() {
  const emailr = emailtoFF('refinance')
  const emailp = emailtoFF('purchase')
  if ($('.final-frame').find('[name=email]').length <= 0) {
    $('#msform-refinance [name=phone_primary]').next('.custom-error').after(emailr)
    $('#msform-purchase [name=phone_primary]').next('.custom-error').after(emailp)
    $('#email-step-refinance, #email-step-purchase').remove()
    console.log('em2ff-success')
  }
}

/**
 * Moves address step to final frame and removes address fieldset
 */
function moveAddresstoFinalFrame() {
  if ($('.final-frame').find('[name=address]').length <= 0) {
    const address = addresstoFF()
    $('[name=phone_primary]').next('.custom-error').after(address)
    $('#address-step-refinance').remove()
    $(document).ready(function () {
      initAutocomplete()
    })
  }
  return
}

// adds a div with a phone number inside the phone container at the top of all footers
if (getParameterByName('spn') === '1') {
  $('#phoneContainer').append(
    '<div style="font-size: 16px; margin-bottom: 10px;">Solar Hotline: <a href="tel:8333140208" style="color: inherit;">1-833-314-0208</a></div>'
  )
}

// if url param rlt=1 then move credit, late, real estate, and estimated debt after the first step
if (getParameterByName('rlt') === '1') {
  $('#credit-step-refinance').insertBefore('#msform-refinance fieldset:first-of-type')
  $('#late-on-mortgage-refinance').insertAfter('#credit-step-refinance')
  $('#real-estate-refinance').insertAfter('#late-on-mortgage-refinance')
  $('#estimated-debt-step-refinance').insertAfter('#real-estate-refinance')
}

if (getParameterByName('dpav')) {
  const dpav = getParameterByName('dpav')
  const initialHeadline = $('.headline').text()
  let h = $('.headline').text()

  switch (dpav) {
    case '1':
      h = 'Veterans are Using New Options For $0 Down Financing.'
      break
    case '2':
      h = 'Veterans Are Using VA Housing Benefits for $0 Down Home Purchases.'
      break
    case '3':
      h = 'Do You Qualify for the  $42,000 VA Home Purchase Benefit?'
      break
    case '4':
      h = 'Veteran Down Payment Assistance. Up To $42,000'
      break
    case '5':
      h = 'New 2021 Veteran Home Purchase Program'
      break

    default:
      h = initialHeadline
      break
  }

  $('.headline').text(h)
}

/**
 * Updates background and headline text
 * @param  {string} bgColor
 * @param  {string} textColor
 */
function backgroundColor(bgColor, textColor) {
  // used variables and short circuiting so I don't reassign the function parameters
  const bg = bgColor || 'initial'
  const text = textColor || 'initial'

  $('body').css('background', bg)
  $('.headline-container').css({ color: text })
}

/**
 * Updates next button background and text color
 * @param  {string} bgColor
 * @param  {string} textColor
 */
function nextButtonColor(bgColor, textColor) {
  // used variables and short circuiting so I don't reassign the function parameters
  const bg = bgColor || 'initial'
  const text = textColor || 'initial'

  $('.next-button, .btn-primary').not('.submit-button').css({ 'background-color': bg })
  $('.next-button p, .btn-primary p').not('.submit-button p').css({ color: text })
}

// global function to be able to use any google font for testing on any site.
const changeFont = (font) => {
  let newFont = font || 'Roboto'
  if (newFont.includes(' ')) {
    newFont = newFont.replaceAll(' ', '+')
  }
  $('head').append(
    "<link href='https://fonts.googleapis.com/css?family=" + newFont + "' rel='stylesheet' type='text/css'>"
  )
  $('.headline').css('font-family', font)
  $('.question').css('font-family', font)
}

// if this param exists then add the value of the param to the top of the body on the right side.
if (getParameterByName('ap')) {
  let pn = getParameterByName('ap')
  let pnc = getParameterByName('apc')
  if (pn) {
    pn = pn.replace(/\D+/g, '')
    if (pn.length === 10) {
      pn = pn.replace(/[^0-9]+/g, '')
      const pnf = pn.replace(/^(?=[0-9]{10})([0-9]{3})([0-9]{3})([0-9]{4})$/, '$1-$2-$3')
      const ele = `<div id="add-phone" style="width: 100%; text-align: right; margin: 20px 0;"><a href="tel:1${pn}" style="color: ${
        pnc || 'inherit'
      }; padding-right: 20px;">${pnf}</a></div>`
      $('body').prepend(ele)
    } else {
      console.warn('param ap is not a valid phone number')
    }
  }
}

const stepVsBar = (() => {
  let executed = false
  return function () {
    if (!executed) {
      executed = true
      const fieldsets = $('#msform-mobile-auto-insurance fieldset')
      const followUpHtml = '<p class="question-label followUp">Follow up question</p>'
      let fsIds = []
      for (let i = 0; i < fieldsets.length; i++) {
        fsIds.push(fieldsets[i].id)
      }
      const followUpQuestions = [
        'vehicle2-year-auto',
        'vehicle2-make-auto',
        'vehicle2-model-auto',
        'home-insurance-auto-mobile',
        'property-type-auto-mobile',
        'year-built-mobile',
      ]
      const fsIdLength = fsIds.length + 1

      for (let j = 1; j < fsIds.length; j++) {
        const html = `<p class="question-label">Question <span class="stepNum">${
          j + 1
        }</span> of <span class="refiFieldTotal">${fsIdLength}</span></p>`
        const found = followUpQuestions.includes(fsIds[j])

        if (found) {
          $(`#msform-mobile-auto-insurance #${fsIds[j]} h4:first-of-type`).before(followUpHtml)
        } else {
          $(`#msform-mobile-auto-insurance #${fsIds[j]} h4:first-of-type`).before(html)
        }
      }

      $('.progressBar_control').remove()

      //event listener to HIDE the headline container after the first step
      window.addEventListener('stepChange', function (e) {
        let frameId = e.detail
        if (frameId.indexOf('vehicle-year-auto') !== -1) {
          $('.headline-container').hide()
        }
      })

      //event listener to SHOW the headline container when coming back to the first step
      window.addEventListener('stepBack', function (e) {
        let frameId = e.detail
        console.log('stepVsBar -> frameId', frameId)
        if (frameId.indexOf('intro-frame-mobile') !== -1) {
          $('.headline').show()
          $('.headline-container').show()
        }
      })
    }
  }
})()

// dynamically injects the costco question after the unemployment step
const costcoVWO = runOnce(function () {
  let followUp = ''
  const hasStepCount = $('p.followUp')
  if (hasStepCount.length > 0) {
    followUp = '<p class="question-label followUp">Follow up question</p>'
  }
  const refinance = `<fieldset class="card" id="costco-step-refinance" data-card="costco"><div class="inner-container">${followUp}<h4 class="question">Are you a Costco Member?</h4><div class="button-list vertical-list"> <input type="radio" id="costco-yes" name="HasCostco" value="1" /> <label for="costco-yes" class="radio-button selection-button yes-btn a-btn" ><p>Yes</p> </label> <input type="radio" id="costco-no-p" name="HasCostco" value="0" checked /> <label for="costco-no-p" class="radio-button selection-button vet_no no-btn b-btn" ><p>No</p> </label></div><div class="next-button-container remove-btn"> <button type="button" class="btn-primary next-button"><p>Next</p><div class="icon-container"><span class="icon-next-arrow"></span></div> </button> <br /> <button type="button" class="back-button">Back</button></div></div></fieldset>`
  const purchase = `<fieldset class="card" id="costco-step-purchase" data-card="costco"><div class="inner-container">${followUp}<h4 class="question">Are you a Costco Member?</h4><div class="button-list vertical-list"> <input type="radio" id="costco-yes-p" name="HasCostco" value="1" /> <label for="costco-yes-p" class="radio-button selection-button yes-btn a-btn" ><p>Yes</p> </label> <input type="radio" id="costco-no-p" name="HasCostco" value="0" checked /> <label for="costco-no-p" class="radio-button selection-button vet_no no-btn b-btn" ><p>No</p> </label></div><div class="next-button-container remove-btn"> <button type="button" class="btn-primary next-button"><p>Next</p><div class="icon-container"><span class="icon-next-arrow"></span></div> </button> <br /> <button type="button" class="back-button">Back</button></div></div></fieldset>`

  $('#unemployment-step-refinance').after(refinance)
  $('#unemployment-step-purchase').after(purchase)
  console.log('vwo triggered')
})

/*
 * basic controls module that will be loaded onto every survey, compiled directly prior to the custom.js overrides
 */

//handle touch event bubbling for the mobile device
function eventHandler(event, selector) {
  event.stopPropagation() // Stop event bubbling.
  event.preventDefault() // Prevent default behaviour
  if (event.type === 'touchend' || event.type === 'touchcancel') {
    selector.off('click')
  }
}

// Triggers a click of the next button when Enter is pressed
window.onkeypress = function (e) {
  var event = e || window.event
  var charCode = event.which || event.keyCode

  if (charCode == '13') {
    $('fieldset:visible').find('.btn-primary').trigger('click')
    return false
  }
}

//some touch enhancements
var dragging = false

$('body').on('touchstart', function () {
  dragging = false
})

$('body').on('touchmove', function () {
  dragging = true
})

// progress the user if they press the next button
$(document).on(
  'click touchend touchcancel',
  '.next-button',
  $.debounce(300, function (e) {
    e.preventDefault()

    if (dragging == true) {
      return
    }
    // advance to next fieldset
    switchFieldSets($(this))

    // focus first input and track page view
    next_fs.focusFirst()
  })
)
// progress the user if they change a dropdown only if it's the only dropdown on that step
function triggerSwitchFSonDropdown() {
  // FEDP-1611 - Temp until we want it on all sites
  $(document).on(
    'change',
    'select',
    $.debounce(300, function (e) {
      e.preventDefault()

      var visibleFieldsetLength = $('fieldset:visible').find('select').length

      if (dragging == true) {
        return
      }
      if (visibleFieldsetLength === 1) {
        // advance to next fieldset
        switchFieldSets($(this))

        // focus first input and track page view
        next_fs.focusFirst()
      }
    })
  )
}

// make them progress if they selected and item automatically, no next button needed
$(document).on(
  'click touchend touchcancel',
  '.selection-button',
  $.debounce(300, function (e) {
    e.preventDefault()

    if (dragging == true) {
      return
    }

    //assign correct radio checked
    var inputId = $(this).attr('for')
    $('#' + inputId).prop('checked', true)

    // advance to next fieldset
    switchFieldSets($(this))

    // focus first input and track page view
    next_fs.focusFirst()
  })
)

$('#VehicleMakeMobileCalled').on('change', function () {
  const vmake = $(this).val()
  $('#VehicleMakeMobile').val(vmake)

  // advance to next fieldset
  switchFieldSets($(this))
})

$('#VehicleMakeMobileCalled2').on('change', function () {
  const vmake = $(this).val()
  $('#VehicleMakeMobile2').val(vmake)

  // advance to next fieldset
  switchFieldSets($(this))
})
$('.makeButton-b').on(
  'click touchend touchcancel',
  $.debounce(300, function () {
    const vmake = $('.SelectedVehicleMake2:checked').val()
    $('#VehicleMakeMobile2').val(vmake)
  })
)
$('#VehicleMakeMobileCalled').on('change', function () {
  const vmake = $(this).val()
  $('#VehicleMakeMobile').val(vmake)

  // advance to next fieldset
  switchFieldSets($(this))

  // focus first input and track page view
  next_fs.focusFirst()
})

$('.makeButton').on(
  'click touchend touchcancel',
  $.debounce(300, function () {
    const vmake = $('.SelectedVehicleMake:checked').val()
    $('#VehicleMakeMobile').val(vmake)
  })
)

//what we instantiate when they press submit
$('.submit-button').on(
  'click touchend touchcancel',
  $.debounce(300, function (e) {
    e.preventDefault()

    $('.submit-button').addClass('dontHide')

    doPayable()
  })
)

/** parse out spaces from the email field **/
$('.email').on('keyup input', validateEmailClass)

/** parse out wacky stuff from name, city **/
$('.name').on('keyup input', validateName)

/** trims name on blur but allows users with two name names to still have a space  */
$('.name').on('blur', validateNameBlur)

/** live validation on address **/
$(document).on('keyup input', '.address', validateAddressClass)

/** live validation on city **/
$(document).on('keyup input', '.city, .property-city', validateCityClass)

/** live validation on zip  **/
$(document).on('keydown', '.zipcode, .property-zipcode', preventDecimal)

/** populate the refi_purpose field based on additional cash needed **/
$("[name='additional_cash_needed']").on('change', populateAdditionalCash)

/** phone validation */
$('.phone').on('blur', validatePhone)

/** zipcode validation & retrieve city / state */
$(document).on('input', '.zipcode', function () {
  if ($('#same-city').is(':checked')) {
    doZipCodeOperations(normalizeZip($(this)), false, false, true)
    return
  }
  doZipCodeOperations(normalizeZip($(this)), false, false, false)
})

$('.property-zipcode').on('input', function () {
  doZipCodeOperations(normalizeZip($(this)), true, false, false)
})

// this removes the first zipcode if the user fills out the final frame zip code
var removedInitialZip = false
$('.zipcode-second').on('keyup input', function () {
  if (removedInitialZip == true) {
    return
  }
  $('#zipcode-initial-refinance, #zipcode-initial-purchase').remove()
  removedInitialZip = true
})

// shows full address if user wants to update it
$(document).on('click touchend touchcancel', '.change-address', function (e) {
  e.preventDefault()
  $('.city-state-second').show()
  $('.address_string').hide()
})

// phone masking
$(document).on('keyup', '.phone, .phone_secondary', function (e) {
  // prevents users from submiting phone numbers of all the same digits
  var myPhone = $('.phone:visible, .phone_secondary:visible').val()
  var stripped = myPhone.replace(/[-() ]/g, '')
  if (stripped.length > 9) {
    var digits = ('' + stripped).split('')
    var realNumber = []
    for (var i = 0; i < digits.length; i++) {
      if (i === 0) {
        realNumber.push(digits[i])
      } else {
        if (digits[i] !== realNumber[0]) {
          realNumber.push(digits[i])
        }
      }
    }

    if (realNumber.length === 1) {
      alert('You must enter a valid phone number')
      $('.phone:visible, .phone_secondary:visible').val('')
    }
  }

  // prevents users from starting their phone number with a 1 or a 0
  if (this.value.charAt(0) === '0' || this.value.charAt(0) === '1') {
    this.value = this.value.slice(1)
  }

  var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
  e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
})

//function to hide the next buttons
;(function () {
  var hideNextButton = getParameterByName('hnb')
  if (hideNextButton == 1) {
    $('.remove-btn').hide()
    $('.remove-btn button').removeClass('btn-primary')
  }
})()


// Automate progress bar width based on length of fieldset in current_form.  Ignores this function if the progress-bars length is 0 or 1.
function progressWidths() {
  if ($('div').hasClass('progress-bar') && $('.progress-bar').length > 1) {
    var questionCount = $('#' + current_form.form_id + ' fieldset')
    var eachWidth = 100 / questionCount.length
    var last = questionCount[questionCount.length - 1]
    for (var i = 0; i < questionCount.length; i++) {
      try {
        $('#' + current_form.form_id + ' .progress-bar')[i].style.width = [i + 1] * eachWidth + '%'
      } catch (error) {
        console.log(error)
      }
    }
    $('#' + last.id + ' .progress-bar').css('width', '100%')
  }
}

// If equityAsAddlCash global variable is true and user selects VA as their current loan type, run equityAndAddlCash() function and pass in 1 for 100% equity
$('[name=current_loan_type]').on('click, change', function (e) {
  e.preventDefault()
  var loanTypeVal = this.value

  if (equityAsAddlCash) {
    if (loanTypeVal === 'VA' || loanTypeVal === 'va') {
      equityAndAddlCash(0.95)
    } else {
      equityAndAddlCash()
    }
  }
})

/**
 * Fast forwards the form to the appropriate step if prepop formData exits
 */
function fastForward() {
  try {
    const step = getCookie('step')
    const formData = JSON.parse(storage('local', 'get', 'formData'))
    const cleanData = dataCleanUp(formData)

    if (step && step !== null) {
      if (formData.loan_purpose === 'Refinance') {
        current_form = new FormObj($('#msform-refinance'))
        setTimeout(() => {
          prePopActions(cleanData)
        }, 500)
      } else if (formData.loan_purpose === 'Purchase') {
        current_form = new FormObj($('#msform-purchase'))
        setTimeout(() => {
          prePopActions(cleanData)
        }, 500)
      }
      noFireCakePixel = true
      window.ckm_request_id = formData.request_id

      const FFInput = $('#' + current_form.form_id + ' #' + step)
        .prev('fieldset')
        .find('div')

      $('#loading-gif .loading').hide()
      $('#loading-gif').show()

      setTimeout(() => {
        numOfFields = $('#' + current_form.form_id + ' fieldset').length - 1
        var fsNum = 0
        $('#' + current_form.form_id + ' fieldset').each(function () {
          $(this).data('pbWidth', fsNum)
          fsNum++
        })
        current_form.reset()
        window.replaceHash($('fieldset:visible').prop('id'))
        $('#' + current_fs.fs[0].id).hide()
        switchFieldSets(FFInput, '.card')
        $('#loading-gif').hide()
        $('#loading-gif .modal-header').text('We are currently matching you with our partners.')
        $('#loading-gif p').text('Loading your options')
      }, 1000)
    } else {
      return false
    }
  } catch (error) {
    stageLog(error)
  }
}

/**
 * Performs the profile build UX on form submit for LMB TCPA Only.
 * @param  {object} leadData
 * @param  {function} tyRedirect
 */
const buildProfile = (leadData, tyRedirect) => {
  submitFormData(leadData)
  const profileName = $('[name=first_name]').val() + ' ' + $('[name=last_name]').val(),
    profileAddress = $('[name=address]').val(),
    profileCity = $('[name=city]').val(),
    profileState = $('[name=state]').val(),
    shufflename = $('#profileName'),
    shuffleaddress = $('#profileAddress'),
    shufflecity = $('#profileCity'),
    shufflestate = $('#profileState')

  $('#preQualModal').show()
  setTimeout(() => {
    $('.lead-container').css('transform', 'scale(1)')
  }, 100)

  $('#profileName').text(profileName)
  $('#profileAddress').text(profileAddress)
  $('#profileCity').text(profileCity)
  $('#profileState').text(profileState)

  // Shuffle the contents of container
  setTimeout(() => {
    shufflename.shuffleLetters()
  }, 500)
  setTimeout(() => {
    shuffleaddress.removeClass('hidden').shuffleLetters()
  }, 1750)
  setTimeout(() => {
    shufflecity.removeClass('hidden').shuffleLetters()
  }, 3000)
  setTimeout(() => {
    shufflestate.removeClass('hidden').shuffleLetters()
  }, 4250)
  setTimeout(() => {
    tyRedirect()
  }, 5000)
  return
}

let placeSearch,
  gaMapsInstance = [],
  componentForm = {
    street_number: 'short_name',
    route: 'short_name',
    locality: 'long_name',
    sublocality_level_1: 'long_name',
    administrative_area_level_1: 'short_name',
    postal_code: 'short_name',
  },
  gaAuthFailure = false

function numCheck(val) {
  return Number.isInteger(val)
}

function gm_authFailure() {
  gaAuthFailure = true
  initAutocomplete()
}

function initAutocomplete() {
  // gets user address input DOM node array
  let formId = $('[id*="autocomplete-"]')

  // if the URL has this param it will turn off the Google Address functionality.
  if (getParameterByName('nga') === '1') {
    return
  }

  if (gaAuthFailure) {
    console.log('GAddress Auth Failure, rendering fallback')
    $('[name="address"]').attr('type', 'text').show()
    formId.remove()
  }

  // Create the autocomplete object, restricting the search to geographical location types.

  // loops through address DOM nodes and creates GA instance
  for (let i = 0; i < formId.length; i++) {
    // updates global gaMapsInstance with new GA instance
    gaMapsInstance[i] = new google.maps.places.Autocomplete(
      /** @type {!HTMLInputElement} */
      (document.getElementById(formId[i].id)),
      {
        types: ['address'],
        componentRestrictions: {
          country: 'us',
        },
      }
    )

    gaMapsInstance[i].setFields(['address_component'])
    gaMapsInstance[i].addListener('place_changed', () => {
      fillInAddress(formId[i].id, gaMapsInstance[i])
    })
  }
}

/*********Google address complete********/

/**
 * Gets address input id and GA instance for fillInAddress event listener
 * @param  {string} gaAddressInputId
 * @param  {object} gaInstance
 */
function fillInAddress(gaAddressInputId, gaInstance) {
  let place = gaInstance.getPlace(),
    gpPoppedAddress = document.getElementById(gaAddressInputId).value,
    gpAddressIsNumber = numCheck(parseInt(gpPoppedAddress.charAt(0)))

  // Get each component of the address from the place details
  // and fill the corresponding field on the form.

  try {
    if (place.address_components) {
      var stAdd = '',
        streetNumber = true
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0]
        if (componentForm[addressType]) {
          var val = place.address_components[i][componentForm[addressType]]

          switch (addressType) {
            case 'street_number':
              stAdd = val
              break
            case 'route':
              if (stAdd !== '') {
                stAdd += ' ' + val
              } else {
                if (gpAddressIsNumber) {
                  stAdd = gpPoppedAddress.split(',')[0]
                } else {
                  streetNumber = false
                }
              }
              break
            case 'locality':
              $('[name=city]').val(val)
              $('.city_span').text(val)
              $('.city-state-error').css('display', 'none')
              $('[name=city]').removeClass('border-error')
              break
            case 'sublocality_level_1':
              // if no locality and zippo died then try to use sublocality
              $('[name=city]').val(val)
              $('.city_span').text(val)
              $('.city-state-error').css('display', 'none')
              $('[name=city]').removeClass('border-error')
              break
            case 'administrative_area_level_1':
              $('[name=state]').val(val)
              $('.state_span').text(val)
              $('.city-state-error').css('display', 'none')
              $('[name=state]').removeClass('border-error')
              break
            case 'postal_code':
              $('[name=zipcode]').val(val)
              $('.zip_span').text(val)
              $('.zipcode-error-state').css('display', 'none')
              $('[name=zipcode]').removeClass('border-error')
              isZipValid = true
              $('.address_string').show()
              break
          }

          $('[name=address]').val(stAdd)
          document.getElementById(gaAddressInputId).value = stAdd
        }
      }

      if (!streetNumber) {
        $('#' + gaAddressInputId).addClass('border-error')
        $('.google-address').text('Please provide a street number').show()
        document.getElementById(gaAddressInputId).value = ''
      } else {
        $('#' + gaAddressInputId).removeClass('border-error')
        $('.google-address').text('Please fill out this field').hide()
        $('.city-state-second').hide()
      }
    } else {
      $('#' + gaAddressInputId).addClass('border-error')
      $('.google-address').text('Please select an address from the dropdown').show()
      document.getElementById(gaAddressInputId).value = ''
    }
  } catch (error) {
    console.log(error)
  }
}

// Bias the autocomplete object to the user's geographical location,
// as supplied by the browser's 'navigator.geolocation' object.

function geolocate() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      var geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      }
      var circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy,
      })
      gaMapsInstance.setBounds(circle.getBounds())
    })
  }
}

// data bind the autocomplete field with the address field
$('.address').on('keyup input', function (e) {
  e.preventDefault()
  var that = $(this).val()
  $('[name=address]').val(that)
})

/**
 * This wrapper is to instantiate certain required function and store some data when the document enters ready state
 */

// get UUID first thing
checkForUUID()

// global noNextButton set to false.  Set on most custom.js files to true.
var noNextButton = false

// global specialtyTY set to false. Will only be true on specialtyTY sites.
var specialtyTY = false

// validate zip
var isZipValid = false

// global variable for my100kquiz.com initially set to false;
var my100kPurchaseRedirect = false

// turn off handleDislosures to not write phone number
var noPhoneOnSite = false

// if true it will not fire the DCP/Organic Cake Pixel
var noFireCakePixel = false

// FEDP-1378 - used for err.enhanced.com
var uniqueSiteName = null

//do not run sidebar on stepChange
var sideBarPanel = false

//signifies a solar site
var isSolar = false

//signifies an insurance site
var isInsurance = false

//signifies an car insurance site
var isCarInsurance = false

//signifies an finance site
var isFinance = false

//signifies a homeservices site
var isHomeServices = false

//signifies a home alarm site
var isHomeAlarm = false

//signifies a medicare site
var isMedicare = false

//signifies a health insurance site
var isHealthInsurance = false

//prevent home rates from running
var homeRates = false

//initial reverse ltv for dropdowns
var reverseLTV = false

//sets initial ileads variable
var ileads = false

// sets initial rmpDCP variable
var rmpDCP = false

// sets initial sliders type to be empty for use w/ sliders and prepop
var slidersType = ''

// distinquishes this site from others
var callDotRMP = false

// for verify sites
var isVerify = false

// initial noDltv setting
var noDltv = false

// check DB for signup
var isGetLastSignUp = false

var showMissingQuestions = false //on verify will show questions that did not prepop
var refiOnly = false //only contains a refi form

// for use on single page sites
var noStoragePrepop = false

// conditional GTM containers
var gtmIframe
if (document.URL.indexOf('ratemarketplace') >= 0) {
  gtmIframe = 'GTM-W596MBX'
} else {
  gtmIframe = 'GTM-P62KC9K'
}

// load GTM container based on url param or just load our default container
document.getElementById('gtmIframe').innerHTML =
  '<!-- Google Tag Manager (noscript) --><noscript><iframe src="https://www.googletagmanager.com/ns.html?id=' +
  gtmIframe +
  '" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript> <!-- End Google Tag Manager (noscript) -->'

// adds alert exit intent on tab close or page reload. Only fires if the URL param exists.
if (getParameterByName('ei') === '1') {
  window.addEventListener('beforeunload', function (e) {
    e.preventDefault()
    e.returnValue = 'Are you sure you want to leave?'
  })
}

//grab the campaign, offer, and affiliate values and put into session storage and into the hidden inputs
//this needs review --erik: we are doing more work than needed assigning cake params and can concatenate some methods
$(document).ready(function () {
  var campaignId = getParameterByName('cpid'),
    offerId = getParameterByName('o'),
    affiliateId = getParameterByName('a'),
    subAffiliate = getParameterByName('s1'),
    subA2 = getParameterByName('s2'),
    subA3 = getParameterByName('s3'),
    subA4 = getParameterByName('s4'),
    subA5 = getParameterByName('s5'),
    trafficSource = getParameterByName('ts'),
    noPush = getParameterByName('np'),
    requestIdbyParam = getParameterByName('req_id'),
    hundredKHeadlineParam = getParameterByName('da'),
    equityAgeParam = getParameterByName('ea'),
    keyWordHeadline = getParameterByName('kw'),
    dynamicHeadline = getParameterByName('hd'),
    dynamicSubHeadline = getParameterByName('shd')

  if (offerId !== null && offerId !== undefined && offerId !== '') {
    storage('session', 'set', 'offerId', offerId)
    $('input[name="offer_id"]').val(offerId)
  }

  if (campaignId !== null && campaignId !== undefined && campaignId !== '') {
    storage('session', 'set', 'campaignId', campaignId)
  }

  if (affiliateId !== null && affiliateId !== undefined && affiliateId !== '') {
    storage('session', 'set', 'affiliateId', affiliateId)
    $('input[name="affiliate_id"]').val(affiliateId)
  } else {
    storage('session', 'set', 'affiliateId', $('input[name="affiliate_id"]').val())
  }
  if (subAffiliate !== null && subAffiliate !== undefined && subAffiliate !== '') {
    storage('session', 'set', 'subAffiliate', subAffiliate)
  }

  if (subA2 !== null && subA2 !== undefined && subA2 !== '') {
    storage('session', 'set', 's2', subA2)
  }
  if (subA3 !== null && subA3 !== undefined && subA3 !== '') {
    storage('session', 'set', 's3', subA3)
  }
  if (subA4 !== null && subA4 !== undefined && subA4 !== '') {
    storage('session', 'set', 's4', subA4)
  }
  if (subA5 !== null && subA5 !== undefined && subA5 !== '') {
    storage('session', 'set', 's5', subA5)
  }

  if (trafficSource) {
    storage('session', 'set', 'trafficSource', trafficSource)
  }

  if (noPush !== null && noPush !== undefined && noPush !== '') {
    storage('session', 'set', 'noPush', noPush)
  }

  if (requestIdbyParam !== null && requestIdbyParam !== undefined && requestIdbyParam !== '') {
    storage('session', 'set', 'request_id', requestIdbyParam)
    handleDisclosures()
  }

  if (storage('local', 'get', 'plp')) {
    storage('local', 'remove', 'plp')
  }

  // runs timetracker function passing start to capture doc load timestamp
  timeTracker.start()

  // run trusted form
  trustedForm()

  // sets timeStamp via localStorage to delete after 24hrs
  checkStorageTime()

  // have to wait a little bit to let fieldset DOM manipulation finish
  setTimeout(() => {
    prepopulateValues()
  }, 200)

  getUserIp()

  zetaRemove()

  // gets current lender list from api
  if (!callDotRMP && $('[name=current_lender]').length > 0) {
    doCurrentLenderLookup()
  }

  // this code removes the selection-button class from the sites that have the employment question
  //$('*[id*=self-e], *[id*=unemp]').next().removeClass('selection-button');

  //If param exists add show disclaimer button
  if (getParameterByName('dis') == '1') {
    addDisclosureButton()
  }

  //If param exists update headline value to param value and show headline
  if (hundredKHeadlineParam !== null && hundredKHeadlineParam !== undefined && hundredKHeadlineParam !== '') {
    hundredKHeadline(hundredKHeadlineParam)
  } else {
    $('#you-do-step-refinance .headline').css('visibility', 'visible')
  }

  // FEDP-1159: Dynamically update the property value and mortage amount defaults if the site is NOT a 100k site
  // Passing values as params in case we want to pass values via a url param etc in the future.
  /*     if (scData[0].siteVertical && scData[0].siteVertical !== '100k') {
        if (getParameterByName('est_property_value') === null && getParameterByName('mortgage_amount') === null) {
            // requires small timeout while other slider functions run
            setTimeout(function() {
                setLoanAmountandHomeValueDefaults(260000, 270000, 340000, 350000)
            }, 100)
        }
    } */

  // Updates the headline of all 100k sites based on an age param to reflect an age range and equity amount.
  try {
    if (scData[0].siteVertical && scData[0].siteVertical === '100k') {
      if (equityAgeParam !== null && equityAgeParam !== undefined && equityAgeParam !== '') {
        $('#you-do-step-refinance .subhead').css('visibility', 'hidden')
        equityAgeUpdate(equityAgeParam)
      }
    }
  } catch (error) {
    console.log(error)
  }

  // FEDP-1197 Adds dynamic headline based on "kw" URL Param above standard headline on va.hbs layout only
  if (keyWordHeadline !== null && keyWordHeadline !== undefined && keyWordHeadline !== '') {
    addGetKWHeadline(keyWordHeadline)
  }

  try {
    if (
      (scData[0].siteName && scData[0].siteName === '100kremodel.com') ||
      scData[0].siteName === '100kremodelquiz.com'
    ) {
      if (dynamicHeadline !== null && dynamicHeadline !== undefined && dynamicHeadline !== '') {
        dynamicHeadlines(dynamicHeadline)
      } else {
        $('#you-do-step-refinance .headline').css('visibility', 'visible')
      }

      if (dynamicSubHeadline !== null && dynamicSubHeadline !== undefined && dynamicSubHeadline !== '') {
        dynamicSubheadlines(dynamicSubHeadline, hundredKHeadlineParam)
      } else {
        $('#you-do-step-refinance .subhead').css('visibility', 'visible')
      }
    } else {
      $('#you-do-step-refinance .subhead').css('visibility', 'visible')
    }
  } catch (error) {
    console.log(error)
  }
})

var current_fs, next_fs, previous_fs //fieldsets
var current_form = new FormObj($('.msform-refinance'))
var zip_container = $('.button-list')
var stepNumber = 2

var orgCakePix = 'https://suited45trk.com/?oex3=FAd6X3q4l%2f21MgL3t5iqTA%3d%3d&cp=js&s1=SUB_ID'

function doControlsAndValidatons() {
  // make it easy to separate out the paths as two separate question sets and support custom intro frame
  // put them on the refinance path
  $('label[for=\'refi-button\']').on(
    'click touchend touchcancel',
    $.debounce(300, function(e) {
      current_form = new FormObj($('.msform-refinance'))
      current_form.reset()
      numOfFields = $('.msform-refinance fieldset').length + 1
      $('#msform-refinance fieldset').each(function(index) {
        $(this)
          .find('.fieldNum')
          .text(index + 2)
      })
      $('#refiLP').val('Refinance')
      $('#path_choice').hide()
      $('.form-container').show()
      window.replaceHash($('fieldset:visible').prop('id'))
      $('.fieldTotal').text(numOfFields)
    })
  )

  //put them on the purchase path
  $('label[for=\'purchase-button\']').on(
    'click touchend touchcancel',
    $.debounce(300, function(e) {
      current_form = new FormObj($('.msform-purchase'))
      current_form.reset()
      numOfFields = $('.msform-purchase fieldset').length
      $('#msform-purchase fieldset').each(function(index) {
        $(this)
          .find('.fieldNum')
          .text(index + 2)
      })
      $('#purchaseLP').val('Purchase')
      $('#path_choice').hide()
      $('.form-container').show()
      window.replaceHash($('fieldset:visible').prop('id'))
      $('.fieldTotal').text(numOfFields)
    })
  )
  $('label[for=\'military-yes\']').on(
    'click touchend touchcancel',
    $.debounce(300, function(e) {
      $('input[name="opt_served_military"').each(function() {
        $(this).val(1)
      })
    })
  )
  $('label[for=\'military-no\']').on(
    'click touchend touchcancel',
    $.debounce(300, function(e) {
      $('input[name="opt_served_military"').each(function() {
        $(this).val(0)
      })
    })
  )

  $('.controlBtn').on(
    'click touchend touchcancel',
    $.debounce(300, function(e) {
      $('.header-container h2').addClass('mobile-small')
    })
  )

  $('.btn-military').on(
    'click touchend touchcancel',
    $.debounce(300, function(e) {
      $('.lander').hide()
      $('#path_choice').fadeIn()
    })
  )

  /**
     * Use the custom reverseLTVSliders
     */

  reverseLTVSliders()

  ///////////////////////////////////////////////////////////////VALIDATIONS SECTION////////////////////////////////////////////////////////////////

  $('#additional_cash_needed').on('change', function(e) {
    e.preventDefault()
    if ($(this).val() == '5000') {
      $('#refi_purpose').val('Cash Out')
    } else {
      $('#refi_purpose').val('Lower Payments')
    }
  })

  ////////////////// End Verify Functions ///////////////////////

  runBackButtonLogic()

  window.addEventListener('stepChange', function(e) {
    changeStepNumber('forward')
  })
  window.addEventListener('stepBack', function(e) {
    changeStepNumber('back')
  })
  changeStepNumber = function(direction) {
    if (direction == 'forward') {
      if ($('#zipcode2-step-purchase').is(':visible')) {
        // eslint-disable-next-line
                stepNumber = stepNumber
        $('.stepNum').text(stepNumber + '.5')
      } else {
        stepNumber = stepNumber + 1
        $('.stepNum').text(stepNumber)
      }
    } else if (direction == 'back') {
      stepNumber = stepNumber - 1
      $('.stepNum').text(stepNumber)
    }
  }
}

doControlsAndValidatons()

$(document).ready(function() {
  getCakeOrganic(orgCakePix)
})
